import _toConsumableArray from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _assertThisInitialized from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _slicedToArray from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as require$$0 from 'react';
import require$$0__default, { createContext, useContext, memo, useState, useRef, useEffect, PureComponent, createRef, useMemo, Children, isValidElement, cloneElement } from 'react';
import * as ReactDOM from 'react-dom';
import { createPortal } from 'react-dom';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var jsxRuntime = {
  exports: {}
};
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = require$$0__default,
      k = Symbol.for("react.element"),
      l = Symbol.for("react.fragment"),
      m = Object.prototype.hasOwnProperty,
      n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
      p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function q(c, a, g) {
    var b,
        d = {},
        e = null,
        h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);

    for (b in a) {
      m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    }

    if (c && c.defaultProps) for (b in a = c.defaultProps, a) {
      void 0 === d[b] && (d[b] = a[b]);
    }
    return {
      $$typeof: k,
      type: c,
      key: e,
      ref: h,
      props: d,
      _owner: n.current
    };
  }

  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;

  if (process.env.NODE_ENV !== "production") {
    (function () {
      var React = require$$0__default; // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types.

      var REACT_ELEMENT_TYPE = Symbol.for('react.element');
      var REACT_PORTAL_TYPE = Symbol.for('react.portal');
      var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
      var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
      var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
      var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
      var REACT_CONTEXT_TYPE = Symbol.for('react.context');
      var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
      var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
      var REACT_MEMO_TYPE = Symbol.for('react.memo');
      var REACT_LAZY_TYPE = Symbol.for('react.lazy');
      var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';

      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }

        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }

        return null;
      }

      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            printWarning('error', format, args);
          }
        }
      }

      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();

          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          } // eslint-disable-next-line react-internal/safe-string-coercion


          var argsWithFormat = args.map(function (item) {
            return String(item);
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      } // -----------------------------------------------------------------------------


      var enableScopeAPI = false; // Experimental Create Event Handle API.

      var enableCacheElement = false;
      var enableTransitionTracing = false; // No known bugs, but needs performance testing

      var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
      // stuff. Intended to enable React core members to more easily debug scheduling
      // issues in DEV builds.

      var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

      var REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');

      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }

        if (typeof type === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
            return true;
          }
        }

        return false;
      }

      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;

        if (displayName) {
          return displayName;
        }

        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
      } // Keep in sync with react-reconciler/getComponentNameFromFiber


      function getContextName(type) {
        return type.displayName || 'Context';
      } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


      function getComponentNameFromType(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null;
        }

        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }

        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }

        if (typeof type === 'string') {
          return type;
        }

        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return 'Fragment';

          case REACT_PORTAL_TYPE:
            return 'Portal';

          case REACT_PROFILER_TYPE:
            return 'Profiler';

          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';

          case REACT_SUSPENSE_TYPE:
            return 'Suspense';

          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + '.Consumer';

            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + '.Provider';

            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');

            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;

              if (outerName !== null) {
                return outerName;
              }

              return getComponentNameFromType(type.type) || 'Memo';

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return getComponentNameFromType(init(payload));
                } catch (x) {
                  return null;
                }
              }
            // eslint-disable-next-line no-fallthrough
          }
        }

        return null;
      }

      var assign = Object.assign; // Helpers to patch console.logs to avoid logging during side-effect free
      // replaying on render function. This currently only patches the object
      // lazily which won't cover if the log function was extracted eagerly.
      // We could also eagerly patch the method.

      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;

      function disabledLog() {}

      disabledLog.__reactDisabledLog = true;

      function disableLogs() {
        {
          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
            /* eslint-enable react-internal/no-production-logging */
          }

          disabledDepth++;
        }
      }

      function reenableLogs() {
        {
          disabledDepth--;

          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
            /* eslint-enable react-internal/no-production-logging */
          }

          if (disabledDepth < 0) {
            error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
          }
        }
      }

      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;

      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === undefined) {
            // Extract the VM specific prefix used by each line.
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || '';
            }
          } // We use the prefix to ensure our stacks line up with native stack frames.


          return '\n' + prefix + name;
        }
      }

      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }

      function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) {
          return '';
        }

        {
          var frame = componentFrameCache.get(fn);

          if (frame !== undefined) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
          // for warnings.

          ReactCurrentDispatcher.current = null;
          disableLogs();
        }

        try {
          // This should throw.
          if (construct) {
            // Something should be setting the props in the constructor.
            var Fake = function Fake() {
              throw Error();
            }; // $FlowFixMe


            Object.defineProperty(Fake.prototype, 'props', {
              set: function set() {
                // We use a throwing setter instead of frozen or non-writable props
                // because that won't throw in a non-strict mode function.
                throw Error();
              }
            });

            if (typeof Reflect === 'object' && Reflect.construct) {
              // We construct a different control for this case to include any extra
              // frames added by the construct call.
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }

              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }

              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }

            fn();
          }
        } catch (sample) {
          // This is inlined manually because closure doesn't do it for us.
          if (sample && control && typeof sample.stack === 'string') {
            // This extracts the first frame from the sample that isn't also in the control.
            // Skipping one frame that we assume is the frame that calls the two.
            var sampleLines = sample.stack.split('\n');
            var controlLines = control.stack.split('\n');
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;

            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              // We expect at least one stack frame to be shared.
              // Typically this will be the root most one. However, stack frames may be
              // cut off due to maximum stack limits. In this case, one maybe cut off
              // earlier than the other. We assume that the sample is longer or the same
              // and there for cut off earlier. So we should find the root most frame in
              // the sample somewhere in the control.
              c--;
            }

            for (; s >= 1 && c >= 0; s--, c--) {
              // Next we find the first one that isn't the same which should be the
              // frame that called our sample function and the control.
              if (sampleLines[s] !== controlLines[c]) {
                // In V8, the first line is describing the message but other VMs don't.
                // If we're about to return the first line, and the control is also on the same
                // line, that's a pretty good indicator that our sample threw at same line as
                // the control. I.e. before we entered the sample frame. So we ignore this result.
                // This can happen if you passed a class to function component, or non-function.
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--; // We may still have similar intermediate frames from the construct call.
                    // The next one that isn't the same should be our match though.

                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                      var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                      // but we have a user-provided "displayName"
                      // splice it in to make the stack more readable.


                      if (fn.displayName && _frame.includes('<anonymous>')) {
                        _frame = _frame.replace('<anonymous>', fn.displayName);
                      }

                      {
                        if (typeof fn === 'function') {
                          componentFrameCache.set(fn, _frame);
                        }
                      } // Return the line we found.

                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }

                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.


        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        {
          if (typeof fn === 'function') {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }

      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }

      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return '';
        }

        if (typeof type === 'function') {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }

        if (typeof type === 'string') {
          return describeBuiltInComponentFrame(type);
        }

        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame('Suspense');

          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame('SuspenseList');
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);

            case REACT_MEMO_TYPE:
              // Memo may contain any component type so we recursively resolve it.
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  // Lazy may contain any component type so we recursively resolve it.
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
              }
          }
        }

        return '';
      }

      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }

      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          // $FlowFixMe This is okay but Flow doesn't know it.
          var has = Function.call.bind(hasOwnProperty);

          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
              // fail the render phase where it didn't fail before. So we log it.
              // After these have been cleaned up, we'll let them throw.

              try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                  // eslint-disable-next-line react-internal/prod-error-codes
                  var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                  err.name = 'Invariant Violation';
                  throw err;
                }

                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
              } catch (ex) {
                error$1 = ex;
              }

              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }

              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }

      var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

      function isArray(a) {
        return isArrayImpl(a);
      }
      /*
       * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
       * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
       *
       * The functions in this module will throw an easier-to-understand,
       * easier-to-debug exception with a clear errors message message explaining the
       * problem. (Instead of a confusing exception thrown inside the implementation
       * of the `value` object).
       */
      // $FlowFixMe only called in DEV, so void return is not possible.


      function typeName(value) {
        {
          // toStringTag is needed for namespaced types like Temporal.Instant
          var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
          return type;
        }
      } // $FlowFixMe only called in DEV, so void return is not possible.


      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }

      function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
      }

      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
          }
        }
      }

      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }

      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== undefined;
      }

      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== undefined;
      }

      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }

      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function warnAboutAccessingKey() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };

          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }

      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function warnAboutAccessingRef() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };

          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      /**
       * Factory method to create a new React element. This no longer adheres to
       * the class pattern, so do not use new to call it. Also, instanceof check
       * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
       * if something is a React Element.
       *
       * @param {*} type
       * @param {*} props
       * @param {*} key
       * @param {string|object} ref
       * @param {*} owner
       * @param {*} self A *temporary* helper to detect places where `this` is
       * different from the `owner` when React.createElement is called, so that we
       * can warn. We want to get rid of owner and replace string `ref`s with arrow
       * functions, and as long as `this` and owner are the same, there will be no
       * change in behavior.
       * @param {*} source An annotation object (added by a transpiler or otherwise)
       * indicating filename, line number, and/or other information.
       * @internal
       */


      var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type: type,
          key: key,
          ref: ref,
          props: props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          // The validation flag is currently mutative. We put it on
          // an external backing store so that we can freeze the whole object.
          // This can be replaced with a WeakMap once they are implemented in
          // commonly used development environments.
          element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
          // the validation flag non-enumerable (where possible, which should
          // include every environment we run tests in), so the test framework
          // ignores it.

          Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          }); // self and source are DEV only properties.

          Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          }); // Two elements created in two different places should be considered
          // equal for testing purposes and therefore we hide it from enumeration.

          Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });

          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      /**
       * https://github.com/reactjs/rfcs/pull/107
       * @param {*} type
       * @param {object} props
       * @param {string} key
       */


      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName; // Reserved names are extracted

          var props = {};
          var key = null;
          var ref = null; // Currently, key can be spread in as a prop. This causes a potential
          // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
          // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
          // but as an intermediary step, we will use jsxDEV for everything except
          // <div {...props} key="Hi" />, because we aren't currently able to tell if
          // key is explicitly declared to be undefined or not.

          if (maybeKey !== undefined) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = '' + maybeKey;
          }

          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = '' + config.key;
          }

          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          } // Remaining properties are added to a new props object


          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          } // Resolve default props


          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;

            for (propName in defaultProps) {
              if (props[propName] === undefined) {
                props[propName] = defaultProps[propName];
              }
            }
          }

          if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }

            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }

          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }

      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }

      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      /**
       * Verifies the object is a ReactElement.
       * See https://reactjs.org/docs/react-api.html#isvalidelement
       * @param {?object} object
       * @return {boolean} True if `object` is a ReactElement.
       * @final
       */

      function isValidElement(object) {
        {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }

      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

            if (name) {
              return '\n\nCheck the render method of `' + name + '`.';
            }
          }

          return '';
        }
      }

      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
          }

          return '';
        }
      }
      /**
       * Warn if there's no key explicitly set on dynamic arrays of children or
       * object keys are not valid. This allows us to keep track of children between
       * updates.
       */


      var ownerHasKeyUseWarning = {};

      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();

          if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }

          return info;
        }
      }
      /**
       * Warn if the element doesn't have an explicit key assigned to it.
       * This element is in an array. The array could grow and shrink or be
       * reordered. All children that haven't already been validated are required to
       * have a "key" property assigned to it. Error statuses are cached so a warning
       * will only be shown once.
       *
       * @internal
       * @param {ReactElement} element Element that requires a key.
       * @param {*} parentType element's parent's type.
       */


      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }

          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }

          ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
          // property, it may be the creator of the child that's responsible for
          // assigning it a key.

          var childOwner = '';

          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            // Give the component that originally created this child.
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }

          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      /**
       * Ensure that every element either is passed in a static location, in an
       * array with an explicit keys property defined, or in an object literal
       * with valid key property.
       *
       * @internal
       * @param {ReactNode} node Statically passed child of any type.
       * @param {*} parentType node's parent's type.
       */


      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== 'object') {
            return;
          }

          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];

              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            // This element was passed in a valid location.
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);

            if (typeof iteratorFn === 'function') {
              // Entry iterators used to provide implicit keys,
              // but now we print a separate warning for them later.
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;

                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      /**
       * Given an element, validate that its props follow the propTypes definition,
       * provided by the type.
       *
       * @param {ReactElement} element
       */


      function validatePropTypes(element) {
        {
          var type = element.type;

          if (type === null || type === undefined || typeof type === 'string') {
            return;
          }

          var propTypes;

          if (typeof type === 'function') {
            propTypes = type.propTypes;
          } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }

          if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
          } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

            var _name = getComponentNameFromType(type);

            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
          }

          if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
          }
        }
      }
      /**
       * Given a fragment, validate that it can only be provided with fragment props
       * @param {ReactElement} fragment
       */


      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);

          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];

            if (key !== 'children' && key !== 'key') {
              setCurrentlyValidatingElement$1(fragment);
              error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }

          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
          }
        }
      }

      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
          // succeed and there will likely be errors in render.

          if (!validType) {
            var info = '';

            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
              info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
            }

            var sourceInfo = getSourceInfoErrorAddendum(source);

            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }

            var typeString;

            if (type === null) {
              typeString = 'null';
            } else if (isArray(type)) {
              typeString = 'array';
            } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
              info = ' Did you accidentally export a JSX literal instead of a component?';
            } else {
              typeString = typeof type;
            }

            error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
          }

          var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
          // TODO: Drop this when these are no longer allowed as the type argument.

          if (element == null) {
            return element;
          } // Skip key warning if the type isn't valid since our key validation logic
          // doesn't expect a non-string/function type and can throw confusing errors.
          // We don't want exception behavior to differ between dev and prod.
          // (Rendering will throw with a helpful message and as soon as the type is
          // fixed, the key warnings will appear.)


          if (validType) {
            var children = props.children;

            if (children !== undefined) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }

                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }

          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }

          return element;
        }
      } // These two functions exist to still get child warnings in dev
      // even with the prod transform. This means that jsxDEV is purely
      // opt-in behavior for better messages but that we won't stop
      // giving you warnings if you use production apis.


      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }

      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }

      var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
      // for now we can ship identical prod functions

      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }

  return reactJsxRuntime_development;
}

(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = requireReactJsxRuntime_production_min();
  } else {
    module.exports = requireReactJsxRuntime_development();
  }
})(jsxRuntime);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */


var NODE_ENV = process.env.NODE_ENV;

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
};

var invariant_1 = invariant;
var MapContext = createContext(null);

function useGoogleMap() {
  invariant_1(!!useContext, 'useGoogleMap is React hook and requires React version 16.8+');
  var map = useContext(MapContext);
  invariant_1(!!map, 'useGoogleMap needs a GoogleMap available up in the tree');
  return map;
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function reduce(obj, fn, acc) {
  return Object.keys(obj).reduce(function reducer(newAcc, key) {
    return fn(newAcc, obj[key], key);
  }, acc);
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function forEach(obj, fn) {
  Object.keys(obj).forEach(function (key) {
    return fn(obj[key], key);
  });
}
/* global google */


function applyUpdaterToNextProps( // eslint-disable-next-line @typescript-eslint/no-explicit-any
updaterMap, // eslint-disable-next-line @typescript-eslint/no-explicit-any
prevProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
nextProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
instance // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var map = {}; // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var iter = function iter(fn, key) {
    var nextValue = nextProps[key];

    if (nextValue !== prevProps[key]) {
      map[key] = nextValue;
      fn(instance, nextValue);
    }
  };

  forEach(updaterMap, iter);
  return map;
}

function registerEvents( // eslint-disable-next-line @typescript-eslint/no-explicit-any
props, // eslint-disable-next-line @typescript-eslint/no-explicit-any
instance, eventMap) {
  var registeredList = reduce(eventMap, function reducer(acc, googleEventName, // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onEventName) {
    if (typeof props[onEventName] === 'function') {
      acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
    }

    return acc;
  }, []);
  return registeredList;
}

function unregisterEvent(registered) {
  google.maps.event.removeListener(registered);
}

function unregisterEvents() {
  var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  events.forEach(unregisterEvent);
}

function applyUpdatersToPropsAndRegisterEvents(_ref) {
  var updaterMap = _ref.updaterMap,
      eventMap = _ref.eventMap,
      prevProps = _ref.prevProps,
      nextProps = _ref.nextProps,
      instance = _ref.instance;
  var registeredEvents = registerEvents(nextProps, instance, eventMap);
  applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance);
  return registeredEvents;
}

var eventMap$i = {
  onDblClick: 'dblclick',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMapTypeIdChanged: 'maptypeid_changed',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseDown: 'mousedown',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick',
  onTilesLoaded: 'tilesloaded',
  onBoundsChanged: 'bounds_changed',
  onCenterChanged: 'center_changed',
  onClick: 'click',
  onDrag: 'drag',
  onHeadingChanged: 'heading_changed',
  onIdle: 'idle',
  onProjectionChanged: 'projection_changed',
  onResize: 'resize',
  onTiltChanged: 'tilt_changed',
  onZoomChanged: 'zoom_changed'
};
var updaterMap$i = {
  extraMapTypes: function extraMapTypes(map, extra) {
    extra.forEach(function forEachExtra(it, i) {
      map.mapTypes.set(String(i), it);
    });
  },
  center: function center(map, _center) {
    map.setCenter(_center);
  },
  clickableIcons: function clickableIcons(map, clickable) {
    map.setClickableIcons(clickable);
  },
  heading: function heading(map, _heading) {
    map.setHeading(_heading);
  },
  mapTypeId: function mapTypeId(map, _mapTypeId) {
    map.setMapTypeId(_mapTypeId);
  },
  options: function options(map, _options) {
    map.setOptions(_options);
  },
  streetView: function streetView(map, _streetView) {
    map.setStreetView(_streetView);
  },
  tilt: function tilt(map, _tilt) {
    map.setTilt(_tilt);
  },
  zoom: function zoom(map, _zoom) {
    map.setZoom(_zoom);
  }
}; // TODO: unfinished!

function GoogleMapFunctional(_ref2) {
  var children = _ref2.children,
      options = _ref2.options,
      id = _ref2.id,
      mapContainerStyle = _ref2.mapContainerStyle,
      mapContainerClassName = _ref2.mapContainerClassName,
      center = _ref2.center,
      onClick = _ref2.onClick,
      onDblClick = _ref2.onDblClick,
      onDrag = _ref2.onDrag,
      onDragEnd = _ref2.onDragEnd,
      onDragStart = _ref2.onDragStart,
      onMouseMove = _ref2.onMouseMove,
      onMouseOut = _ref2.onMouseOut,
      onMouseOver = _ref2.onMouseOver,
      onMouseDown = _ref2.onMouseDown,
      onMouseUp = _ref2.onMouseUp,
      onRightClick = _ref2.onRightClick,
      onCenterChanged = _ref2.onCenterChanged,
      onLoad = _ref2.onLoad,
      onUnmount = _ref2.onUnmount;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      map = _useState2[0],
      setMap = _useState2[1];

  var ref = useRef(null); // const [extraMapTypesListener, setExtraMapTypesListener] = useState<google.maps.MapsEventListener | null>(null)

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      centerChangedListener = _useState4[0],
      setCenterChangedListener = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      dblclickListener = _useState6[0],
      setDblclickListener = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      dragendListener = _useState8[0],
      setDragendListener = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      dragstartListener = _useState10[0],
      setDragstartListener = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      mousedownListener = _useState12[0],
      setMousedownListener = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      mousemoveListener = _useState14[0],
      setMousemoveListener = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      mouseoutListener = _useState16[0],
      setMouseoutListener = _useState16[1];

  var _useState17 = useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      mouseoverListener = _useState18[0],
      setMouseoverListener = _useState18[1];

  var _useState19 = useState(null),
      _useState20 = _slicedToArray(_useState19, 2),
      mouseupListener = _useState20[0],
      setMouseupListener = _useState20[1];

  var _useState21 = useState(null),
      _useState22 = _slicedToArray(_useState21, 2),
      rightclickListener = _useState22[0],
      setRightclickListener = _useState22[1];

  var _useState23 = useState(null),
      _useState24 = _slicedToArray(_useState23, 2),
      clickListener = _useState24[0],
      setClickListener = _useState24[1];

  var _useState25 = useState(null),
      _useState26 = _slicedToArray(_useState25, 2),
      dragListener = _useState26[0],
      setDragListener = _useState26[1]; // Order does matter


  useEffect(function () {
    if (options && map !== null) {
      map.setOptions(options);
    }
  }, [map, options]);
  useEffect(function () {
    if (map !== null && typeof center !== 'undefined') {
      map.setCenter(center);
    }
  }, [map, center]);
  useEffect(function () {
    if (map && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(map, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  useEffect(function () {
    if (map && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      setDragendListener(google.maps.event.addListener(map, 'dragend', onDragEnd));
    }
  }, [onDblClick]);
  useEffect(function () {
    if (map && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      setDragstartListener(google.maps.event.addListener(map, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  useEffect(function () {
    if (map && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(map, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  useEffect(function () {
    if (map && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      setMousemoveListener(google.maps.event.addListener(map, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  useEffect(function () {
    if (map && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(map, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  useEffect(function () {
    if (map && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(map, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  useEffect(function () {
    if (map && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(map, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  useEffect(function () {
    if (map && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(map, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  useEffect(function () {
    if (map && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(map, 'click', onClick));
    }
  }, [onClick]);
  useEffect(function () {
    if (map && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      setDragListener(google.maps.event.addListener(map, 'drag', onDrag));
    }
  }, [onDrag]);
  useEffect(function () {
    if (map && onCenterChanged) {
      if (centerChangedListener !== null) {
        google.maps.event.removeListener(centerChangedListener);
      }

      setCenterChangedListener(google.maps.event.addListener(map, 'center_changed', onCenterChanged));
    }
  }, [onClick]);
  useEffect(function () {
    var map = ref.current === null ? null : new google.maps.Map(ref.current, options);
    setMap(map);

    if (map !== null && onLoad) {
      onLoad(map);
    }

    return function () {
      if (map !== null) {
        if (onUnmount) {
          onUnmount(map);
        }
      }
    };
  }, []);
  return jsxRuntime.exports.jsx("div", Object.assign({
    id: id,
    ref: ref,
    style: mapContainerStyle,
    className: mapContainerClassName
  }, {
    children: jsxRuntime.exports.jsx(MapContext.Provider, Object.assign({
      value: map
    }, {
      children: map !== null ? children : jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {})
    }))
  }));
}

memo(GoogleMapFunctional);

var GoogleMap = /*#__PURE__*/function (_PureComponent) {
  _inherits(GoogleMap, _PureComponent);

  function GoogleMap() {
    var _this2;

    _classCallCheck(this, GoogleMap);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(GoogleMap).apply(this, arguments));
    _this2.state = {
      map: null
    };
    _this2.registeredEvents = [];
    _this2.mapRef = null;

    _this2.getInstance = function () {
      if (_this2.mapRef === null) {
        return null;
      }

      return new google.maps.Map(_this2.mapRef, _this2.props.options);
    };

    _this2.panTo = function (latLng) {
      var map = _this2.getInstance();

      if (map) {
        map.panTo(latLng);
      }
    };

    _this2.setMapCallback = function () {
      if (_this2.state.map !== null) {
        if (_this2.props.onLoad) {
          _this2.props.onLoad(_this2.state.map);
        }
      }
    };

    _this2.getRef = function (ref) {
      _this2.mapRef = ref;
    };

    return _this2;
  }

  _createClass(GoogleMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var map = this.getInstance();
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$i,
        eventMap: eventMap$i,
        prevProps: {},
        nextProps: this.props,
        instance: map
      });
      this.setState(function setMap() {
        return {
          map: map
        };
      }, this.setMapCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.map !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$i,
          eventMap: eventMap$i,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.map
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.map !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.map);
        }

        unregisterEvents(this.registeredEvents);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsx("div", Object.assign({
        id: this.props.id,
        ref: this.getRef,
        style: this.props.mapContainerStyle,
        className: this.props.mapContainerClassName
      }, {
        children: jsxRuntime.exports.jsx(MapContext.Provider, Object.assign({
          value: this.state.map
        }, {
          children: this.state.map !== null ? this.props.children : jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {})
        }))
      }));
    }
  }]);

  return GoogleMap;
}(PureComponent);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function __rest$1(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

var isBrowser = typeof document !== 'undefined';

function injectScript(_ref3) {
  var url = _ref3.url,
      id = _ref3.id,
      nonce = _ref3.nonce;

  if (!isBrowser) {
    return Promise.reject(new Error('document is undefined'));
  }

  return new Promise(function injectScriptCallback(resolve, reject) {
    var existingScript = document.getElementById(id);
    var windowWithGoogleMap = window;

    if (existingScript) {
      // Same script id/url: keep same script
      var dataStateAttribute = existingScript.getAttribute('data-state');

      if (existingScript.src === url && dataStateAttribute !== 'error') {
        if (dataStateAttribute === 'ready') {
          return resolve(id);
        } else {
          var originalInitMap = windowWithGoogleMap.initMap;
          var originalErrorCallback = existingScript.onerror;

          windowWithGoogleMap.initMap = function initMap() {
            if (originalInitMap) {
              originalInitMap();
            }

            resolve(id);
          };

          existingScript.onerror = function (err) {
            if (originalErrorCallback) {
              originalErrorCallback(err);
            }

            reject(err);
          };

          return;
        }
      } // Same script id, but either
      // 1. requested URL is different
      // 2. script failed to load
      else {
        existingScript.remove();
      }
    }

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.id = id;
    script.async = true;
    script.nonce = nonce;

    script.onerror = function onerror(err) {
      script.setAttribute('data-state', 'error');
      reject(err);
    };

    windowWithGoogleMap.initMap = function onload() {
      script.setAttribute('data-state', 'ready');
      resolve(id);
    };

    document.head.appendChild(script);
  }).catch(function (err) {
    console.error('injectScript error: ', err);
    throw err;
  });
}

function isGoogleFontStyle(element) {
  // 'Roboto' or 'Google Sans Text' font download
  var href = element.href;

  if (href && (href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0 || href.indexOf('https://fonts.googleapis.com/css?family=Google+Sans+Text') === 0)) {
    return true;
  } // font style elements


  if (element.tagName.toLowerCase() === 'style' && // @ts-ignore
  element.styleSheet && // @ts-ignore
  element.styleSheet.cssText && // @ts-ignore
  element.styleSheet.cssText.replace('\r\n', '').indexOf('.gm-style') === 0) {
    // @ts-ignore
    element.styleSheet.cssText = '';
    return true;
  } // font style elements for other browsers


  if (element.tagName.toLowerCase() === 'style' && element.innerHTML && element.innerHTML.replace('\r\n', '').indexOf('.gm-style') === 0) {
    element.innerHTML = '';
    return true;
  } // when google tries to add empty style


  if (element.tagName.toLowerCase() === 'style' && // @ts-ignore
  !element.styleSheet && !element.innerHTML) {
    return true;
  }

  return false;
} // Preventing the Google Maps library from downloading an extra font


function preventGoogleFonts() {
  // we override these methods only for one particular head element
  // default methods for other elements are not affected
  var head = document.getElementsByTagName('head')[0];
  var trueInsertBefore = head.insertBefore.bind(head); // TODO: adding return before reflect solves the TS issue
  // @ts-ignore

  head.insertBefore = function insertBefore(newElement, referenceElement) {
    if (!isGoogleFontStyle(newElement)) {
      Reflect.apply(trueInsertBefore, head, [newElement, referenceElement]);
    }
  };

  var trueAppend = head.appendChild.bind(head); // TODO: adding return before reflect solves the TS issue
  // @ts-ignore

  head.appendChild = function appendChild(textNode) {
    if (!isGoogleFontStyle(textNode)) {
      Reflect.apply(trueAppend, head, [textNode]);
    }
  };
}

function makeLoadScriptUrl(_ref4) {
  var googleMapsApiKey = _ref4.googleMapsApiKey,
      googleMapsClientId = _ref4.googleMapsClientId,
      _ref4$version = _ref4.version,
      version = _ref4$version === void 0 ? 'weekly' : _ref4$version,
      language = _ref4.language,
      region = _ref4.region,
      libraries = _ref4.libraries,
      channel = _ref4.channel,
      mapIds = _ref4.mapIds;
  var params = [];
  invariant_1(googleMapsApiKey && googleMapsClientId || !(googleMapsApiKey && googleMapsClientId), 'You need to specify either googleMapsApiKey or googleMapsClientId for @react-google-maps/api load script to work. You cannot use both at the same time.');

  if (googleMapsApiKey) {
    params.push("key=".concat(googleMapsApiKey));
  } else if (googleMapsClientId) {
    params.push("client=".concat(googleMapsClientId));
  }

  if (version) {
    params.push("v=".concat(version));
  }

  if (language) {
    params.push("language=".concat(language));
  }

  if (region) {
    params.push("region=".concat(region));
  }

  if (libraries && libraries.length) {
    params.push("libraries=".concat(libraries.sort().join(',')));
  }

  if (channel) {
    params.push("channel=".concat(channel));
  }

  if (mapIds && mapIds.length) {
    params.push("map_ids=".concat(mapIds.join(',')));
  }

  params.push('callback=initMap');
  return "https://maps.googleapis.com/maps/api/js?".concat(params.join('&'));
}

var cleaningUp = false;

function DefaultLoadingElement() {
  return jsxRuntime.exports.jsx("div", {
    children: "Loading..."
  });
}

var defaultLoadScriptProps = {
  id: 'script-loader',
  version: 'weekly'
};

var LoadScript = /*#__PURE__*/function (_PureComponent2) {
  _inherits(LoadScript, _PureComponent2);

  function LoadScript() {
    var _this3;

    _classCallCheck(this, LoadScript);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(LoadScript).apply(this, arguments));
    _this3.check = createRef();
    _this3.state = {
      loaded: false
    };

    _this3.cleanupCallback = function () {
      // @ts-ignore
      delete window.google.maps;

      _this3.injectScript();
    };

    _this3.isCleaningUp = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this3)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var promiseCallback;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                promiseCallback = function _promiseCallback(resolve) {
                  if (!cleaningUp) {
                    resolve();
                  } else {
                    if (isBrowser) {
                      var timer = window.setInterval(function interval() {
                        if (!cleaningUp) {
                          window.clearInterval(timer);
                          resolve();
                        }
                      }, 1);
                    }
                  }

                  return;
                };

                return _context.abrupt("return", new Promise(promiseCallback));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };

    _this3.cleanup = function () {
      cleaningUp = true;
      var script = document.getElementById(_this3.props.id);

      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }

      Array.prototype.slice.call(document.getElementsByTagName('script')).filter(function filter(script) {
        return typeof script.src === 'string' && script.src.includes('maps.googleapis');
      }).forEach(function forEach(script) {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
      Array.prototype.slice.call(document.getElementsByTagName('link')).filter(function filter(link) {
        return link.href === 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Google+Sans';
      }).forEach(function forEach(link) {
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
      Array.prototype.slice.call(document.getElementsByTagName('style')).filter(function filter(style) {
        return style.innerText !== undefined && style.innerText.length > 0 && style.innerText.includes('.gm-');
      }).forEach(function forEach(style) {
        if (style.parentNode) {
          style.parentNode.removeChild(style);
        }
      });
    };

    _this3.injectScript = function () {
      if (_this3.props.preventGoogleFontsLoading) {
        preventGoogleFonts();
      }

      invariant_1(!!_this3.props.id, 'LoadScript requires "id" prop to be a string: %s', _this3.props.id);
      var injectScriptOptions = {
        id: _this3.props.id,
        nonce: _this3.props.nonce,
        url: makeLoadScriptUrl(_this3.props)
      };
      injectScript(injectScriptOptions).then(function () {
        if (_this3.props.onLoad) {
          _this3.props.onLoad();
        }

        _this3.setState(function setLoaded() {
          return {
            loaded: true
          };
        });

        return;
      }).catch(function (err) {
        if (_this3.props.onError) {
          _this3.props.onError(err);
        }

        console.error("\n          There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(_this3.props.googleMapsApiKey || '-', ") or Client ID (").concat(_this3.props.googleMapsClientId || '-', ") to <LoadScript />\n          Otherwise it is a Network issue.\n        "));
      });
    };

    return _this3;
  }

  _createClass(LoadScript, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (isBrowser) {
        if (window.google && window.google.maps && !cleaningUp) {
          console.error('google api is already presented');
          return;
        }

        this.isCleaningUp().then(this.injectScript).catch(function error(err) {
          console.error('Error at injecting script after cleaning up: ', err);
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.libraries !== prevProps.libraries) {
        console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
      }

      if (isBrowser && prevProps.language !== this.props.language) {
        this.cleanup(); // TODO: refactor to use gDSFP maybe... wait for hooks refactoring.
        // eslint-disable-next-line react/no-did-update-set-state

        this.setState(function setLoaded() {
          return {
            loaded: false
          };
        }, this.cleanupCallback);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this4 = this;

      if (isBrowser) {
        this.cleanup();

        var timeoutCallback = function timeoutCallback() {
          if (!_this4.check.current) {
            // @ts-ignore
            delete window.google;
            cleaningUp = false;
          }
        };

        window.setTimeout(timeoutCallback, 1);

        if (this.props.onUnmount) {
          this.props.onUnmount();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, {
        children: [jsxRuntime.exports.jsx("div", {
          ref: this.check
        }), this.state.loaded ? this.props.children : this.props.loadingElement || jsxRuntime.exports.jsx(DefaultLoadingElement, {})]
      });
    }
  }]);

  return LoadScript;
}(PureComponent);

LoadScript.defaultProps = defaultLoadScriptProps;
/* eslint-disable filenames/match-regex */

var previouslyLoadedUrl;

function useLoadScript(_ref5) {
  var _ref5$id = _ref5.id,
      id = _ref5$id === void 0 ? defaultLoadScriptProps.id : _ref5$id,
      _ref5$version = _ref5.version,
      version = _ref5$version === void 0 ? defaultLoadScriptProps.version : _ref5$version,
      nonce = _ref5.nonce,
      googleMapsApiKey = _ref5.googleMapsApiKey,
      googleMapsClientId = _ref5.googleMapsClientId,
      language = _ref5.language,
      region = _ref5.region,
      libraries = _ref5.libraries,
      preventGoogleFontsLoading = _ref5.preventGoogleFontsLoading,
      channel = _ref5.channel,
      mapIds = _ref5.mapIds;
  var isMounted = useRef(false);

  var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      isLoaded = _useState28[0],
      setLoaded = _useState28[1];

  var _useState29 = useState(undefined),
      _useState30 = _slicedToArray(_useState29, 2),
      loadError = _useState30[0],
      setLoadError = _useState30[1];

  useEffect(function trackMountedState() {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  useEffect(function applyPreventGoogleFonts() {
    if (isBrowser && preventGoogleFontsLoading) {
      preventGoogleFonts();
    }
  }, [preventGoogleFontsLoading]);
  useEffect(function validateLoadedState() {
    if (isLoaded) {
      invariant_1(!!window.google, 'useLoadScript was marked as loaded, but window.google is not present. Something went wrong.');
    }
  }, [isLoaded]);
  var url = makeLoadScriptUrl({
    version: version,
    googleMapsApiKey: googleMapsApiKey,
    googleMapsClientId: googleMapsClientId,
    language: language,
    region: region,
    libraries: libraries,
    channel: channel,
    mapIds: mapIds
  });
  useEffect(function loadScriptAndModifyLoadedState() {
    if (!isBrowser) {
      return;
    }

    function setLoadedIfMounted() {
      if (isMounted.current) {
        setLoaded(true);
        previouslyLoadedUrl = url;
      }
    }

    if (window.google && window.google.maps && previouslyLoadedUrl === url) {
      setLoadedIfMounted();
      return;
    }

    injectScript({
      id: id,
      url: url,
      nonce: nonce
    }).then(setLoadedIfMounted).catch(function handleInjectError(err) {
      if (isMounted.current) {
        setLoadError(err);
      }

      console.warn("\n        There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(googleMapsApiKey || '-', ") or Client ID (").concat(googleMapsClientId || '-', ")\n        Otherwise it is a Network issue.\n      "));
      console.error(err);
    });
  }, [id, url, nonce]);
  var prevLibraries = useRef();
  useEffect(function checkPerformance() {
    if (prevLibraries.current && libraries !== prevLibraries.current) {
      console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
    }

    prevLibraries.current = libraries;
  }, [libraries]);
  return {
    isLoaded: isLoaded,
    loadError: loadError,
    url: url
  };
}

var defaultLoadingElement = jsxRuntime.exports.jsx(DefaultLoadingElement, {});

function LoadScriptNext(_a) {
  var loadingElement = _a.loadingElement,
      onLoad = _a.onLoad,
      onError = _a.onError,
      onUnmount = _a.onUnmount,
      children = _a.children,
      hookOptions = __rest$1(_a, ["loadingElement", "onLoad", "onError", "onUnmount", "children"]);

  var _useLoadScript = useLoadScript(hookOptions),
      isLoaded = _useLoadScript.isLoaded,
      loadError = _useLoadScript.loadError;

  useEffect(function handleOnLoad() {
    if (isLoaded && typeof onLoad === 'function') {
      onLoad();
    }
  }, [isLoaded, onLoad]);
  useEffect(function handleOnError() {
    if (loadError && typeof onError === 'function') {
      onError(loadError);
    }
  }, [loadError, onError]);
  useEffect(function handleOnUnmount() {
    return function () {
      if (onUnmount) {
        onUnmount();
      }
    };
  }, [onUnmount]);
  return isLoaded ? children : loadingElement || defaultLoadingElement;
}

var LoadScriptNext$1 = memo(LoadScriptNext); // do not edit .js files directly - edit src/index.jst

var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;

    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    }

    for (i = length; i-- !== 0;) {
      var key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  } // true if both NaN, false otherwise


  return a !== a && b !== b;
};
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DEFAULT_ID = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */

var LoaderStatus;

(function (LoaderStatus) {
  LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
  LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
  LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
  LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})(LoaderStatus || (LoaderStatus = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */


var Loader = /*#__PURE__*/function () {
  /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */
  function Loader(_ref6) {
    var apiKey = _ref6.apiKey,
        authReferrerPolicy = _ref6.authReferrerPolicy,
        channel = _ref6.channel,
        client = _ref6.client,
        _ref6$id = _ref6.id,
        id = _ref6$id === void 0 ? DEFAULT_ID : _ref6$id,
        language = _ref6.language,
        _ref6$libraries = _ref6.libraries,
        libraries = _ref6$libraries === void 0 ? [] : _ref6$libraries,
        mapIds = _ref6.mapIds,
        nonce = _ref6.nonce,
        region = _ref6.region,
        _ref6$retries = _ref6.retries,
        retries = _ref6$retries === void 0 ? 3 : _ref6$retries,
        _ref6$url = _ref6.url,
        url = _ref6$url === void 0 ? "https://maps.googleapis.com/maps/api/js" : _ref6$url,
        version = _ref6.version;

    _classCallCheck(this, Loader);

    this.CALLBACK = "__googleMapsCallback";
    this.callbacks = [];
    this.done = false;
    this.loading = false;
    this.errors = [];
    this.apiKey = apiKey;
    this.authReferrerPolicy = authReferrerPolicy;
    this.channel = channel;
    this.client = client;
    this.id = id || DEFAULT_ID; // Do not allow empty string

    this.language = language;
    this.libraries = libraries;
    this.mapIds = mapIds;
    this.nonce = nonce;
    this.region = region;
    this.retries = retries;
    this.url = url;
    this.version = version;

    if (Loader.instance) {
      if (!fastDeepEqual(this.options, Loader.instance.options)) {
        throw new Error("Loader must not be called again with different options. ".concat(JSON.stringify(this.options), " !== ").concat(JSON.stringify(Loader.instance.options)));
      }

      return Loader.instance;
    }

    Loader.instance = this;
  }

  _createClass(Loader, [{
    key: "createUrl",

    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     */
    value: function createUrl() {
      var url = this.url;
      url += "?callback=".concat(this.CALLBACK);

      if (this.apiKey) {
        url += "&key=".concat(this.apiKey);
      }

      if (this.channel) {
        url += "&channel=".concat(this.channel);
      }

      if (this.client) {
        url += "&client=".concat(this.client);
      }

      if (this.libraries.length > 0) {
        url += "&libraries=".concat(this.libraries.join(","));
      }

      if (this.language) {
        url += "&language=".concat(this.language);
      }

      if (this.region) {
        url += "&region=".concat(this.region);
      }

      if (this.version) {
        url += "&v=".concat(this.version);
      }

      if (this.mapIds) {
        url += "&map_ids=".concat(this.mapIds.join(","));
      }

      if (this.authReferrerPolicy) {
        url += "&auth_referrer_policy=".concat(this.authReferrerPolicy);
      }

      return url;
    }
  }, {
    key: "deleteScript",
    value: function deleteScript() {
      var script = document.getElementById(this.id);

      if (script) {
        script.remove();
      }
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     */

  }, {
    key: "load",
    value: function load() {
      return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     */

  }, {
    key: "loadPromise",
    value: function loadPromise() {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        _this5.loadCallback(function (err) {
          if (!err) {
            resolve(window.google);
          } else {
            reject(err.error);
          }
        });
      });
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     */

  }, {
    key: "loadCallback",
    value: function loadCallback(fn) {
      this.callbacks.push(fn);
      this.execute();
    }
    /**
     * Set the script on document.
     */

  }, {
    key: "setScript",
    value: function setScript() {
      if (document.getElementById(this.id)) {
        // TODO wrap onerror callback for cases where the script was loaded elsewhere
        this.callback();
        return;
      }

      var url = this.createUrl();
      var script = document.createElement("script");
      script.id = this.id;
      script.type = "text/javascript";
      script.src = url;
      script.onerror = this.loadErrorCallback.bind(this);
      script.defer = true;
      script.async = true;

      if (this.nonce) {
        script.nonce = this.nonce;
      }

      document.head.appendChild(script);
    }
    /**
     * Reset the loader state.
     */

  }, {
    key: "reset",
    value: function reset() {
      this.deleteScript();
      this.done = false;
      this.loading = false;
      this.errors = [];
      this.onerrorEvent = null;
    }
  }, {
    key: "resetIfRetryingFailed",
    value: function resetIfRetryingFailed() {
      if (this.failed) {
        this.reset();
      }
    }
  }, {
    key: "loadErrorCallback",
    value: function loadErrorCallback(e) {
      var _this6 = this;

      this.errors.push(e);

      if (this.errors.length <= this.retries) {
        var delay = this.errors.length * Math.pow(2, this.errors.length);
        console.log("Failed to load Google Maps script, retrying in ".concat(delay, " ms."));
        setTimeout(function () {
          _this6.deleteScript();

          _this6.setScript();
        }, delay);
      } else {
        this.onerrorEvent = e;
        this.callback();
      }
    }
  }, {
    key: "setCallback",
    value: function setCallback() {
      window.__googleMapsCallback = this.callback.bind(this);
    }
  }, {
    key: "callback",
    value: function callback() {
      var _this7 = this;

      this.done = true;
      this.loading = false;
      this.callbacks.forEach(function (cb) {
        cb(_this7.onerrorEvent);
      });
      this.callbacks = [];
    }
  }, {
    key: "execute",
    value: function execute() {
      this.resetIfRetryingFailed();

      if (this.done) {
        this.callback();
      } else {
        // short circuit and warn if google.maps is already loaded
        if (window.google && window.google.maps && window.google.maps.version) {
          console.warn("Google Maps already loaded outside @googlemaps/js-api-loader." + "This may result in undesirable behavior as options and script parameters may not match.");
          this.callback();
          return;
        }

        if (this.loading) ;else {
          this.loading = true;
          this.setCallback();
          this.setScript();
        }
      }
    }
  }, {
    key: "options",
    get: function get() {
      return {
        version: this.version,
        apiKey: this.apiKey,
        channel: this.channel,
        client: this.client,
        id: this.id,
        libraries: this.libraries,
        language: this.language,
        region: this.region,
        mapIds: this.mapIds,
        nonce: this.nonce,
        url: this.url,
        authReferrerPolicy: this.authReferrerPolicy
      };
    }
  }, {
    key: "status",
    get: function get() {
      if (this.errors.length) {
        return LoaderStatus.FAILURE;
      }

      if (this.done) {
        return LoaderStatus.SUCCESS;
      }

      if (this.loading) {
        return LoaderStatus.LOADING;
      }

      return LoaderStatus.INITIALIZED;
    }
  }, {
    key: "failed",
    get: function get() {
      return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
  }]);

  return Loader;
}();

function useJsApiLoader(_ref7) {
  var _ref7$id = _ref7.id,
      id = _ref7$id === void 0 ? defaultLoadScriptProps.id : _ref7$id,
      _ref7$version = _ref7.version,
      version = _ref7$version === void 0 ? defaultLoadScriptProps.version : _ref7$version,
      nonce = _ref7.nonce,
      googleMapsApiKey = _ref7.googleMapsApiKey,
      language = _ref7.language,
      region = _ref7.region,
      libraries = _ref7.libraries,
      preventGoogleFontsLoading = _ref7.preventGoogleFontsLoading,
      mapIds = _ref7.mapIds;
  var isMounted = useRef(false);

  var _useState31 = useState(false),
      _useState32 = _slicedToArray(_useState31, 2),
      isLoaded = _useState32[0],
      setLoaded = _useState32[1];

  var _useState33 = useState(undefined),
      _useState34 = _slicedToArray(_useState33, 2),
      loadError = _useState34[0],
      setLoadError = _useState34[1];

  useEffect(function trackMountedState() {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  var loader = useMemo(function memo() {
    return new Loader({
      id: id,
      apiKey: googleMapsApiKey,
      version: version,
      libraries: libraries,
      language: language,
      region: region,
      mapIds: mapIds,
      nonce: nonce
    });
  }, [id, googleMapsApiKey, version, libraries, language, region, mapIds, nonce]);
  useEffect(function effect() {
    if (isLoaded) {
      return;
    } else {
      loader.load().then(function then() {
        if (isMounted.current) setLoaded(true);
      }).catch(function onrejected(error) {
        setLoadError(error);
      });
    }
  }, []);
  useEffect(function applyPreventGoogleFonts() {
    if (isBrowser && preventGoogleFontsLoading) {
      preventGoogleFonts();
    }
  }, [preventGoogleFontsLoading]);
  var prevLibraries = useRef();
  useEffect(function effect() {
    if (prevLibraries.current && libraries !== prevLibraries.current) {
      console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
    }

    prevLibraries.current = libraries;
  }, [libraries]);
  return {
    isLoaded: isLoaded,
    loadError: loadError
  };
}

var eventMap$h = {};
var updaterMap$h = {
  options: function options(instance, _options2) {
    instance.setOptions(_options2);
  }
};

function TrafficLayerFunctional(_ref8) {
  var options = _ref8.options,
      onLoad = _ref8.onLoad,
      onUnmount = _ref8.onUnmount;
  var map = useContext(MapContext);

  var _useState35 = useState(null),
      _useState36 = _slicedToArray(_useState35, 2),
      instance = _useState36[0],
      setInstance = _useState36[1]; // Order does matter


  useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  useEffect(function () {
    if (options && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  useEffect(function () {
    var trafficLayer = new google.maps.TrafficLayer(Object.assign(Object.assign({}, options || {}), {
      map: map
    }));
    setInstance(trafficLayer);

    if (onLoad) {
      onLoad(trafficLayer);
    }

    return function () {
      if (instance !== null) {
        if (onUnmount) {
          onUnmount(instance);
        }

        instance.setMap(null);
      }
    };
  }, []);
  return null;
}

var TrafficLayerF = memo(TrafficLayerFunctional);

var TrafficLayer = /*#__PURE__*/function (_PureComponent3) {
  _inherits(TrafficLayer, _PureComponent3);

  function TrafficLayer() {
    var _this8;

    _classCallCheck(this, TrafficLayer);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(TrafficLayer).apply(this, arguments));
    _this8.state = {
      trafficLayer: null
    };

    _this8.setTrafficLayerCallback = function () {
      if (_this8.state.trafficLayer !== null && _this8.props.onLoad) {
        _this8.props.onLoad(_this8.state.trafficLayer);
      }
    };

    _this8.registeredEvents = [];
    return _this8;
  }

  _createClass(TrafficLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var trafficLayer = new google.maps.TrafficLayer(Object.assign(Object.assign({}, this.props.options || {}), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$h,
        eventMap: eventMap$h,
        prevProps: {},
        nextProps: this.props,
        instance: trafficLayer
      });
      this.setState(function setTrafficLayer() {
        return {
          trafficLayer: trafficLayer
        };
      }, this.setTrafficLayerCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.trafficLayer !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$h,
          eventMap: eventMap$h,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.trafficLayer
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.trafficLayer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.trafficLayer);
        }

        unregisterEvents(this.registeredEvents); // @ts-ignore

        this.state.trafficLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return TrafficLayer;
}(PureComponent);

TrafficLayer.contextType = MapContext;

function BicyclingLayerFunctional(_ref9) {
  var onLoad = _ref9.onLoad,
      onUnmount = _ref9.onUnmount;
  var map = useContext(MapContext);

  var _useState37 = useState(null),
      _useState38 = _slicedToArray(_useState37, 2),
      instance = _useState38[0],
      setInstance = _useState38[1]; // Order does matter


  useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  useEffect(function () {
    var bicyclingLayer = new google.maps.BicyclingLayer();
    setInstance(bicyclingLayer);
    bicyclingLayer.setMap(map);

    if (onLoad) {
      onLoad(bicyclingLayer);
    }

    return function () {
      if (bicyclingLayer !== null) {
        if (onUnmount) {
          onUnmount(bicyclingLayer);
        }

        bicyclingLayer.setMap(null);
      }
    };
  }, []);
  return null;
}

var BicyclingLayerF = memo(BicyclingLayerFunctional);

var BicyclingLayer = /*#__PURE__*/function (_PureComponent4) {
  _inherits(BicyclingLayer, _PureComponent4);

  function BicyclingLayer() {
    var _this9;

    _classCallCheck(this, BicyclingLayer);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(BicyclingLayer).apply(this, arguments));
    _this9.state = {
      bicyclingLayer: null
    };

    _this9.setBicyclingLayerCallback = function () {
      if (_this9.state.bicyclingLayer !== null) {
        _this9.state.bicyclingLayer.setMap(_this9.context);

        if (_this9.props.onLoad) {
          _this9.props.onLoad(_this9.state.bicyclingLayer);
        }
      }
    };

    return _this9;
  }

  _createClass(BicyclingLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var bicyclingLayer = new google.maps.BicyclingLayer();
      this.setState(function () {
        return {
          bicyclingLayer: bicyclingLayer
        };
      }, this.setBicyclingLayerCallback);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.bicyclingLayer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.bicyclingLayer);
        }

        this.state.bicyclingLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return BicyclingLayer;
}(PureComponent);

BicyclingLayer.contextType = MapContext;

function TransitLayerFunctional(_ref10) {
  var _this10 = this;

  var onLoad = _ref10.onLoad,
      onUnmount = _ref10.onUnmount;
  var map = useContext(MapContext);

  var _useState39 = useState(null),
      _useState40 = _slicedToArray(_useState39, 2),
      instance = _useState40[0],
      setInstance = _useState40[1]; // Order does matter


  useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  useEffect(function () {
    var transitLayer = new google.maps.TransitLayer();
    setInstance(transitLayer);
    transitLayer.setMap(map);

    if (onLoad) {
      onLoad(transitLayer);
    }

    return function () {
      if (instance !== null) {
        if (onUnmount) {
          onUnmount(instance);
        } // @ts-ignore


        _this10.state.transitLayer.setMap(null);
      }
    };
  }, []);
  return null;
}

var TransitLayerF = memo(TransitLayerFunctional);

var TransitLayer = /*#__PURE__*/function (_PureComponent5) {
  _inherits(TransitLayer, _PureComponent5);

  function TransitLayer() {
    var _this11;

    _classCallCheck(this, TransitLayer);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(TransitLayer).apply(this, arguments));
    _this11.state = {
      transitLayer: null
    };

    _this11.setTransitLayerCallback = function () {
      if (_this11.state.transitLayer !== null) {
        // @ts-ignore
        _this11.state.transitLayer.setMap(_this11.context);

        if (_this11.props.onLoad) {
          // @ts-ignore
          _this11.props.onLoad(_this11.state.transitLayer);
        }
      }
    };

    return _this11;
  }

  _createClass(TransitLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var transitLayer = new google.maps.TransitLayer();
      this.setState(function setTransitLayer() {
        return {
          transitLayer: transitLayer
        };
      }, this.setTransitLayerCallback);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.transitLayer !== null) {
        if (this.props.onUnmount) {
          // @ts-ignore
          this.props.onUnmount(this.state.transitLayer);
        } // @ts-ignore


        this.state.transitLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return TransitLayer;
}(PureComponent);

TransitLayer.contextType = MapContext;
/* globals google */

var eventMap$g = {
  onCircleComplete: 'circlecomplete',
  onMarkerComplete: 'markercomplete',
  onOverlayComplete: 'overlaycomplete',
  onPolygonComplete: 'polygoncomplete',
  onPolylineComplete: 'polylinecomplete',
  onRectangleComplete: 'rectanglecomplete'
};
var updaterMap$g = {
  drawingMode: function drawingMode(instance, _drawingMode) {
    instance.setDrawingMode(_drawingMode);
  },
  options: function options(instance, _options3) {
    instance.setOptions(_options3);
  }
};

function DrawingManagerFunctional(_ref11) {
  var options = _ref11.options,
      drawingMode = _ref11.drawingMode,
      onCircleComplete = _ref11.onCircleComplete,
      onMarkerComplete = _ref11.onMarkerComplete,
      onOverlayComplete = _ref11.onOverlayComplete,
      onPolylineComplete = _ref11.onPolylineComplete,
      onRectangleComplete = _ref11.onRectangleComplete,
      onLoad = _ref11.onLoad,
      onUnmount = _ref11.onUnmount;
  var map = useContext(MapContext);

  var _useState41 = useState(null),
      _useState42 = _slicedToArray(_useState41, 2),
      instance = _useState42[0],
      setInstance = _useState42[1];

  var _useState43 = useState(null),
      _useState44 = _slicedToArray(_useState43, 2),
      circlecompleteListener = _useState44[0],
      setCircleCompleteListener = _useState44[1];

  var _useState45 = useState(null),
      _useState46 = _slicedToArray(_useState45, 2),
      markercompleteListener = _useState46[0],
      setMarkerCompleteListener = _useState46[1];

  var _useState47 = useState(null),
      _useState48 = _slicedToArray(_useState47, 2),
      overlaycompleteListener = _useState48[0],
      setOverlayCompleteListener = _useState48[1];

  var _useState49 = useState(null),
      _useState50 = _slicedToArray(_useState49, 2),
      polygoncompleteListener = _useState50[0],
      setPolygonCompleteListener = _useState50[1];

  var _useState51 = useState(null),
      _useState52 = _slicedToArray(_useState51, 2),
      rectanglecompleteListener = _useState52[0],
      setRectangleCompleteListener = _useState52[1]; // Order does matter


  useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  useEffect(function () {
    if (options && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  useEffect(function () {
    if (drawingMode && instance !== null) {
      instance.setDrawingMode(drawingMode);
    }
  }, [instance, drawingMode]);
  useEffect(function () {
    if (instance && onCircleComplete) {
      if (circlecompleteListener !== null) {
        google.maps.event.removeListener(circlecompleteListener);
      }

      setCircleCompleteListener(google.maps.event.addListener(instance, 'circlecomplete', onCircleComplete));
    }
  }, [instance, onCircleComplete]);
  useEffect(function () {
    if (instance && onMarkerComplete) {
      if (markercompleteListener !== null) {
        google.maps.event.removeListener(markercompleteListener);
      }

      setMarkerCompleteListener(google.maps.event.addListener(instance, 'markercomplete', onMarkerComplete));
    }
  }, [instance, onMarkerComplete]);
  useEffect(function () {
    if (instance && onOverlayComplete) {
      if (overlaycompleteListener !== null) {
        google.maps.event.removeListener(overlaycompleteListener);
      }

      setOverlayCompleteListener(google.maps.event.addListener(instance, 'overlaycomplete', onOverlayComplete));
    }
  }, [instance, onOverlayComplete]);
  useEffect(function () {
    if (instance && onPolylineComplete) {
      if (polygoncompleteListener !== null) {
        google.maps.event.removeListener(polygoncompleteListener);
      }

      setPolygonCompleteListener(google.maps.event.addListener(instance, 'polygoncomplete', onPolylineComplete));
    }
  }, [instance, onPolylineComplete]);
  useEffect(function () {
    if (instance && onRectangleComplete) {
      if (rectanglecompleteListener !== null) {
        google.maps.event.removeListener(rectanglecompleteListener);
      }

      setRectangleCompleteListener(google.maps.event.addListener(instance, 'rectanglecomplete', onRectangleComplete));
    }
  }, [instance, onRectangleComplete]);
  useEffect(function () {
    invariant_1(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
    var drawingManager = new google.maps.drawing.DrawingManager(Object.assign(Object.assign({}, options || {}), {
      map: map
    }));

    if (drawingMode) {
      drawingManager.setDrawingMode(drawingMode);
    }

    if (onCircleComplete) {
      setCircleCompleteListener(google.maps.event.addListener(drawingManager, 'circlecomplete', onCircleComplete));
    }

    if (onMarkerComplete) {
      setMarkerCompleteListener(google.maps.event.addListener(drawingManager, 'markercomplete', onMarkerComplete));
    }

    if (onOverlayComplete) {
      setOverlayCompleteListener(google.maps.event.addListener(drawingManager, 'overlaycomplete', onOverlayComplete));
    }

    if (onPolylineComplete) {
      setPolygonCompleteListener(google.maps.event.addListener(drawingManager, 'polygoncomplete', onPolylineComplete));
    }

    if (onRectangleComplete) {
      setRectangleCompleteListener(google.maps.event.addListener(drawingManager, 'rectanglecomplete', onRectangleComplete));
    }

    setInstance(drawingManager);

    if (onLoad) {
      onLoad(drawingManager);
    }

    return function () {
      if (instance !== null) {
        if (circlecompleteListener) {
          google.maps.event.removeListener(circlecompleteListener);
        }

        if (markercompleteListener) {
          google.maps.event.removeListener(markercompleteListener);
        }

        if (overlaycompleteListener) {
          google.maps.event.removeListener(overlaycompleteListener);
        }

        if (polygoncompleteListener) {
          google.maps.event.removeListener(polygoncompleteListener);
        }

        if (rectanglecompleteListener) {
          google.maps.event.removeListener(rectanglecompleteListener);
        }

        if (onUnmount) {
          onUnmount(instance);
        }

        instance.setMap(null);
      }
    };
  }, []);
  return null;
}

var DrawingManagerF = memo(DrawingManagerFunctional);

var DrawingManager = /*#__PURE__*/function (_PureComponent6) {
  _inherits(DrawingManager, _PureComponent6);

  function DrawingManager(props) {
    var _this12;

    _classCallCheck(this, DrawingManager);

    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(DrawingManager).call(this, props));
    _this12.registeredEvents = [];
    _this12.state = {
      drawingManager: null
    };

    _this12.setDrawingManagerCallback = function () {
      if (_this12.state.drawingManager !== null && _this12.props.onLoad) {
        _this12.props.onLoad(_this12.state.drawingManager);
      }
    };

    invariant_1(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
    return _this12;
  }

  _createClass(DrawingManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var drawingManager = new google.maps.drawing.DrawingManager(Object.assign(Object.assign({}, this.props.options || {}), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$g,
        eventMap: eventMap$g,
        prevProps: {},
        nextProps: this.props,
        instance: drawingManager
      });
      this.setState(function setDrawingManager() {
        return {
          drawingManager: drawingManager
        };
      }, this.setDrawingManagerCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.drawingManager !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$g,
          eventMap: eventMap$g,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.drawingManager
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.drawingManager !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.drawingManager);
        }

        unregisterEvents(this.registeredEvents);
        this.state.drawingManager.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return DrawingManager;
}(PureComponent);

DrawingManager.contextType = MapContext;
var eventMap$f = {
  onAnimationChanged: 'animation_changed',
  onClick: 'click',
  onClickableChanged: 'clickable_changed',
  onCursorChanged: 'cursor_changed',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDraggableChanged: 'draggable_changed',
  onDragStart: 'dragstart',
  onFlatChanged: 'flat_changed',
  onIconChanged: 'icon_changed',
  onMouseDown: 'mousedown',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onPositionChanged: 'position_changed',
  onRightClick: 'rightclick',
  onShapeChanged: 'shape_changed',
  onTitleChanged: 'title_changed',
  onVisibleChanged: 'visible_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$f = {
  animation: function animation(instance, _animation) {
    instance.setAnimation(_animation);
  },
  clickable: function clickable(instance, _clickable) {
    instance.setClickable(_clickable);
  },
  cursor: function cursor(instance, _cursor) {
    instance.setCursor(_cursor);
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable);
  },
  icon: function icon(instance, _icon) {
    instance.setIcon(_icon);
  },
  label: function label(instance, _label) {
    instance.setLabel(_label);
  },
  map: function map(instance, _map) {
    instance.setMap(_map);
  },
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity);
  },
  options: function options(instance, _options4) {
    instance.setOptions(_options4);
  },
  position: function position(instance, _position) {
    instance.setPosition(_position);
  },
  shape: function shape(instance, _shape) {
    instance.setShape(_shape);
  },
  title: function title(instance, _title) {
    instance.setTitle(_title);
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible);
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex);
  }
};
var defaultOptions$4 = {};

function MarkerFunctional(_ref12) {
  var position = _ref12.position,
      options = _ref12.options,
      clusterer = _ref12.clusterer,
      noClustererRedraw = _ref12.noClustererRedraw,
      children = _ref12.children,
      draggable = _ref12.draggable,
      visible = _ref12.visible,
      animation = _ref12.animation,
      clickable = _ref12.clickable,
      cursor = _ref12.cursor,
      icon = _ref12.icon,
      label = _ref12.label,
      opacity = _ref12.opacity,
      shape = _ref12.shape,
      title = _ref12.title,
      zIndex = _ref12.zIndex,
      onClick = _ref12.onClick,
      onDblClick = _ref12.onDblClick,
      onDrag = _ref12.onDrag,
      onDragEnd = _ref12.onDragEnd,
      onDragStart = _ref12.onDragStart,
      onMouseOut = _ref12.onMouseOut,
      onMouseOver = _ref12.onMouseOver,
      onMouseUp = _ref12.onMouseUp,
      onMouseDown = _ref12.onMouseDown,
      onRightClick = _ref12.onRightClick,
      onClickableChanged = _ref12.onClickableChanged,
      onCursorChanged = _ref12.onCursorChanged,
      onAnimationChanged = _ref12.onAnimationChanged,
      onDraggableChanged = _ref12.onDraggableChanged,
      onFlatChanged = _ref12.onFlatChanged,
      onIconChanged = _ref12.onIconChanged,
      onPositionChanged = _ref12.onPositionChanged,
      onShapeChanged = _ref12.onShapeChanged,
      onTitleChanged = _ref12.onTitleChanged,
      onVisibleChanged = _ref12.onVisibleChanged,
      onZindexChanged = _ref12.onZindexChanged,
      onLoad = _ref12.onLoad,
      onUnmount = _ref12.onUnmount;
  var map = useContext(MapContext);

  var _useState53 = useState(null),
      _useState54 = _slicedToArray(_useState53, 2),
      instance = _useState54[0],
      setInstance = _useState54[1];

  var _useState55 = useState(null),
      _useState56 = _slicedToArray(_useState55, 2),
      dblclickListener = _useState56[0],
      setDblclickListener = _useState56[1];

  var _useState57 = useState(null),
      _useState58 = _slicedToArray(_useState57, 2),
      dragendListener = _useState58[0],
      setDragendListener = _useState58[1];

  var _useState59 = useState(null),
      _useState60 = _slicedToArray(_useState59, 2),
      dragstartListener = _useState60[0],
      setDragstartListener = _useState60[1];

  var _useState61 = useState(null),
      _useState62 = _slicedToArray(_useState61, 2),
      mousedownListener = _useState62[0],
      setMousedownListener = _useState62[1];

  var _useState63 = useState(null),
      _useState64 = _slicedToArray(_useState63, 2),
      mouseoutListener = _useState64[0],
      setMouseoutListener = _useState64[1];

  var _useState65 = useState(null),
      _useState66 = _slicedToArray(_useState65, 2),
      mouseoverListener = _useState66[0],
      setMouseoverListener = _useState66[1];

  var _useState67 = useState(null),
      _useState68 = _slicedToArray(_useState67, 2),
      mouseupListener = _useState68[0],
      setMouseupListener = _useState68[1];

  var _useState69 = useState(null),
      _useState70 = _slicedToArray(_useState69, 2),
      rightclickListener = _useState70[0],
      setRightclickListener = _useState70[1];

  var _useState71 = useState(null),
      _useState72 = _slicedToArray(_useState71, 2),
      clickListener = _useState72[0],
      setClickListener = _useState72[1];

  var _useState73 = useState(null),
      _useState74 = _slicedToArray(_useState73, 2),
      dragListener = _useState74[0],
      setDragListener = _useState74[1];

  var _useState75 = useState(null),
      _useState76 = _slicedToArray(_useState75, 2),
      clickableChangedListener = _useState76[0],
      setClickableChangedListener = _useState76[1];

  var _useState77 = useState(null),
      _useState78 = _slicedToArray(_useState77, 2),
      cursorChangedListener = _useState78[0],
      setCursorChangedListener = _useState78[1];

  var _useState79 = useState(null),
      _useState80 = _slicedToArray(_useState79, 2),
      animationChangedListener = _useState80[0],
      setAnimationChangedListener = _useState80[1];

  var _useState81 = useState(null),
      _useState82 = _slicedToArray(_useState81, 2),
      draggableChangedListener = _useState82[0],
      setDraggableChangedListener = _useState82[1];

  var _useState83 = useState(null),
      _useState84 = _slicedToArray(_useState83, 2),
      flatChangedListener = _useState84[0],
      setFlatChangedListener = _useState84[1];

  var _useState85 = useState(null),
      _useState86 = _slicedToArray(_useState85, 2),
      iconChangedListener = _useState86[0],
      setIconChangedListener = _useState86[1];

  var _useState87 = useState(null),
      _useState88 = _slicedToArray(_useState87, 2),
      positionChangedListener = _useState88[0],
      setPositionChangedListener = _useState88[1];

  var _useState89 = useState(null),
      _useState90 = _slicedToArray(_useState89, 2),
      shapeChangedListener = _useState90[0],
      setShapeChangedListener = _useState90[1];

  var _useState91 = useState(null),
      _useState92 = _slicedToArray(_useState91, 2),
      titleChangedListener = _useState92[0],
      setTitleChangedListener = _useState92[1];

  var _useState93 = useState(null),
      _useState94 = _slicedToArray(_useState93, 2),
      visibleChangedListener = _useState94[0],
      setVisibleChangedListener = _useState94[1];

  var _useState95 = useState(null),
      _useState96 = _slicedToArray(_useState95, 2),
      zIndexChangedListener = _useState96[0],
      setZindexChangedListener = _useState96[1]; // Order does matter


  useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  useEffect(function () {
    if (position && instance !== null) {
      instance.setPosition(position);
    }
  }, [instance, position]);
  useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  useEffect(function () {
    if (animation && instance !== null) {
      instance.setAnimation(animation);
    }
  }, [instance, animation]);
  useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDblClick]);
  useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  useEffect(function () {
    if (instance && onClickableChanged) {
      if (clickableChangedListener !== null) {
        google.maps.event.removeListener(clickableChangedListener);
      }

      setClickableChangedListener(google.maps.event.addListener(instance, 'clickable_changed', onClickableChanged));
    }
  }, [onClickableChanged]);
  useEffect(function () {
    if (instance && onCursorChanged) {
      if (cursorChangedListener !== null) {
        google.maps.event.removeListener(cursorChangedListener);
      }

      setCursorChangedListener(google.maps.event.addListener(instance, 'cursor_changed', onCursorChanged));
    }
  }, [onCursorChanged]);
  useEffect(function () {
    if (instance && onAnimationChanged) {
      if (animationChangedListener !== null) {
        google.maps.event.removeListener(animationChangedListener);
      }

      setAnimationChangedListener(google.maps.event.addListener(instance, 'animation_changed', onAnimationChanged));
    }
  }, [onAnimationChanged]);
  useEffect(function () {
    if (instance && onDraggableChanged) {
      if (draggableChangedListener !== null) {
        google.maps.event.removeListener(draggableChangedListener);
      }

      setDraggableChangedListener(google.maps.event.addListener(instance, 'draggable_changed', onDraggableChanged));
    }
  }, [onDraggableChanged]);
  useEffect(function () {
    if (instance && onFlatChanged) {
      if (flatChangedListener !== null) {
        google.maps.event.removeListener(flatChangedListener);
      }

      setFlatChangedListener(google.maps.event.addListener(instance, 'flat_changed', onFlatChanged));
    }
  }, [onFlatChanged]);
  useEffect(function () {
    if (instance && onIconChanged) {
      if (iconChangedListener !== null) {
        google.maps.event.removeListener(iconChangedListener);
      }

      setIconChangedListener(google.maps.event.addListener(instance, 'icon_changed', onIconChanged));
    }
  }, [onIconChanged]);
  useEffect(function () {
    if (instance && onPositionChanged) {
      if (positionChangedListener !== null) {
        google.maps.event.removeListener(positionChangedListener);
      }

      setPositionChangedListener(google.maps.event.addListener(instance, 'position_changed', onPositionChanged));
    }
  }, [onPositionChanged]);
  useEffect(function () {
    if (instance && onShapeChanged) {
      if (shapeChangedListener !== null) {
        google.maps.event.removeListener(shapeChangedListener);
      }

      setShapeChangedListener(google.maps.event.addListener(instance, 'shape_changed', onShapeChanged));
    }
  }, [onShapeChanged]);
  useEffect(function () {
    if (instance && onTitleChanged) {
      if (titleChangedListener !== null) {
        google.maps.event.removeListener(titleChangedListener);
      }

      setTitleChangedListener(google.maps.event.addListener(instance, 'title_changed', onTitleChanged));
    }
  }, [onTitleChanged]);
  useEffect(function () {
    if (instance && onVisibleChanged) {
      if (visibleChangedListener !== null) {
        google.maps.event.removeListener(visibleChangedListener);
      }

      setVisibleChangedListener(google.maps.event.addListener(instance, 'visible_changed', onVisibleChanged));
    }
  }, [onVisibleChanged]);
  useEffect(function () {
    if (instance && onZindexChanged) {
      if (zIndexChangedListener !== null) {
        google.maps.event.removeListener(zIndexChangedListener);
      }

      setZindexChangedListener(google.maps.event.addListener(instance, 'zindex_changed', onZindexChanged));
    }
  }, [onZindexChanged]);
  useEffect(function () {
    var markerOptions = Object.assign(Object.assign(Object.assign({}, options || defaultOptions$4), clusterer ? defaultOptions$4 : {
      map: map
    }), {
      position: position
    });
    var marker = new google.maps.Marker(markerOptions);

    if (clusterer) {
      clusterer.addMarker(marker, !!noClustererRedraw);
    } else {
      marker.setMap(map);
    }

    if (position) {
      marker.setPosition(position);
    }

    if (typeof visible !== 'undefined') {
      marker.setVisible(visible);
    }

    if (typeof draggable !== 'undefined') {
      marker.setDraggable(draggable);
    }

    if (typeof clickable !== 'undefined') {
      marker.setClickable(clickable);
    }

    if (typeof cursor === 'string') {
      marker.setCursor(cursor);
    }

    if (icon) {
      marker.setIcon(icon);
    }

    if (typeof label !== 'undefined') {
      marker.setLabel(label);
    }

    if (typeof opacity !== 'undefined') {
      marker.setOpacity(opacity);
    }

    if (shape) {
      marker.setShape(shape);
    }

    if (typeof title === 'string') {
      marker.setTitle(title);
    }

    if (typeof zIndex === 'number') {
      marker.setZIndex(zIndex);
    }

    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(marker, 'dblclick', onDblClick));
    }

    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(marker, 'dragend', onDragEnd));
    }

    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(marker, 'dragstart', onDragStart));
    }

    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(marker, 'mousedown', onMouseDown));
    }

    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(marker, 'mouseout', onMouseOut));
    }

    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(marker, 'mouseover', onMouseOver));
    }

    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(marker, 'mouseup', onMouseUp));
    }

    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(marker, 'rightclick', onRightClick));
    }

    if (onClick) {
      setClickListener(google.maps.event.addListener(marker, 'click', onClick));
    }

    if (onDrag) {
      setDragListener(google.maps.event.addListener(marker, 'drag', onDrag));
    }

    if (onClickableChanged) {
      setClickableChangedListener(google.maps.event.addListener(marker, 'clickable_changed', onClickableChanged));
    }

    if (onCursorChanged) {
      setCursorChangedListener(google.maps.event.addListener(marker, 'cursor_changed', onCursorChanged));
    }

    if (onAnimationChanged) {
      setAnimationChangedListener(google.maps.event.addListener(marker, 'animation_changed', onAnimationChanged));
    }

    if (onDraggableChanged) {
      setDraggableChangedListener(google.maps.event.addListener(marker, 'draggable_changed', onDraggableChanged));
    }

    if (onFlatChanged) {
      setFlatChangedListener(google.maps.event.addListener(marker, 'flat_changed', onFlatChanged));
    }

    if (onIconChanged) {
      setIconChangedListener(google.maps.event.addListener(marker, 'icon_changed', onIconChanged));
    }

    if (onPositionChanged) {
      setPositionChangedListener(google.maps.event.addListener(marker, 'position_changed', onPositionChanged));
    }

    if (onShapeChanged) {
      setShapeChangedListener(google.maps.event.addListener(marker, 'shape_changed', onShapeChanged));
    }

    if (onTitleChanged) {
      setTitleChangedListener(google.maps.event.addListener(marker, 'title_changed', onTitleChanged));
    }

    if (onVisibleChanged) {
      setVisibleChangedListener(google.maps.event.addListener(marker, 'visible_changed', onVisibleChanged));
    }

    if (onZindexChanged) {
      setZindexChangedListener(google.maps.event.addListener(marker, 'zindex_changed', onZindexChanged));
    }

    setInstance(marker);

    if (onLoad) {
      onLoad(marker);
    }

    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      if (clickableChangedListener !== null) {
        google.maps.event.removeListener(clickableChangedListener);
      }

      if (cursorChangedListener !== null) {
        google.maps.event.removeListener(cursorChangedListener);
      }

      if (animationChangedListener !== null) {
        google.maps.event.removeListener(animationChangedListener);
      }

      if (draggableChangedListener !== null) {
        google.maps.event.removeListener(draggableChangedListener);
      }

      if (flatChangedListener !== null) {
        google.maps.event.removeListener(flatChangedListener);
      }

      if (iconChangedListener !== null) {
        google.maps.event.removeListener(iconChangedListener);
      }

      if (positionChangedListener !== null) {
        google.maps.event.removeListener(positionChangedListener);
      }

      if (titleChangedListener !== null) {
        google.maps.event.removeListener(titleChangedListener);
      }

      if (visibleChangedListener !== null) {
        google.maps.event.removeListener(visibleChangedListener);
      }

      if (zIndexChangedListener !== null) {
        google.maps.event.removeListener(zIndexChangedListener);
      }

      if (onUnmount) {
        onUnmount(marker);
      }

      if (clusterer) {
        clusterer.removeMarker(marker, !!noClustererRedraw);
      } else if (marker) {
        marker.setMap(null);
      }
    };
  }, []);
  var chx = useMemo(function () {
    return children ? Children.map(children, function (child) {
      if (!isValidElement(child)) {
        return child;
      }

      var elementChild = child;
      return cloneElement(elementChild, {
        anchor: instance
      });
    }) : null;
  }, [children, instance]);
  return jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {
    children: chx
  }) || null;
}

var MarkerF = memo(MarkerFunctional);

var Marker = /*#__PURE__*/function (_PureComponent7) {
  _inherits(Marker, _PureComponent7);

  function Marker() {
    var _this13;

    _classCallCheck(this, Marker);

    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(Marker).apply(this, arguments));
    _this13.registeredEvents = [];
    return _this13;
  }

  _createClass(Marker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var markerOptions = Object.assign(Object.assign(Object.assign({}, this.props.options || defaultOptions$4), this.props.clusterer ? defaultOptions$4 : {
        map: this.context
      }), {
        position: this.props.position
      }); // Unfortunately we can't just do this in the contstructor, because the
      // `MapContext` might not be filled in yet.

      this.marker = new google.maps.Marker(markerOptions);

      if (this.props.clusterer) {
        this.props.clusterer.addMarker(this.marker, !!this.props.noClustererRedraw);
      } else {
        this.marker.setMap(this.context);
      }

      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$f,
        eventMap: eventMap$f,
        prevProps: {},
        nextProps: this.props,
        instance: this.marker
      });

      if (this.props.onLoad) {
        this.props.onLoad(this.marker);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.marker) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$f,
          eventMap: eventMap$f,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.marker
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.marker) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.marker);
        }

        unregisterEvents(this.registeredEvents);

        if (this.props.clusterer) {
          this.props.clusterer.removeMarker(this.marker, !!this.props.noClustererRedraw);
        } else {
          this.marker && this.marker.setMap(null);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this14 = this;

      var children = null;

      if (this.props.children) {
        children = Children.map(this.props.children, function (child) {
          if (!isValidElement(child)) {
            return child;
          }

          var elementChild = child;
          return cloneElement(elementChild, {
            anchor: _this14.marker
          });
        });
      }

      return children || null;
    }
  }]);

  return Marker;
}(PureComponent);

Marker.contextType = MapContext;

var ClusterIcon =
/** @class */
function () {
  function ClusterIcon(cluster, styles) {
    cluster.getClusterer().extend(ClusterIcon, google.maps.OverlayView);
    this.cluster = cluster;
    this.clusterClassName = this.cluster.getClusterer().getClusterClass();
    this.className = this.clusterClassName;
    this.styles = styles;
    this.center = undefined;
    this.div = null;
    this.sums = null;
    this.visible = false;
    this.boundsChangedListener = null;
    this.url = '';
    this.height = 0;
    this.width = 0;
    this.anchorText = [0, 0];
    this.anchorIcon = [0, 0];
    this.textColor = 'black';
    this.textSize = 11;
    this.textDecoration = 'none';
    this.fontWeight = 'bold';
    this.fontStyle = 'normal';
    this.fontFamily = 'Arial,sans-serif';
    this.backgroundPosition = '0 0'; // @ts-ignore

    this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
  }

  ClusterIcon.prototype.onAdd = function () {
    var _this = this;

    var cMouseDownInCluster;
    var cDraggingMapByCluster;
    this.div = document.createElement('div');
    this.div.className = this.className;

    if (this.visible) {
      this.show();
    } // @ts-ignore


    this.getPanes().overlayMouseTarget.appendChild(this.div); // Fix for Issue 157

    this.boundsChangedListener = google.maps.event.addListener( // @ts-ignore
    this.getMap(), 'boundschanged', function boundsChanged() {
      cDraggingMapByCluster = cMouseDownInCluster;
    });
    google.maps.event.addListener(this.div, 'mousedown', function onMouseDown() {
      cMouseDownInCluster = true;
      cDraggingMapByCluster = false;
    });
    google.maps.event.addListener(this.div, 'click', function (event) {
      cMouseDownInCluster = false;

      if (!cDraggingMapByCluster) {
        var markerClusterer_1 = _this.cluster.getClusterer();
        /**
         * This event is fired when a cluster marker is clicked.
         * @name MarkerClusterer#click
         * @param {Cluster} c The cluster that was clicked.
         * @event
         */


        google.maps.event.trigger(markerClusterer_1, 'click', _this.cluster);
        google.maps.event.trigger(markerClusterer_1, 'clusterclick', _this.cluster); // deprecated name
        // The default click handler follows. Disable it by setting
        // the zoomOnClick property to false.

        if (markerClusterer_1.getZoomOnClick()) {
          // Zoom into the cluster.
          var maxZoom_1 = markerClusterer_1.getMaxZoom();

          var bounds_1 = _this.cluster.getBounds(); // @ts-ignore


          markerClusterer_1.getMap().fitBounds(bounds_1); // There is a fix for Issue 170 here:

          setTimeout(function timeout() {
            // @ts-ignore
            markerClusterer_1.getMap().fitBounds(bounds_1); // Don't zoom beyond the max zoom level
            // @ts-ignore

            if (maxZoom_1 !== null && markerClusterer_1.getMap().getZoom() > maxZoom_1) {
              // @ts-ignore
              markerClusterer_1.getMap().setZoom(maxZoom_1 + 1);
            }
          }, 100);
        } // Prevent event propagation to the map:


        event.cancelBubble = true;

        if (event.stopPropagation) {
          event.stopPropagation();
        }
      }
    });
    google.maps.event.addListener(this.div, 'mouseover', function () {
      /**
       * This event is fired when the mouse moves over a cluster marker.
       * @name MarkerClusterer#mouseover
       * @param {Cluster} c The cluster that the mouse moved over.
       * @event
       */
      google.maps.event.trigger(_this.cluster.getClusterer(), 'mouseover', _this.cluster);
    });
    google.maps.event.addListener(this.div, 'mouseout', function () {
      /**
       * This event is fired when the mouse moves out of a cluster marker.
       * @name MarkerClusterer#mouseout
       * @param {Cluster} c The cluster that the mouse moved out of.
       * @event
       */
      google.maps.event.trigger(_this.cluster.getClusterer(), 'mouseout', _this.cluster);
    });
  };

  ClusterIcon.prototype.onRemove = function () {
    if (this.div && this.div.parentNode) {
      this.hide();

      if (this.boundsChangedListener !== null) {
        google.maps.event.removeListener(this.boundsChangedListener);
      }

      google.maps.event.clearInstanceListeners(this.div);
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  };

  ClusterIcon.prototype.draw = function () {
    if (this.visible && this.div !== null && this.center) {
      var _a = this.getPosFromLatLng(this.center),
          x = _a.x,
          y = _a.y;

      this.div.style.top = y + 'px';
      this.div.style.left = x + 'px';
    }
  };

  ClusterIcon.prototype.hide = function () {
    if (this.div) {
      this.div.style.display = 'none';
    }

    this.visible = false;
  };

  ClusterIcon.prototype.show = function () {
    var _a;

    if (this.div && this.center) {
      var divTitle = ''; // NOTE: values must be specified in px units

      var bp = this.backgroundPosition.split(' ');
      var spriteH = parseInt(bp[0].replace(/^\s+|\s+$/g, ''), 10);
      var spriteV = parseInt(bp[1].replace(/^\s+|\s+$/g, ''), 10);
      var pos = this.getPosFromLatLng(this.center);

      if (this.sums === null || typeof this.sums.title === 'undefined' || this.sums.title === '') {
        divTitle = this.cluster.getClusterer().getTitle();
      } else {
        divTitle = this.sums.title;
      }

      this.div.style.cursor = 'pointer';
      this.div.style.position = 'absolute';
      this.div.style.top = "".concat(pos.y, "px");
      this.div.style.left = "".concat(pos.x, "px");
      this.div.style.width = "".concat(this.width, "px");
      this.div.style.height = "".concat(this.height, "px");
      var img = document.createElement('img');
      img.alt = divTitle;
      img.src = this.url;
      img.style.position = 'absolute';
      img.style.top = "".concat(spriteV, "px");
      img.style.left = "".concat(spriteH, "px");

      if (!this.cluster.getClusterer().enableRetinaIcons) {
        img.style.clip = "rect(-".concat(spriteV, "px, -").concat(spriteH + this.width, "px, -").concat(spriteV + this.height, ", -").concat(spriteH, ")");
      }

      var textElm = document.createElement('div');
      textElm.style.position = 'absolute';
      textElm.style.top = "".concat(this.anchorText[0], "px");
      textElm.style.left = "".concat(this.anchorText[1], "px");
      textElm.style.color = this.textColor;
      textElm.style.fontSize = "".concat(this.textSize, "px");
      textElm.style.fontFamily = this.fontFamily;
      textElm.style.fontWeight = this.fontWeight;
      textElm.style.fontStyle = this.fontStyle;
      textElm.style.textDecoration = this.textDecoration;
      textElm.style.textAlign = 'center';
      textElm.style.width = "".concat(this.width, "px");
      textElm.style.lineHeight = "".concat(this.height, "px");
      textElm.innerText = "".concat((_a = this.sums) === null || _a === void 0 ? void 0 : _a.text);
      this.div.innerHTML = '';
      this.div.appendChild(img);
      this.div.appendChild(textElm);
      this.div.title = divTitle;
      this.div.style.display = '';
    }

    this.visible = true;
  };

  ClusterIcon.prototype.useStyle = function (sums) {
    this.sums = sums;
    var styles = this.cluster.getClusterer().getStyles();
    var style = styles[Math.min(styles.length - 1, Math.max(0, sums.index - 1))];
    this.url = style.url;
    this.height = style.height;
    this.width = style.width;
    if (style.className) this.className = "".concat(this.clusterClassName, " ").concat(style.className);
    this.anchorText = style.anchorText || [0, 0];
    this.anchorIcon = style.anchorIcon || [this.height / 2, this.width / 2];
    this.textColor = style.textColor || 'black';
    this.textSize = style.textSize || 11;
    this.textDecoration = style.textDecoration || 'none';
    this.fontWeight = style.fontWeight || 'bold';
    this.fontStyle = style.fontStyle || 'normal';
    this.fontFamily = style.fontFamily || 'Arial,sans-serif';
    this.backgroundPosition = style.backgroundPosition || '0 0';
  };

  ClusterIcon.prototype.setCenter = function (center) {
    this.center = center;
  };

  ClusterIcon.prototype.getPosFromLatLng = function (latlng) {
    // @ts-ignore
    var pos = this.getProjection().fromLatLngToDivPixel(latlng);
    pos.x -= this.anchorIcon[1];
    pos.y -= this.anchorIcon[0]; // pos.x = pos.x
    // pos.y = pos.y

    return pos;
  };

  return ClusterIcon;
}();

var Cluster$1 =
/** @class */
function () {
  function Cluster(markerClusterer) {
    this.markerClusterer = markerClusterer; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    this.map = this.markerClusterer.getMap();
    this.gridSize = this.markerClusterer.getGridSize();
    this.minClusterSize = this.markerClusterer.getMinimumClusterSize();
    this.averageCenter = this.markerClusterer.getAverageCenter();
    this.markers = [];
    this.center = undefined;
    this.bounds = null;
    this.clusterIcon = new ClusterIcon(this, this.markerClusterer.getStyles());
  }

  Cluster.prototype.getSize = function () {
    return this.markers.length;
  };

  Cluster.prototype.getMarkers = function () {
    return this.markers;
  };

  Cluster.prototype.getCenter = function () {
    return this.center;
  };

  Cluster.prototype.getMap = function () {
    return this.map;
  };

  Cluster.prototype.getClusterer = function () {
    return this.markerClusterer;
  };

  Cluster.prototype.getBounds = function () {
    var bounds = new google.maps.LatLngBounds(this.center, this.center);
    var markers = this.getMarkers();

    for (var i = 0; i < markers.length; i++) {
      var position = markers[i].getPosition();

      if (position) {
        bounds.extend(position);
      }
    }

    return bounds;
  };

  Cluster.prototype.remove = function () {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.clusterIcon.setMap(null);
    this.markers = []; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    delete this.markers;
  };

  Cluster.prototype.addMarker = function (marker) {
    if (this.isMarkerAlreadyAdded(marker)) {
      return false;
    }

    if (!this.center) {
      var position = marker.getPosition();

      if (position) {
        this.center = position;
        this.calculateBounds();
      }
    } else {
      if (this.averageCenter) {
        var position = marker.getPosition();

        if (position) {
          var length_1 = this.markers.length + 1;
          this.center = new google.maps.LatLng((this.center.lat() * (length_1 - 1) + position.lat()) / length_1, (this.center.lng() * (length_1 - 1) + position.lng()) / length_1);
          this.calculateBounds();
        }
      }
    }

    marker.isAdded = true;
    this.markers.push(marker);
    var mCount = this.markers.length;
    var maxZoom = this.markerClusterer.getMaxZoom();
    var zoom = this.map.getZoom();

    if (maxZoom !== null && typeof zoom !== 'undefined' && zoom > maxZoom) {
      // Zoomed in past max zoom, so show the marker.
      if (marker.getMap() !== this.map) {
        marker.setMap(this.map);
      }
    } else if (mCount < this.minClusterSize) {
      // Min cluster size not reached so show the marker.
      if (marker.getMap() !== this.map) {
        marker.setMap(this.map);
      }
    } else if (mCount === this.minClusterSize) {
      // Hide the markers that were showing.
      for (var i = 0; i < mCount; i++) {
        this.markers[i].setMap(null);
      }
    } else {
      marker.setMap(null);
    }

    return true;
  };

  Cluster.prototype.isMarkerInClusterBounds = function (marker) {
    if (this.bounds !== null) {
      var position = marker.getPosition();

      if (position) {
        return this.bounds.contains(position);
      }
    }

    return false;
  };

  Cluster.prototype.calculateBounds = function () {
    this.bounds = this.markerClusterer.getExtendedBounds(new google.maps.LatLngBounds(this.center, this.center));
  };

  Cluster.prototype.updateIcon = function () {
    var mCount = this.markers.length;
    var maxZoom = this.markerClusterer.getMaxZoom();
    var zoom = this.map.getZoom();

    if (maxZoom !== null && typeof zoom !== 'undefined' && zoom > maxZoom) {
      this.clusterIcon.hide();
      return;
    }

    if (mCount < this.minClusterSize) {
      // Min cluster size not yet reached.
      this.clusterIcon.hide();
      return;
    }

    if (this.center) {
      this.clusterIcon.setCenter(this.center);
    }

    this.clusterIcon.useStyle(this.markerClusterer.getCalculator()(this.markers, this.markerClusterer.getStyles().length));
    this.clusterIcon.show();
  };

  Cluster.prototype.isMarkerAlreadyAdded = function (marker) {
    if (this.markers.includes) {
      return this.markers.includes(marker);
    }

    for (var i = 0; i < this.markers.length; i++) {
      if (marker === this.markers[i]) {
        return true;
      }
    }

    return false;
  };

  return Cluster;
}();
/* global google */

/**
 * Supports up to 9007199254740991 (Number.MAX_SAFE_INTEGER) markers
 * which is not a problem as max array length is 4294967296 (2**32)
 */


var CALCULATOR = function CALCULATOR(markers, numStyles) {
  var count = markers.length;
  var numberOfDigits = count.toString().length;
  var index = Math.min(numberOfDigits, numStyles);
  return {
    text: count.toString(),
    index: index,
    title: ''
  };
};

var BATCH_SIZE = 2000;
var BATCH_SIZE_IE = 500;
var IMAGE_PATH = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
var IMAGE_EXTENSION = 'png';
var IMAGE_SIZES = [53, 56, 66, 78, 90];
var CLUSTERER_CLASS = 'cluster';

var Clusterer =
/** @class */
function () {
  function Clusterer(map, optMarkers, optOptions) {
    if (optMarkers === void 0) {
      optMarkers = [];
    }

    if (optOptions === void 0) {
      optOptions = {};
    }

    this.extend(Clusterer, google.maps.OverlayView);
    this.markers = [];
    this.clusters = [];
    this.listeners = [];
    this.activeMap = null;
    this.ready = false;
    this.gridSize = optOptions.gridSize || 60;
    this.minClusterSize = optOptions.minimumClusterSize || 2;
    this.maxZoom = optOptions.maxZoom || null;
    this.styles = optOptions.styles || [];
    this.title = optOptions.title || '';
    this.zoomOnClick = true;

    if (optOptions.zoomOnClick !== undefined) {
      this.zoomOnClick = optOptions.zoomOnClick;
    }

    this.averageCenter = false;

    if (optOptions.averageCenter !== undefined) {
      this.averageCenter = optOptions.averageCenter;
    }

    this.ignoreHidden = false;

    if (optOptions.ignoreHidden !== undefined) {
      this.ignoreHidden = optOptions.ignoreHidden;
    }

    this.enableRetinaIcons = false;

    if (optOptions.enableRetinaIcons !== undefined) {
      this.enableRetinaIcons = optOptions.enableRetinaIcons;
    }

    this.imagePath = optOptions.imagePath || IMAGE_PATH;
    this.imageExtension = optOptions.imageExtension || IMAGE_EXTENSION;
    this.imageSizes = optOptions.imageSizes || IMAGE_SIZES;
    this.calculator = optOptions.calculator || CALCULATOR;
    this.batchSize = optOptions.batchSize || BATCH_SIZE;
    this.batchSizeIE = optOptions.batchSizeIE || BATCH_SIZE_IE;
    this.clusterClass = optOptions.clusterClass || CLUSTERER_CLASS;

    if (navigator.userAgent.toLowerCase().indexOf('msie') !== -1) {
      // Try to avoid IE timeout when processing a huge number of markers:
      this.batchSize = this.batchSizeIE;
    }

    this.timerRefStatic = null;
    this.setupStyles();
    this.addMarkers(optMarkers, true); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    this.setMap(map); // Note: this causes onAdd to be called
  }

  Clusterer.prototype.onAdd = function () {
    var _this = this; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore


    this.activeMap = this.getMap();
    this.ready = true;
    this.repaint(); // Add the map event listeners

    this.listeners = [google.maps.event.addListener( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.getMap(), 'zoom_changed', function () {
      _this.resetViewport(false); // Workaround for this Google bug: when map is at level 0 and "-" of
      // zoom slider is clicked, a "zoom_changed" event is fired even though
      // the map doesn't zoom out any further. In this situation, no "idle"
      // event is triggered so the cluster markers that have been removed
      // do not get redrawn. Same goes for a zoom in at maxZoom.


      if ( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      _this.getMap().getZoom() === (_this.get('minZoom') || 0) || // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      _this.getMap().getZoom() === _this.get('maxZoom')) {
        google.maps.event.trigger(_this, 'idle');
      }
    }), google.maps.event.addListener( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.getMap(), 'idle', function () {
      _this.redraw();
    })];
  };

  Clusterer.prototype.onRemove = function () {
    // Put all the managed markers back on the map:
    for (var i = 0; i < this.markers.length; i++) {
      if (this.markers[i].getMap() !== this.activeMap) {
        this.markers[i].setMap(this.activeMap);
      }
    } // Remove all clusters:


    for (var i = 0; i < this.clusters.length; i++) {
      this.clusters[i].remove();
    }

    this.clusters = []; // Remove map event listeners:

    for (var i = 0; i < this.listeners.length; i++) {
      google.maps.event.removeListener(this.listeners[i]);
    }

    this.listeners = [];
    this.activeMap = null;
    this.ready = false;
  }; // eslint-disable-next-line @typescript-eslint/no-empty-function


  Clusterer.prototype.draw = function () {};

  Clusterer.prototype.setupStyles = function () {
    if (this.styles.length > 0) {
      return;
    }

    for (var i = 0; i < this.imageSizes.length; i++) {
      this.styles.push({
        url: this.imagePath + (i + 1) + '.' + this.imageExtension,
        height: this.imageSizes[i],
        width: this.imageSizes[i]
      });
    }
  };

  Clusterer.prototype.fitMapToMarkers = function () {
    var markers = this.getMarkers();
    var bounds = new google.maps.LatLngBounds();

    for (var i = 0; i < markers.length; i++) {
      var position = markers[i].getPosition();

      if (position) {
        bounds.extend(position);
      }
    } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore


    this.getMap().fitBounds(bounds);
  };

  Clusterer.prototype.getGridSize = function () {
    return this.gridSize;
  };

  Clusterer.prototype.setGridSize = function (gridSize) {
    this.gridSize = gridSize;
  };

  Clusterer.prototype.getMinimumClusterSize = function () {
    return this.minClusterSize;
  };

  Clusterer.prototype.setMinimumClusterSize = function (minimumClusterSize) {
    this.minClusterSize = minimumClusterSize;
  };

  Clusterer.prototype.getMaxZoom = function () {
    return this.maxZoom;
  };

  Clusterer.prototype.setMaxZoom = function (maxZoom) {
    this.maxZoom = maxZoom;
  };

  Clusterer.prototype.getStyles = function () {
    return this.styles;
  };

  Clusterer.prototype.setStyles = function (styles) {
    this.styles = styles;
  };

  Clusterer.prototype.getTitle = function () {
    return this.title;
  };

  Clusterer.prototype.setTitle = function (title) {
    this.title = title;
  };

  Clusterer.prototype.getZoomOnClick = function () {
    return this.zoomOnClick;
  };

  Clusterer.prototype.setZoomOnClick = function (zoomOnClick) {
    this.zoomOnClick = zoomOnClick;
  };

  Clusterer.prototype.getAverageCenter = function () {
    return this.averageCenter;
  };

  Clusterer.prototype.setAverageCenter = function (averageCenter) {
    this.averageCenter = averageCenter;
  };

  Clusterer.prototype.getIgnoreHidden = function () {
    return this.ignoreHidden;
  };

  Clusterer.prototype.setIgnoreHidden = function (ignoreHidden) {
    this.ignoreHidden = ignoreHidden;
  };

  Clusterer.prototype.getEnableRetinaIcons = function () {
    return this.enableRetinaIcons;
  };

  Clusterer.prototype.setEnableRetinaIcons = function (enableRetinaIcons) {
    this.enableRetinaIcons = enableRetinaIcons;
  };

  Clusterer.prototype.getImageExtension = function () {
    return this.imageExtension;
  };

  Clusterer.prototype.setImageExtension = function (imageExtension) {
    this.imageExtension = imageExtension;
  };

  Clusterer.prototype.getImagePath = function () {
    return this.imagePath;
  };

  Clusterer.prototype.setImagePath = function (imagePath) {
    this.imagePath = imagePath;
  };

  Clusterer.prototype.getImageSizes = function () {
    return this.imageSizes;
  };

  Clusterer.prototype.setImageSizes = function (imageSizes) {
    this.imageSizes = imageSizes;
  };

  Clusterer.prototype.getCalculator = function () {
    return this.calculator;
  };

  Clusterer.prototype.setCalculator = function (calculator) {
    this.calculator = calculator;
  };

  Clusterer.prototype.getBatchSizeIE = function () {
    return this.batchSizeIE;
  };

  Clusterer.prototype.setBatchSizeIE = function (batchSizeIE) {
    this.batchSizeIE = batchSizeIE;
  };

  Clusterer.prototype.getClusterClass = function () {
    return this.clusterClass;
  };

  Clusterer.prototype.setClusterClass = function (clusterClass) {
    this.clusterClass = clusterClass;
  };

  Clusterer.prototype.getMarkers = function () {
    return this.markers;
  };

  Clusterer.prototype.getTotalMarkers = function () {
    return this.markers.length;
  };

  Clusterer.prototype.getClusters = function () {
    return this.clusters;
  };

  Clusterer.prototype.getTotalClusters = function () {
    return this.clusters.length;
  };

  Clusterer.prototype.addMarker = function (marker, optNoDraw) {
    this.pushMarkerTo(marker);

    if (!optNoDraw) {
      this.redraw();
    }
  };

  Clusterer.prototype.addMarkers = function (markers, optNoDraw) {
    for (var key in markers) {
      if (Object.prototype.hasOwnProperty.call(markers, key)) {
        this.pushMarkerTo(markers[key]);
      }
    }

    if (!optNoDraw) {
      this.redraw();
    }
  };

  Clusterer.prototype.pushMarkerTo = function (marker) {
    var _this = this; // If the marker is draggable add a listener so we can update the clusters on the dragend:


    if (marker.getDraggable()) {
      google.maps.event.addListener(marker, 'dragend', function () {
        if (_this.ready) {
          marker.isAdded = false;

          _this.repaint();
        }
      });
    }

    marker.isAdded = false;
    this.markers.push(marker);
  };

  Clusterer.prototype.removeMarker_ = function (marker) {
    var index = -1;

    if (this.markers.indexOf) {
      index = this.markers.indexOf(marker);
    } else {
      for (var i = 0; i < this.markers.length; i++) {
        if (marker === this.markers[i]) {
          index = i;
          break;
        }
      }
    }

    if (index === -1) {
      // Marker is not in our list of markers, so do nothing:
      return false;
    }

    marker.setMap(null);
    this.markers.splice(index, 1); // Remove the marker from the list of managed markers

    return true;
  };

  Clusterer.prototype.removeMarker = function (marker, optNoDraw) {
    var removed = this.removeMarker_(marker);

    if (!optNoDraw && removed) {
      this.repaint();
    }

    return removed;
  };

  Clusterer.prototype.removeMarkers = function (markers, optNoDraw) {
    var removed = false;

    for (var i = 0; i < markers.length; i++) {
      removed = removed || this.removeMarker_(markers[i]);
    }

    if (!optNoDraw && removed) {
      this.repaint();
    }

    return removed;
  };

  Clusterer.prototype.clearMarkers = function () {
    this.resetViewport(true);
    this.markers = [];
  };

  Clusterer.prototype.repaint = function () {
    var oldClusters = this.clusters.slice();
    this.clusters = [];
    this.resetViewport(false);
    this.redraw(); // Remove the old clusters.
    // Do it in a timeout to prevent blinking effect.

    setTimeout(function timeout() {
      for (var i = 0; i < oldClusters.length; i++) {
        oldClusters[i].remove();
      }
    }, 0);
  };

  Clusterer.prototype.getExtendedBounds = function (bounds) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var projection = this.getProjection(); // Convert the points to pixels and the extend out by the grid size.

    var trPix = projection.fromLatLngToDivPixel( // Turn the bounds into latlng.
    new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng()));
    trPix.x += this.gridSize;
    trPix.y -= this.gridSize;
    var blPix = projection.fromLatLngToDivPixel( // Turn the bounds into latlng.
    new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng()));
    blPix.x -= this.gridSize;
    blPix.y += this.gridSize; // Extend the bounds to contain the new bounds.

    bounds.extend( // Convert the pixel points back to LatLng nw
    projection.fromDivPixelToLatLng(trPix));
    bounds.extend( // Convert the pixel points back to LatLng sw
    projection.fromDivPixelToLatLng(blPix));
    return bounds;
  };

  Clusterer.prototype.redraw = function () {
    // Redraws all the clusters.
    this.createClusters(0);
  };

  Clusterer.prototype.resetViewport = function (optHide) {
    // Remove all the clusters
    for (var i = 0; i < this.clusters.length; i++) {
      this.clusters[i].remove();
    }

    this.clusters = []; // Reset the markers to not be added and to be removed from the map.

    for (var i = 0; i < this.markers.length; i++) {
      var marker = this.markers[i];
      marker.isAdded = false;

      if (optHide) {
        marker.setMap(null);
      }
    }
  };

  Clusterer.prototype.distanceBetweenPoints = function (p1, p2) {
    var R = 6371; // Radius of the Earth in km

    var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
    var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  };

  Clusterer.prototype.isMarkerInBounds = function (marker, bounds) {
    var position = marker.getPosition();

    if (position) {
      return bounds.contains(position);
    }

    return false;
  };

  Clusterer.prototype.addToClosestCluster = function (marker) {
    var cluster;
    var distance = 40000; // Some large number

    var clusterToAddTo = null;

    for (var i = 0; i < this.clusters.length; i++) {
      cluster = this.clusters[i];
      var center = cluster.getCenter();
      var position = marker.getPosition();

      if (center && position) {
        var d = this.distanceBetweenPoints(center, position);

        if (d < distance) {
          distance = d;
          clusterToAddTo = cluster;
        }
      }
    }

    if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
      clusterToAddTo.addMarker(marker);
    } else {
      cluster = new Cluster$1(this);
      cluster.addMarker(marker);
      this.clusters.push(cluster);
    }
  };

  Clusterer.prototype.createClusters = function (iFirst) {
    var _this = this;

    if (!this.ready) {
      return;
    } // Cancel previous batch processing if we're working on the first batch:


    if (iFirst === 0) {
      /**
       * This event is fired when the <code>Clusterer</code> begins
       *  clustering markers.
       * @name Clusterer#clusteringbegin
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */
      google.maps.event.trigger(this, 'clusteringbegin', this);

      if (this.timerRefStatic !== null) {
        window.clearTimeout(this.timerRefStatic); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        delete this.timerRefStatic;
      }
    } // Get our current map view bounds.
    // Create a new bounds object so we don't affect the map.
    //
    // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:


    var mapBounds = // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.getMap().getZoom() > 3 ? new google.maps.LatLngBounds( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.getMap().getBounds().getSouthWest(), // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.getMap().getBounds().getNorthEast()) : new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
    var bounds = this.getExtendedBounds(mapBounds);
    var iLast = Math.min(iFirst + this.batchSize, this.markers.length);

    for (var i = iFirst; i < iLast; i++) {
      var marker = this.markers[i];

      if (!marker.isAdded && this.isMarkerInBounds(marker, bounds) && (!this.ignoreHidden || this.ignoreHidden && marker.getVisible())) {
        this.addToClosestCluster(marker);
      }
    }

    if (iLast < this.markers.length) {
      this.timerRefStatic = window.setTimeout(function () {
        _this.createClusters(iLast);
      }, 0);
    } else {
      this.timerRefStatic = null;
      /**
       * This event is fired when the <code>Clusterer</code> stops
       *  clustering markers.
       * @name Clusterer#clusteringend
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */

      google.maps.event.trigger(this, 'clusteringend', this);

      for (var i = 0; i < this.clusters.length; i++) {
        this.clusters[i].updateIcon();
      }
    }
  };

  Clusterer.prototype.extend = function (obj1, obj2) {
    return function applyExtend(object) {
      // eslint-disable-next-line guard-for-in
      for (var property in object.prototype) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.prototype[property] = object.prototype[property];
      } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore


      return this;
    }.apply(obj1, [obj2]);
  };

  return Clusterer;
}();

var eventMap$e = {
  onClick: 'click',
  onClusteringBegin: 'clusteringbegin',
  onClusteringEnd: 'clusteringend',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover'
};
var updaterMap$e = {
  averageCenter: function averageCenter(instance, _averageCenter) {
    instance.setAverageCenter(_averageCenter);
  },
  batchSizeIE: function batchSizeIE(instance, _batchSizeIE) {
    instance.setBatchSizeIE(_batchSizeIE);
  },
  calculator: function calculator(instance, _calculator) {
    instance.setCalculator(_calculator);
  },
  clusterClass: function clusterClass(instance, _clusterClass) {
    instance.setClusterClass(_clusterClass);
  },
  enableRetinaIcons: function enableRetinaIcons(instance, _enableRetinaIcons) {
    instance.setEnableRetinaIcons(_enableRetinaIcons);
  },
  gridSize: function gridSize(instance, _gridSize) {
    instance.setGridSize(_gridSize);
  },
  ignoreHidden: function ignoreHidden(instance, _ignoreHidden) {
    instance.setIgnoreHidden(_ignoreHidden);
  },
  imageExtension: function imageExtension(instance, _imageExtension) {
    instance.setImageExtension(_imageExtension);
  },
  imagePath: function imagePath(instance, _imagePath) {
    instance.setImagePath(_imagePath);
  },
  imageSizes: function imageSizes(instance, _imageSizes) {
    instance.setImageSizes(_imageSizes);
  },
  maxZoom: function maxZoom(instance, _maxZoom) {
    instance.setMaxZoom(_maxZoom);
  },
  minimumClusterSize: function minimumClusterSize(instance, _minimumClusterSize) {
    instance.setMinimumClusterSize(_minimumClusterSize);
  },
  styles: function styles(instance, _styles) {
    instance.setStyles(_styles);
  },
  title: function title(instance, _title2) {
    instance.setTitle(_title2);
  },
  zoomOnClick: function zoomOnClick(instance, _zoomOnClick) {
    instance.setZoomOnClick(_zoomOnClick);
  }
};

function MarkerClustererFunctional(_ref13) {
  var children = _ref13.children;

  var _useState97 = useState(null),
      _useState98 = _slicedToArray(_useState97, 1),
      instance
  /* setInstance */
  = _useState98[0]; // TODO!


  return instance !== null ? children(instance) || null : null;
}

memo(MarkerClustererFunctional);

var ClustererComponent = /*#__PURE__*/function (_PureComponent8) {
  _inherits(ClustererComponent, _PureComponent8);

  function ClustererComponent() {
    var _this15;

    _classCallCheck(this, ClustererComponent);

    _this15 = _possibleConstructorReturn(this, _getPrototypeOf(ClustererComponent).apply(this, arguments));
    _this15.registeredEvents = [];
    _this15.state = {
      markerClusterer: null
    };

    _this15.setClustererCallback = function () {
      if (_this15.state.markerClusterer !== null && _this15.props.onLoad) {
        _this15.props.onLoad(_this15.state.markerClusterer);
      }
    };

    return _this15;
  }

  _createClass(ClustererComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.context) {
        var markerClusterer = new Clusterer(this.context, [], this.props.options);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$e,
          eventMap: eventMap$e,
          prevProps: {},
          nextProps: this.props,
          instance: markerClusterer
        });
        this.setState(function () {
          return {
            markerClusterer: markerClusterer
          };
        }, this.setClustererCallback);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.markerClusterer) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$e,
          eventMap: eventMap$e,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.markerClusterer
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.markerClusterer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.markerClusterer);
        }

        unregisterEvents(this.registeredEvents); // @ts-ignore

        this.state.markerClusterer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.markerClusterer !== null ? this.props.children(this.state.markerClusterer) : null;
    }
  }]);

  return ClustererComponent;
}(PureComponent);

ClustererComponent.contextType = MapContext;

var InfoBox =
/** @class */
function () {
  function InfoBox(options) {
    if (options === void 0) {
      options = {};
    }

    this.extend(InfoBox, google.maps.OverlayView); // Standard options (in common with google.maps.InfoWindow):

    this.content = options.content || '';
    this.disableAutoPan = options.disableAutoPan || false;
    this.maxWidth = options.maxWidth || 0;
    this.pixelOffset = options.pixelOffset || new google.maps.Size(0, 0);
    this.position = options.position || new google.maps.LatLng(0, 0);
    this.zIndex = options.zIndex || null; // Additional options (unique to InfoBox):

    this.boxClass = options.boxClass || 'infoBox';
    this.boxStyle = options.boxStyle || {};
    this.closeBoxMargin = options.closeBoxMargin || '2px';
    this.closeBoxURL = options.closeBoxURL || 'http://www.google.com/intl/en_us/mapfiles/close.gif';

    if (options.closeBoxURL === '') {
      this.closeBoxURL = '';
    }

    this.infoBoxClearance = options.infoBoxClearance || new google.maps.Size(1, 1);

    if (typeof options.visible === 'undefined') {
      if (typeof options.isHidden === 'undefined') {
        options.visible = true;
      } else {
        options.visible = !options.isHidden;
      }
    }

    this.isHidden = !options.visible;
    this.alignBottom = options.alignBottom || false;
    this.pane = options.pane || 'floatPane';
    this.enableEventPropagation = options.enableEventPropagation || false;
    this.div = null;
    this.closeListener = null;
    this.moveListener = null;
    this.mapListener = null;
    this.contextListener = null;
    this.eventListeners = null;
    this.fixedWidthSet = null;
  }

  InfoBox.prototype.createInfoBoxDiv = function () {
    var _this = this; // This handler prevents an event in the InfoBox from being passed on to the map.


    function cancelHandler(event) {
      event.cancelBubble = true;

      if (event.stopPropagation) {
        event.stopPropagation();
      }
    } // This handler ignores the current event in the InfoBox and conditionally prevents
    // the event from being passed on to the map. It is used for the contextmenu event.


    var ignoreHandler = function ignoreHandler(event) {
      event.returnValue = false;

      if (event.preventDefault) {
        event.preventDefault();
      }

      if (!_this.enableEventPropagation) {
        cancelHandler(event);
      }
    };

    if (!this.div) {
      this.div = document.createElement('div');
      this.setBoxStyle();

      if (typeof this.content === 'string') {
        this.div.innerHTML = this.getCloseBoxImg() + this.content;
      } else {
        this.div.innerHTML = this.getCloseBoxImg();
        this.div.appendChild(this.content);
      } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore


      var panes = this.getPanes();
      panes[this.pane].appendChild(this.div); // Add the InfoBox div to the DOM

      this.addClickHandler();

      if (this.div.style.width) {
        this.fixedWidthSet = true;
      } else {
        if (this.maxWidth !== 0 && this.div.offsetWidth > this.maxWidth) {
          this.div.style.width = this.maxWidth + 'px';
          this.fixedWidthSet = true;
        } else {
          // The following code is needed to overcome problems with MSIE
          var bw = this.getBoxWidths();
          this.div.style.width = this.div.offsetWidth - bw.left - bw.right + 'px';
          this.fixedWidthSet = false;
        }
      }

      this.panBox(this.disableAutoPan);

      if (!this.enableEventPropagation) {
        this.eventListeners = []; // Cancel event propagation.
        // Note: mousemove not included (to resolve Issue 152)

        var events = ['mousedown', 'mouseover', 'mouseout', 'mouseup', 'click', 'dblclick', 'touchstart', 'touchend', 'touchmove'];

        for (var i = 0; i < events.length; i++) {
          this.eventListeners.push(google.maps.event.addListener(this.div, events[i], cancelHandler));
        } // Workaround for Google bug that causes the cursor to change to a pointer
        // when the mouse moves over a marker underneath InfoBox.


        this.eventListeners.push(google.maps.event.addListener(this.div, 'mouseover', function () {
          if (_this.div) {
            _this.div.style.cursor = 'default';
          }
        }));
      }

      this.contextListener = google.maps.event.addListener(this.div, 'contextmenu', ignoreHandler);
      /**
       * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
       * @name InfoBox#domready
       * @event
       */

      google.maps.event.trigger(this, 'domready');
    }
  };

  InfoBox.prototype.getCloseBoxImg = function () {
    var img = '';

    if (this.closeBoxURL !== '') {
      img = '<img alt=""';
      img += ' aria-hidden="true"';
      img += " src='" + this.closeBoxURL + "'";
      img += ' align=right'; // Do this because Opera chokes on style='float: right;'

      img += " style='";
      img += ' position: relative;'; // Required by MSIE

      img += ' cursor: pointer;';
      img += ' margin: ' + this.closeBoxMargin + ';';
      img += "'>";
    }

    return img;
  };

  InfoBox.prototype.addClickHandler = function () {
    if (this.div && this.div.firstChild && this.closeBoxURL !== '') {
      var closeBox = this.div.firstChild;
      this.closeListener = google.maps.event.addListener(closeBox, 'click', this.getCloseClickHandler());
    } else {
      this.closeListener = null;
    }
  };

  InfoBox.prototype.getCloseClickHandler = function () {
    var _this = this;

    return function (event) {
      // 1.0.3 fix: Always prevent propagation of a close box click to the map:
      event.cancelBubble = true;

      if (event.stopPropagation) {
        event.stopPropagation();
      }
      /**
       * This event is fired when the InfoBox's close box is clicked.
       * @name InfoBox#closeclick
       * @event
       */


      google.maps.event.trigger(_this, 'closeclick');

      _this.close();
    };
  };

  InfoBox.prototype.panBox = function (disablePan) {
    if (this.div && !disablePan) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var map = this.getMap(); // Only pan if attached to map, not panorama

      if (map instanceof google.maps.Map) {
        var xOffset = 0;
        var yOffset = 0;
        var bounds = map.getBounds();

        if (bounds && !bounds.contains(this.position)) {
          // Marker not in visible area of map, so set center
          // of map to the marker position first.
          map.setCenter(this.position);
        }

        var mapDiv = map.getDiv(); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        var mapWidth = mapDiv.offsetWidth; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        var mapHeight = mapDiv.offsetHeight;
        var iwOffsetX = this.pixelOffset.width;
        var iwOffsetY = this.pixelOffset.height;
        var iwWidth = this.div.offsetWidth;
        var iwHeight = this.div.offsetHeight;
        var padX = this.infoBoxClearance.width;
        var padY = this.infoBoxClearance.height; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        var projection = this.getProjection();
        var pixPosition = projection.fromLatLngToContainerPixel(this.position);

        if (pixPosition !== null) {
          if (pixPosition.x < -iwOffsetX + padX) {
            xOffset = pixPosition.x + iwOffsetX - padX;
          } else if (pixPosition.x + iwWidth + iwOffsetX + padX > mapWidth) {
            xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
          }

          if (this.alignBottom) {
            if (pixPosition.y < -iwOffsetY + padY + iwHeight) {
              yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
            } else if (pixPosition.y + iwOffsetY + padY > mapHeight) {
              yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
            }
          } else {
            if (pixPosition.y < -iwOffsetY + padY) {
              yOffset = pixPosition.y + iwOffsetY - padY;
            } else if (pixPosition.y + iwHeight + iwOffsetY + padY > mapHeight) {
              yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
            }
          }
        }

        if (!(xOffset === 0 && yOffset === 0)) {
          // Move the map to the shifted center.
          map.panBy(xOffset, yOffset);
        }
      }
    }
  };

  InfoBox.prototype.setBoxStyle = function () {
    if (this.div) {
      // Apply style values from the style sheet defined in the boxClass parameter:
      this.div.className = this.boxClass; // Clear existing inline style values:

      this.div.style.cssText = ''; // Apply style values defined in the boxStyle parameter:

      var boxStyle = this.boxStyle;

      for (var i in boxStyle) {
        if (Object.prototype.hasOwnProperty.call(boxStyle, i)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.div.style[i] = boxStyle[i];
        }
      } // Fix for iOS disappearing InfoBox problem
      // See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad


      this.div.style.webkitTransform = 'translateZ(0)'; // Fix up opacity style for benefit of MSIE

      if (typeof this.div.style.opacity !== 'undefined' && this.div.style.opacity !== '') {
        // See http://www.quirksmode.org/css/opacity.html
        var opacity = parseFloat(this.div.style.opacity || ''); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        this.div.style.msFilter = '"progid:DXImageTransform.Microsoft.Alpha(Opacity=' + opacity * 100 + ')"';
        this.div.style.filter = 'alpha(opacity=' + opacity * 100 + ')';
      } // Apply required styles


      this.div.style.position = 'absolute';
      this.div.style.visibility = 'hidden';

      if (this.zIndex !== null) {
        this.div.style.zIndex = this.zIndex + '';
      }

      if (!this.div.style.overflow) {
        this.div.style.overflow = 'auto';
      }
    }
  };

  InfoBox.prototype.getBoxWidths = function () {
    var bw = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };

    if (!this.div) {
      return bw;
    }

    if (document.defaultView) {
      var ownerDocument = this.div.ownerDocument;
      var computedStyle = ownerDocument && ownerDocument.defaultView ? ownerDocument.defaultView.getComputedStyle(this.div, '') : null;

      if (computedStyle) {
        // The computed styles are always in pixel units (good!)
        bw.top = parseInt(computedStyle.borderTopWidth || '', 10) || 0;
        bw.bottom = parseInt(computedStyle.borderBottomWidth || '', 10) || 0;
        bw.left = parseInt(computedStyle.borderLeftWidth || '', 10) || 0;
        bw.right = parseInt(computedStyle.borderRightWidth || '', 10) || 0;
      }
    } else if ( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    document.documentElement.currentStyle // MSIE
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var currentStyle = this.div.currentStyle;

      if (currentStyle) {
        // The current styles may not be in pixel units, but assume they are (bad!)
        bw.top = parseInt(currentStyle.borderTopWidth || '', 10) || 0;
        bw.bottom = parseInt(currentStyle.borderBottomWidth || '', 10) || 0;
        bw.left = parseInt(currentStyle.borderLeftWidth || '', 10) || 0;
        bw.right = parseInt(currentStyle.borderRightWidth || '', 10) || 0;
      }
    }

    return bw;
  };

  InfoBox.prototype.onRemove = function () {
    if (this.div && this.div.parentNode) {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  };

  InfoBox.prototype.draw = function () {
    this.createInfoBoxDiv();

    if (this.div) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var projection = this.getProjection();
      var pixPosition = projection.fromLatLngToDivPixel(this.position);

      if (pixPosition !== null) {
        this.div.style.left = pixPosition.x + this.pixelOffset.width + 'px';

        if (this.alignBottom) {
          this.div.style.bottom = -(pixPosition.y + this.pixelOffset.height) + 'px';
        } else {
          this.div.style.top = pixPosition.y + this.pixelOffset.height + 'px';
        }
      }

      if (this.isHidden) {
        this.div.style.visibility = 'hidden';
      } else {
        this.div.style.visibility = 'visible';
      }
    }
  };

  InfoBox.prototype.setOptions = function (options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof options.boxClass !== 'undefined') {
      // Must be first
      this.boxClass = options.boxClass;
      this.setBoxStyle();
    }

    if (typeof options.boxStyle !== 'undefined') {
      // Must be second
      this.boxStyle = options.boxStyle;
      this.setBoxStyle();
    }

    if (typeof options.content !== 'undefined') {
      this.setContent(options.content);
    }

    if (typeof options.disableAutoPan !== 'undefined') {
      this.disableAutoPan = options.disableAutoPan;
    }

    if (typeof options.maxWidth !== 'undefined') {
      this.maxWidth = options.maxWidth;
    }

    if (typeof options.pixelOffset !== 'undefined') {
      this.pixelOffset = options.pixelOffset;
    }

    if (typeof options.alignBottom !== 'undefined') {
      this.alignBottom = options.alignBottom;
    }

    if (typeof options.position !== 'undefined') {
      this.setPosition(options.position);
    }

    if (typeof options.zIndex !== 'undefined') {
      this.setZIndex(options.zIndex);
    }

    if (typeof options.closeBoxMargin !== 'undefined') {
      this.closeBoxMargin = options.closeBoxMargin;
    }

    if (typeof options.closeBoxURL !== 'undefined') {
      this.closeBoxURL = options.closeBoxURL;
    }

    if (typeof options.infoBoxClearance !== 'undefined') {
      this.infoBoxClearance = options.infoBoxClearance;
    }

    if (typeof options.isHidden !== 'undefined') {
      this.isHidden = options.isHidden;
    }

    if (typeof options.visible !== 'undefined') {
      this.isHidden = !options.visible;
    }

    if (typeof options.enableEventPropagation !== 'undefined') {
      this.enableEventPropagation = options.enableEventPropagation;
    }

    if (this.div) {
      this.draw();
    }
  };

  InfoBox.prototype.setContent = function (content) {
    this.content = content;

    if (this.div) {
      if (this.closeListener) {
        google.maps.event.removeListener(this.closeListener);
        this.closeListener = null;
      } // Odd code required to make things work with MSIE.


      if (!this.fixedWidthSet) {
        this.div.style.width = '';
      }

      if (typeof content === 'string') {
        this.div.innerHTML = this.getCloseBoxImg() + content;
      } else {
        this.div.innerHTML = this.getCloseBoxImg();
        this.div.appendChild(content);
      } // Perverse code required to make things work with MSIE.
      // (Ensures the close box does, in fact, float to the right.)


      if (!this.fixedWidthSet) {
        this.div.style.width = this.div.offsetWidth + 'px';

        if (typeof content === 'string') {
          this.div.innerHTML = this.getCloseBoxImg() + content;
        } else {
          this.div.innerHTML = this.getCloseBoxImg();
          this.div.appendChild(content);
        }
      }

      this.addClickHandler();
    }
    /**
     * This event is fired when the content of the InfoBox changes.
     * @name InfoBox#content_changed
     * @event
     */


    google.maps.event.trigger(this, 'content_changed');
  };

  InfoBox.prototype.setPosition = function (latLng) {
    this.position = latLng;

    if (this.div) {
      this.draw();
    }
    /**
     * This event is fired when the position of the InfoBox changes.
     * @name InfoBox#position_changed
     * @event
     */


    google.maps.event.trigger(this, 'position_changed');
  };

  InfoBox.prototype.setVisible = function (isVisible) {
    this.isHidden = !isVisible;

    if (this.div) {
      this.div.style.visibility = this.isHidden ? 'hidden' : 'visible';
    }
  };

  InfoBox.prototype.setZIndex = function (index) {
    this.zIndex = index;

    if (this.div) {
      this.div.style.zIndex = index + '';
    }
    /**
     * This event is fired when the zIndex of the InfoBox changes.
     * @name InfoBox#zindex_changed
     * @event
     */


    google.maps.event.trigger(this, 'zindex_changed');
  };

  InfoBox.prototype.getContent = function () {
    return this.content;
  };

  InfoBox.prototype.getPosition = function () {
    return this.position;
  };

  InfoBox.prototype.getZIndex = function () {
    return this.zIndex;
  };

  InfoBox.prototype.getVisible = function () {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var map = this.getMap();
    var isVisible;

    if (typeof map === 'undefined' || map === null) {
      isVisible = false;
    } else {
      isVisible = !this.isHidden;
    }

    return isVisible;
  };

  InfoBox.prototype.show = function () {
    this.isHidden = false;

    if (this.div) {
      this.div.style.visibility = 'visible';
    }
  };

  InfoBox.prototype.hide = function () {
    this.isHidden = true;

    if (this.div) {
      this.div.style.visibility = 'hidden';
    }
  };

  InfoBox.prototype.open = function (map, anchor) {
    var _this = this;

    if (anchor) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.position = anchor.getPosition();
      this.moveListener = google.maps.event.addListener(anchor, 'position_changed', function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var position = anchor.getPosition();

        _this.setPosition(position);
      });
      this.mapListener = google.maps.event.addListener(anchor, 'map_changed', function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        _this.setMap(anchor.map);
      });
    } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore


    this.setMap(map);

    if (this.div) {
      this.panBox();
    }
  };

  InfoBox.prototype.close = function () {
    if (this.closeListener) {
      google.maps.event.removeListener(this.closeListener);
      this.closeListener = null;
    }

    if (this.eventListeners) {
      for (var i = 0; i < this.eventListeners.length; i++) {
        google.maps.event.removeListener(this.eventListeners[i]);
      }

      this.eventListeners = null;
    }

    if (this.moveListener) {
      google.maps.event.removeListener(this.moveListener);
      this.moveListener = null;
    }

    if (this.mapListener) {
      google.maps.event.removeListener(this.mapListener);
      this.mapListener = null;
    }

    if (this.contextListener) {
      google.maps.event.removeListener(this.contextListener);
      this.contextListener = null;
    } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore


    this.setMap(null);
  };

  InfoBox.prototype.extend = function (obj1, obj2) {
    return function applyExtend(object) {
      // eslint-disable-next-line guard-for-in
      for (var property in object.prototype) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (!Object.prototype.hasOwnProperty.call(this, property)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.prototype[property] = object.prototype[property];
        }
      } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore


      return this;
    }.apply(obj1, [obj2]);
  };

  return InfoBox;
}();

var eventMap$d = {
  onCloseClick: 'closeclick',
  onContentChanged: 'content_changed',
  onDomReady: 'domready',
  onPositionChanged: 'position_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$d = {
  options: function options(instance, _options5) {
    instance.setOptions(_options5);
  },
  position: function position(instance, _position2) {
    if (_position2 instanceof google.maps.LatLng) {
      instance.setPosition(_position2);
    } else {
      instance.setPosition(new google.maps.LatLng(_position2.lat, _position2.lng));
    }
  },
  visible: function visible(instance, _visible2) {
    instance.setVisible(_visible2);
  },
  zIndex: function zIndex(instance, _zIndex2) {
    instance.setZIndex(_zIndex2);
  }
};
var defaultOptions$3 = {};

function InfoBoxFunctional(_ref14) {
  var children = _ref14.children,
      anchor = _ref14.anchor,
      options = _ref14.options,
      position = _ref14.position,
      zIndex = _ref14.zIndex,
      onCloseClick = _ref14.onCloseClick,
      onDomReady = _ref14.onDomReady,
      onContentChanged = _ref14.onContentChanged,
      onPositionChanged = _ref14.onPositionChanged,
      onZindexChanged = _ref14.onZindexChanged,
      onLoad = _ref14.onLoad,
      onUnmount = _ref14.onUnmount;
  var map = useContext(MapContext);

  var _useState99 = useState(null),
      _useState100 = _slicedToArray(_useState99, 2),
      instance = _useState100[0],
      setInstance = _useState100[1];

  var _useState101 = useState(null),
      _useState102 = _slicedToArray(_useState101, 2),
      closeclickListener = _useState102[0],
      setCloseClickListener = _useState102[1];

  var _useState103 = useState(null),
      _useState104 = _slicedToArray(_useState103, 2),
      domreadyclickListener = _useState104[0],
      setDomReadyClickListener = _useState104[1];

  var _useState105 = useState(null),
      _useState106 = _slicedToArray(_useState105, 2),
      contentchangedclickListener = _useState106[0],
      setContentChangedClickListener = _useState106[1];

  var _useState107 = useState(null),
      _useState108 = _slicedToArray(_useState107, 2),
      positionchangedclickListener = _useState108[0],
      setPositionChangedClickListener = _useState108[1];

  var _useState109 = useState(null),
      _useState110 = _slicedToArray(_useState109, 2),
      zindexchangedclickListener = _useState110[0],
      setZindexChangedClickListener = _useState110[1];

  var containerElementRef = useRef(null); // Order does matter

  useEffect(function () {
    if (map && instance !== null) {
      instance.close();

      if (anchor) {
        instance.open(map, anchor);
      } else if (instance.getPosition()) {
        instance.open(map);
      }
    }
  }, [map, instance, anchor]);
  useEffect(function () {
    if (options && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  useEffect(function () {
    if (position && instance !== null) {
      var positionLatLng = position instanceof google.maps.LatLng ? position // @ts-ignore
      : new google.maps.LatLng(position.lat, position.lng);
      instance.setPosition(positionLatLng);
    }
  }, [position]);
  useEffect(function () {
    if (typeof zIndex === 'number' && instance !== null) {
      instance.setZIndex(zIndex);
    }
  }, [zIndex]);
  useEffect(function () {
    if (instance && onCloseClick) {
      if (closeclickListener !== null) {
        google.maps.event.removeListener(closeclickListener);
      }

      setCloseClickListener(google.maps.event.addListener(instance, 'closeclick', onCloseClick));
    }
  }, [onCloseClick]);
  useEffect(function () {
    if (instance && onDomReady) {
      if (domreadyclickListener !== null) {
        google.maps.event.removeListener(domreadyclickListener);
      }

      setDomReadyClickListener(google.maps.event.addListener(instance, 'domready', onDomReady));
    }
  }, [onDomReady]);
  useEffect(function () {
    if (instance && onContentChanged) {
      if (contentchangedclickListener !== null) {
        google.maps.event.removeListener(contentchangedclickListener);
      }

      setContentChangedClickListener(google.maps.event.addListener(instance, 'content_changed', onContentChanged));
    }
  }, [onContentChanged]);
  useEffect(function () {
    if (instance && onPositionChanged) {
      if (positionchangedclickListener !== null) {
        google.maps.event.removeListener(positionchangedclickListener);
      }

      setPositionChangedClickListener(google.maps.event.addListener(instance, 'position_changed', onPositionChanged));
    }
  }, [onPositionChanged]);
  useEffect(function () {
    if (instance && onZindexChanged) {
      if (zindexchangedclickListener !== null) {
        google.maps.event.removeListener(zindexchangedclickListener);
      }

      setZindexChangedClickListener(google.maps.event.addListener(instance, 'zindex_changed', onZindexChanged));
    }
  }, [onZindexChanged]);
  useEffect(function () {
    if (map) {
      var _a = options || defaultOptions$3,
          _position3 = _a.position,
          infoBoxOptions = __rest$1(_a, ["position"]);

      var positionLatLng;

      if (_position3 && !(_position3 instanceof google.maps.LatLng)) {
        // @ts-ignore
        positionLatLng = new google.maps.LatLng(_position3.lat, _position3.lng);
      }

      var infoBox = new InfoBox(Object.assign(Object.assign({}, infoBoxOptions), positionLatLng ? {
        position: positionLatLng
      } : {}));
      containerElementRef.current = document.createElement('div');
      setInstance(infoBox);

      if (onCloseClick) {
        setCloseClickListener(google.maps.event.addListener(infoBox, 'circlecomplete', onCloseClick));
      }

      if (onDomReady) {
        setDomReadyClickListener(google.maps.event.addListener(infoBox, 'domready', onDomReady));
      }

      if (onContentChanged) {
        setContentChangedClickListener(google.maps.event.addListener(infoBox, 'content_changed', onContentChanged));
      }

      if (onPositionChanged) {
        setPositionChangedClickListener(google.maps.event.addListener(infoBox, 'position_changed', onPositionChanged));
      }

      if (onZindexChanged) {
        setZindexChangedClickListener(google.maps.event.addListener(infoBox, 'zindex_changed', onZindexChanged));
      }

      infoBox.setContent(containerElementRef.current);

      if (anchor) {
        infoBox.open(map, anchor);
      } else if (infoBox.getPosition()) {
        infoBox.open(map);
      } else {
        invariant_1(false, 'You must provide either an anchor or a position prop for <InfoBox>.');
      }

      if (onLoad) {
        onLoad(infoBox);
      }
    }

    return function () {
      if (instance !== null) {
        if (closeclickListener) {
          google.maps.event.removeListener(closeclickListener);
        }

        if (contentchangedclickListener) {
          google.maps.event.removeListener(contentchangedclickListener);
        }

        if (domreadyclickListener) {
          google.maps.event.removeListener(domreadyclickListener);
        }

        if (positionchangedclickListener) {
          google.maps.event.removeListener(positionchangedclickListener);
        }

        if (zindexchangedclickListener) {
          google.maps.event.removeListener(zindexchangedclickListener);
        }

        if (onUnmount) {
          onUnmount(instance);
        }

        instance.close();
      }
    };
  }, []);
  return containerElementRef.current ? createPortal(Children.only(children), containerElementRef.current) : null;
}

var InfoBoxF = memo(InfoBoxFunctional);

var InfoBoxComponent = /*#__PURE__*/function (_PureComponent9) {
  _inherits(InfoBoxComponent, _PureComponent9);

  function InfoBoxComponent() {
    var _this16;

    _classCallCheck(this, InfoBoxComponent);

    _this16 = _possibleConstructorReturn(this, _getPrototypeOf(InfoBoxComponent).apply(this, arguments));
    _this16.registeredEvents = [];
    _this16.containerElement = null;
    _this16.state = {
      infoBox: null
    };

    _this16.open = function (infoBox, anchor) {
      if (anchor) {
        // @ts-ignore
        infoBox.open(_this16.context, anchor);
      } else if (infoBox.getPosition()) {
        // @ts-ignore
        infoBox.open(_this16.context);
      } else {
        invariant_1(false, 'You must provide either an anchor or a position prop for <InfoBox>.');
      }
    };

    _this16.setInfoBoxCallback = function () {
      if (_this16.state.infoBox !== null && _this16.containerElement !== null) {
        _this16.state.infoBox.setContent(_this16.containerElement);

        _this16.open(_this16.state.infoBox, _this16.props.anchor);

        if (_this16.props.onLoad) {
          _this16.props.onLoad(_this16.state.infoBox);
        }
      }
    };

    return _this16;
  }

  _createClass(InfoBoxComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _a = this.props.options || {},
          position = _a.position,
          infoBoxOptions = __rest$1(_a, ["position"]);

      var positionLatLng;

      if (position && !(position instanceof google.maps.LatLng)) {
        // @ts-ignore
        positionLatLng = new google.maps.LatLng(position.lat, position.lng);
      }

      var infoBox = new InfoBox(Object.assign(Object.assign({}, infoBoxOptions), positionLatLng ? {
        position: positionLatLng
      } : {}));
      this.containerElement = document.createElement('div');
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$d,
        eventMap: eventMap$d,
        prevProps: {},
        nextProps: this.props,
        instance: infoBox
      });
      this.setState({
        infoBox: infoBox
      }, this.setInfoBoxCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var infoBox = this.state.infoBox;

      if (infoBox !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$d,
          eventMap: eventMap$d,
          prevProps: prevProps,
          nextProps: this.props,
          instance: infoBox
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var onUnmount = this.props.onUnmount;
      var infoBox = this.state.infoBox;

      if (infoBox !== null) {
        if (onUnmount) {
          onUnmount(infoBox);
        }

        unregisterEvents(this.registeredEvents);
        infoBox.close();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.containerElement ? createPortal(Children.only(this.props.children), this.containerElement) : null;
    }
  }]);

  return InfoBoxComponent;
}(PureComponent);

InfoBoxComponent.contextType = MapContext;
var kdbush = {
  exports: {}
};

(function (module, exports) {
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    function sortKD(ids, coords, nodeSize, left, right, depth) {
      if (right - left <= nodeSize) {
        return;
      }

      var m = left + right >> 1;
      select(ids, coords, m, left, right, depth % 2);
      sortKD(ids, coords, nodeSize, left, m - 1, depth + 1);
      sortKD(ids, coords, nodeSize, m + 1, right, depth + 1);
    }

    function select(ids, coords, k, left, right, inc) {
      while (right > left) {
        if (right - left > 600) {
          var n = right - left + 1;
          var m = k - left + 1;
          var z = Math.log(n);
          var s = 0.5 * Math.exp(2 * z / 3);
          var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
          var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
          var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
          select(ids, coords, k, newLeft, newRight, inc);
        }

        var t = coords[2 * k + inc];
        var i = left;
        var j = right;
        swapItem(ids, coords, left, k);

        if (coords[2 * right + inc] > t) {
          swapItem(ids, coords, left, right);
        }

        while (i < j) {
          swapItem(ids, coords, i, j);
          i++;
          j--;

          while (coords[2 * i + inc] < t) {
            i++;
          }

          while (coords[2 * j + inc] > t) {
            j--;
          }
        }

        if (coords[2 * left + inc] === t) {
          swapItem(ids, coords, left, j);
        } else {
          j++;
          swapItem(ids, coords, j, right);
        }

        if (j <= k) {
          left = j + 1;
        }

        if (k <= j) {
          right = j - 1;
        }
      }
    }

    function swapItem(ids, coords, i, j) {
      swap(ids, i, j);
      swap(coords, 2 * i, 2 * j);
      swap(coords, 2 * i + 1, 2 * j + 1);
    }

    function swap(arr, i, j) {
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }

    function range(ids, coords, minX, minY, maxX, maxY, nodeSize) {
      var stack = [0, ids.length - 1, 0];
      var result = [];
      var x, y;

      while (stack.length) {
        var axis = stack.pop();
        var right = stack.pop();
        var left = stack.pop();

        if (right - left <= nodeSize) {
          for (var i = left; i <= right; i++) {
            x = coords[2 * i];
            y = coords[2 * i + 1];

            if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
              result.push(ids[i]);
            }
          }

          continue;
        }

        var m = Math.floor((left + right) / 2);
        x = coords[2 * m];
        y = coords[2 * m + 1];

        if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
          result.push(ids[m]);
        }

        var nextAxis = (axis + 1) % 2;

        if (axis === 0 ? minX <= x : minY <= y) {
          stack.push(left);
          stack.push(m - 1);
          stack.push(nextAxis);
        }

        if (axis === 0 ? maxX >= x : maxY >= y) {
          stack.push(m + 1);
          stack.push(right);
          stack.push(nextAxis);
        }
      }

      return result;
    }

    function within(ids, coords, qx, qy, r, nodeSize) {
      var stack = [0, ids.length - 1, 0];
      var result = [];
      var r2 = r * r;

      while (stack.length) {
        var axis = stack.pop();
        var right = stack.pop();
        var left = stack.pop();

        if (right - left <= nodeSize) {
          for (var i = left; i <= right; i++) {
            if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) {
              result.push(ids[i]);
            }
          }

          continue;
        }

        var m = Math.floor((left + right) / 2);
        var x = coords[2 * m];
        var y = coords[2 * m + 1];

        if (sqDist(x, y, qx, qy) <= r2) {
          result.push(ids[m]);
        }

        var nextAxis = (axis + 1) % 2;

        if (axis === 0 ? qx - r <= x : qy - r <= y) {
          stack.push(left);
          stack.push(m - 1);
          stack.push(nextAxis);
        }

        if (axis === 0 ? qx + r >= x : qy + r >= y) {
          stack.push(m + 1);
          stack.push(right);
          stack.push(nextAxis);
        }
      }

      return result;
    }

    function sqDist(ax, ay, bx, by) {
      var dx = ax - bx;
      var dy = ay - by;
      return dx * dx + dy * dy;
    }

    var defaultGetX = function defaultGetX(p) {
      return p[0];
    };

    var defaultGetY = function defaultGetY(p) {
      return p[1];
    };

    var KDBush = function KDBush(points, getX, getY, nodeSize, ArrayType) {
      if (getX === void 0) getX = defaultGetX;
      if (getY === void 0) getY = defaultGetY;
      if (nodeSize === void 0) nodeSize = 64;
      if (ArrayType === void 0) ArrayType = Float64Array;
      this.nodeSize = nodeSize;
      this.points = points;
      var IndexArrayType = points.length < 65536 ? Uint16Array : Uint32Array;
      var ids = this.ids = new IndexArrayType(points.length);
      var coords = this.coords = new ArrayType(points.length * 2);

      for (var i = 0; i < points.length; i++) {
        ids[i] = i;
        coords[2 * i] = getX(points[i]);
        coords[2 * i + 1] = getY(points[i]);
      }

      sortKD(ids, coords, nodeSize, 0, ids.length - 1, 0);
    };

    KDBush.prototype.range = function range$1(minX, minY, maxX, maxY) {
      return range(this.ids, this.coords, minX, minY, maxX, maxY, this.nodeSize);
    };

    KDBush.prototype.within = function within$1(x, y, r) {
      return within(this.ids, this.coords, x, y, r, this.nodeSize);
    };

    return KDBush;
  });
})(kdbush);

var KDBush = kdbush.exports;
var defaultOptions$2 = {
  minZoom: 0,
  // min zoom to generate clusters on
  maxZoom: 16,
  // max zoom level to cluster the points on
  minPoints: 2,
  // minimum points to form a cluster
  radius: 40,
  // cluster radius in pixels
  extent: 512,
  // tile extent (radius is calculated relative to it)
  nodeSize: 64,
  // size of the KD-tree leaf node, affects performance
  log: false,
  // whether to log timing info
  // whether to generate numeric ids for input features (in vector tiles)
  generateId: false,
  // a reduce function for calculating custom cluster properties
  reduce: null,
  // (accumulated, props) => { accumulated.sum += props.sum; }
  // properties to use for individual points when running the reducer
  map: function map(props) {
    return props;
  } // props => ({sum: props.my_value})

};

var fround = Math.fround || function (tmp) {
  return function (x) {
    tmp[0] = +x;
    return tmp[0];
  };
}(new Float32Array(1));

var Supercluster = /*#__PURE__*/function () {
  function Supercluster(options) {
    _classCallCheck(this, Supercluster);

    this.options = extend$1(Object.create(defaultOptions$2), options);
    this.trees = new Array(this.options.maxZoom + 1);
  }

  _createClass(Supercluster, [{
    key: "load",
    value: function load(points) {
      var _this$options = this.options,
          log = _this$options.log,
          minZoom = _this$options.minZoom,
          maxZoom = _this$options.maxZoom,
          nodeSize = _this$options.nodeSize;
      if (log) console.time('total time');
      var timerId = "prepare ".concat(points.length, " points");
      if (log) console.time(timerId);
      this.points = points; // generate a cluster object for each point and index input points into a KD-tree

      var clusters = [];

      for (var i = 0; i < points.length; i++) {
        if (!points[i].geometry) continue;
        clusters.push(createPointCluster(points[i], i));
      }

      this.trees[maxZoom + 1] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);
      if (log) console.timeEnd(timerId); // cluster points on max zoom, then cluster the results on previous zoom, etc.;
      // results in a cluster hierarchy across zoom levels

      for (var z = maxZoom; z >= minZoom; z--) {
        var now = +Date.now(); // create a new set of clusters for the zoom and index them with a KD-tree

        clusters = this._cluster(clusters, z);
        this.trees[z] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);
        if (log) console.log('z%d: %d clusters in %dms', z, clusters.length, +Date.now() - now);
      }

      if (log) console.timeEnd('total time');
      return this;
    }
  }, {
    key: "getClusters",
    value: function getClusters(bbox, zoom) {
      var minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
      var minLat = Math.max(-90, Math.min(90, bbox[1]));
      var maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
      var maxLat = Math.max(-90, Math.min(90, bbox[3]));

      if (bbox[2] - bbox[0] >= 360) {
        minLng = -180;
        maxLng = 180;
      } else if (minLng > maxLng) {
        var easternHem = this.getClusters([minLng, minLat, 180, maxLat], zoom);
        var westernHem = this.getClusters([-180, minLat, maxLng, maxLat], zoom);
        return easternHem.concat(westernHem);
      }

      var tree = this.trees[this._limitZoom(zoom)];

      var ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
      var clusters = [];

      var _iterator = _createForOfIteratorHelper(ids),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var id = _step.value;
          var c = tree.points[id];
          clusters.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return clusters;
    }
  }, {
    key: "getChildren",
    value: function getChildren(clusterId) {
      var originId = this._getOriginId(clusterId);

      var originZoom = this._getOriginZoom(clusterId);

      var errorMsg = 'No cluster with the specified id.';
      var index = this.trees[originZoom];
      if (!index) throw new Error(errorMsg);
      var origin = index.points[originId];
      if (!origin) throw new Error(errorMsg);
      var r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
      var ids = index.within(origin.x, origin.y, r);
      var children = [];

      var _iterator2 = _createForOfIteratorHelper(ids),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var id = _step2.value;
          var c = index.points[id];

          if (c.parentId === clusterId) {
            children.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (children.length === 0) throw new Error(errorMsg);
      return children;
    }
  }, {
    key: "getLeaves",
    value: function getLeaves(clusterId, limit, offset) {
      limit = limit || 10;
      offset = offset || 0;
      var leaves = [];

      this._appendLeaves(leaves, clusterId, limit, offset, 0);

      return leaves;
    }
  }, {
    key: "getTile",
    value: function getTile(z, x, y) {
      var tree = this.trees[this._limitZoom(z)];

      var z2 = Math.pow(2, z);
      var _this$options2 = this.options,
          extent = _this$options2.extent,
          radius = _this$options2.radius;
      var p = radius / extent;
      var top = (y - p) / z2;
      var bottom = (y + 1 + p) / z2;
      var tile = {
        features: []
      };

      this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.points, x, y, z2, tile);

      if (x === 0) {
        this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.points, z2, y, z2, tile);
      }

      if (x === z2 - 1) {
        this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.points, -1, y, z2, tile);
      }

      return tile.features.length ? tile : null;
    }
  }, {
    key: "getClusterExpansionZoom",
    value: function getClusterExpansionZoom(clusterId) {
      var expansionZoom = this._getOriginZoom(clusterId) - 1;

      while (expansionZoom <= this.options.maxZoom) {
        var children = this.getChildren(clusterId);
        expansionZoom++;
        if (children.length !== 1) break;
        clusterId = children[0].properties.cluster_id;
      }

      return expansionZoom;
    }
  }, {
    key: "_appendLeaves",
    value: function _appendLeaves(result, clusterId, limit, offset, skipped) {
      var children = this.getChildren(clusterId);

      var _iterator3 = _createForOfIteratorHelper(children),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var child = _step3.value;
          var props = child.properties;

          if (props && props.cluster) {
            if (skipped + props.point_count <= offset) {
              // skip the whole cluster
              skipped += props.point_count;
            } else {
              // enter the cluster
              skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped); // exit the cluster
            }
          } else if (skipped < offset) {
            // skip a single point
            skipped++;
          } else {
            // add a single point
            result.push(child);
          }

          if (result.length === limit) break;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return skipped;
    }
  }, {
    key: "_addTileFeatures",
    value: function _addTileFeatures(ids, points, x, y, z2, tile) {
      var _iterator4 = _createForOfIteratorHelper(ids),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var i = _step4.value;
          var c = points[i];
          var isCluster = c.numPoints;
          var tags = void 0,
              px = void 0,
              py = void 0;

          if (isCluster) {
            tags = getClusterProperties(c);
            px = c.x;
            py = c.y;
          } else {
            var p = this.points[c.index];
            tags = p.properties;
            px = lngX(p.geometry.coordinates[0]);
            py = latY(p.geometry.coordinates[1]);
          }

          var f = {
            type: 1,
            geometry: [[Math.round(this.options.extent * (px * z2 - x)), Math.round(this.options.extent * (py * z2 - y))]],
            tags: tags
          }; // assign id

          var id = void 0;

          if (isCluster) {
            id = c.id;
          } else if (this.options.generateId) {
            // optionally generate id
            id = c.index;
          } else if (this.points[c.index].id) {
            // keep id if already assigned
            id = this.points[c.index].id;
          }

          if (id !== undefined) f.id = id;
          tile.features.push(f);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "_limitZoom",
    value: function _limitZoom(z) {
      return Math.max(this.options.minZoom, Math.min(+z, this.options.maxZoom + 1));
    }
  }, {
    key: "_cluster",
    value: function _cluster(points, zoom) {
      var clusters = [];
      var _this$options3 = this.options,
          radius = _this$options3.radius,
          extent = _this$options3.extent,
          reduce = _this$options3.reduce,
          minPoints = _this$options3.minPoints;
      var r = radius / (extent * Math.pow(2, zoom)); // loop through each point

      for (var i = 0; i < points.length; i++) {
        var p = points[i]; // if we've already visited the point at this zoom level, skip it

        if (p.zoom <= zoom) continue;
        p.zoom = zoom; // find all nearby points

        var tree = this.trees[zoom + 1];
        var neighborIds = tree.within(p.x, p.y, r);
        var numPointsOrigin = p.numPoints || 1;
        var numPoints = numPointsOrigin; // count the number of points in a potential cluster

        var _iterator5 = _createForOfIteratorHelper(neighborIds),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _neighborId2 = _step5.value;
            var _b3 = tree.points[_neighborId2]; // filter out neighbors that are already processed

            if (_b3.zoom > zoom) numPoints += _b3.numPoints || 1;
          } // if there were neighbors to merge, and there are enough points to form a cluster

        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        if (numPoints > numPointsOrigin && numPoints >= minPoints) {
          var wx = p.x * numPointsOrigin;
          var wy = p.y * numPointsOrigin;
          var clusterProperties = reduce && numPointsOrigin > 1 ? this._map(p, true) : null; // encode both zoom and point index on which the cluster originated -- offset by total length of features

          var id = (i << 5) + (zoom + 1) + this.points.length;

          var _iterator6 = _createForOfIteratorHelper(neighborIds),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var neighborId = _step6.value;
              var b = tree.points[neighborId];
              if (b.zoom <= zoom) continue;
              b.zoom = zoom; // save the zoom (so it doesn't get processed twice)

              var numPoints2 = b.numPoints || 1;
              wx += b.x * numPoints2; // accumulate coordinates for calculating weighted center

              wy += b.y * numPoints2;
              b.parentId = id;

              if (reduce) {
                if (!clusterProperties) clusterProperties = this._map(p, true);
                reduce(clusterProperties, this._map(b));
              }
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          p.parentId = id;
          clusters.push(createCluster(wx / numPoints, wy / numPoints, id, numPoints, clusterProperties));
        } else {
          // left points as unclustered
          clusters.push(p);

          if (numPoints > 1) {
            var _iterator7 = _createForOfIteratorHelper(neighborIds),
                _step7;

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var _neighborId = _step7.value;
                var _b2 = tree.points[_neighborId];
                if (_b2.zoom <= zoom) continue;
                _b2.zoom = zoom;
                clusters.push(_b2);
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          }
        }
      }

      return clusters;
    } // get index of the point from which the cluster originated

  }, {
    key: "_getOriginId",
    value: function _getOriginId(clusterId) {
      return clusterId - this.points.length >> 5;
    } // get zoom of the point from which the cluster originated

  }, {
    key: "_getOriginZoom",
    value: function _getOriginZoom(clusterId) {
      return (clusterId - this.points.length) % 32;
    }
  }, {
    key: "_map",
    value: function _map(point, clone) {
      if (point.numPoints) {
        return clone ? extend$1({}, point.properties) : point.properties;
      }

      var original = this.points[point.index].properties;
      var result = this.options.map(original);
      return clone && result === original ? extend$1({}, result) : result;
    }
  }]);

  return Supercluster;
}();

function createCluster(x, y, id, numPoints, properties) {
  return {
    x: fround(x),
    // weighted cluster center; round for consistency with Float32Array index
    y: fround(y),
    zoom: Infinity,
    // the last zoom the cluster was processed at
    id: id,
    // encodes index of the first child of the cluster and its zoom level
    parentId: -1,
    // parent cluster id
    numPoints: numPoints,
    properties: properties
  };
}

function createPointCluster(p, id) {
  var _p$geometry$coordinat = _slicedToArray(p.geometry.coordinates, 2),
      x = _p$geometry$coordinat[0],
      y = _p$geometry$coordinat[1];

  return {
    x: fround(lngX(x)),
    // projected point coordinates
    y: fround(latY(y)),
    zoom: Infinity,
    // the last zoom the point was processed at
    index: id,
    // index of the source feature in the original input array,
    parentId: -1 // parent cluster id

  };
}

function getClusterJSON(cluster) {
  return {
    type: 'Feature',
    id: cluster.id,
    properties: getClusterProperties(cluster),
    geometry: {
      type: 'Point',
      coordinates: [xLng(cluster.x), yLat(cluster.y)]
    }
  };
}

function getClusterProperties(cluster) {
  var count = cluster.numPoints;
  var abbrev = count >= 10000 ? "".concat(Math.round(count / 1000), "k") : count >= 1000 ? "".concat(Math.round(count / 100) / 10, "k") : count;
  return extend$1(extend$1({}, cluster.properties), {
    cluster: true,
    cluster_id: cluster.id,
    point_count: count,
    point_count_abbreviated: abbrev
  });
} // longitude/latitude to spherical mercator in [0..1] range


function lngX(lng) {
  return lng / 360 + 0.5;
}

function latY(lat) {
  var sin = Math.sin(lat * Math.PI / 180);
  var y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
  return y < 0 ? 0 : y > 1 ? 1 : y;
} // spherical mercator to longitude/latitude


function xLng(x) {
  return (x - 0.5) * 360;
}

function yLat(y) {
  var y2 = (180 - y * 360) * Math.PI / 180;
  return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}

function extend$1(dest, src) {
  for (var id in src) {
    dest[id] = src[id];
  }

  return dest;
}

function getX(p) {
  return p.x;
}

function getY(p) {
  return p.y;
}

var HAS_WEAKSET_SUPPORT = typeof WeakSet === 'function';
var keys = Object.keys;
/**
 * are the values passed strictly equal or both NaN
 *
 * @param a the value to compare against
 * @param b the value to test
 * @returns are the values equal by the SameValueZero principle
 */

function sameValueZeroEqual(a, b) {
  return a === b || a !== a && b !== b;
}
/**
 * is the value a plain object
 *
 * @param value the value to test
 * @returns is the value a plain object
 */


function isPlainObject(value) {
  return value.constructor === Object || value.constructor == null;
}
/**
 * is the value promise-like (meaning it is thenable)
 *
 * @param value the value to test
 * @returns is the value promise-like
 */


function isPromiseLike(value) {
  return !!value && typeof value.then === 'function';
}
/**
 * is the value passed a react element
 *
 * @param value the value to test
 * @returns is the value a react element
 */


function isReactElement(value) {
  return !!(value && value.$$typeof);
}
/**
 * in cases where WeakSet is not supported, creates a new custom
 * object that mimics the necessary API aspects for cache purposes
 *
 * @returns the new cache object
 */


function getNewCacheFallback() {
  var values = [];
  return {
    add: function add(value) {
      values.push(value);
    },
    has: function has(value) {
      return values.indexOf(value) !== -1;
    }
  };
}
/**
 * get a new cache object to prevent circular references
 *
 * @returns the new cache object
 */


var getNewCache = function (canUseWeakMap) {
  if (canUseWeakMap) {
    return function _getNewCache() {
      return new WeakSet();
    };
  }

  return getNewCacheFallback;
}(HAS_WEAKSET_SUPPORT);
/**
 * create a custom isEqual handler specific to circular objects
 *
 * @param [isEqual] the isEqual comparator to use instead of isDeepEqual
 * @returns the method to create the `isEqual` function
 */


function createCircularEqualCreator(isEqual) {
  return function createCircularEqual(comparator) {
    var _comparator = isEqual || comparator;

    return function circularEqual(a, b, indexOrKeyA, indexOrKeyB, parentA, parentB, cache) {
      if (cache === void 0) {
        cache = getNewCache();
      }

      var isCacheableA = !!a && typeof a === 'object';
      var isCacheableB = !!b && typeof b === 'object';

      if (isCacheableA || isCacheableB) {
        var hasA = isCacheableA && cache.has(a);
        var hasB = isCacheableB && cache.has(b);

        if (hasA || hasB) {
          return hasA && hasB;
        }

        if (isCacheableA) {
          cache.add(a);
        }

        if (isCacheableB) {
          cache.add(b);
        }
      }

      return _comparator(a, b, cache);
    };
  };
}
/**
 * are the arrays equal in value
 *
 * @param a the array to test
 * @param b the array to test against
 * @param isEqual the comparator to determine equality
 * @param meta the meta object to pass through
 * @returns are the arrays equal
 */


function areArraysEqual(a, b, isEqual, meta) {
  var index = a.length;

  if (b.length !== index) {
    return false;
  }

  while (index-- > 0) {
    if (!isEqual(a[index], b[index], index, index, a, b, meta)) {
      return false;
    }
  }

  return true;
}
/**
 * are the maps equal in value
 *
 * @param a the map to test
 * @param b the map to test against
 * @param isEqual the comparator to determine equality
 * @param meta the meta map to pass through
 * @returns are the maps equal
 */


function areMapsEqual(a, b, isEqual, meta) {
  var isValueEqual = a.size === b.size;

  if (isValueEqual && a.size) {
    var matchedIndices_1 = {};
    var indexA_1 = 0;
    a.forEach(function (aValue, aKey) {
      if (isValueEqual) {
        var hasMatch_1 = false;
        var matchIndexB_1 = 0;
        b.forEach(function (bValue, bKey) {
          if (!hasMatch_1 && !matchedIndices_1[matchIndexB_1]) {
            hasMatch_1 = isEqual(aKey, bKey, indexA_1, matchIndexB_1, a, b, meta) && isEqual(aValue, bValue, aKey, bKey, a, b, meta);

            if (hasMatch_1) {
              matchedIndices_1[matchIndexB_1] = true;
            }
          }

          matchIndexB_1++;
        });
        indexA_1++;
        isValueEqual = hasMatch_1;
      }
    });
  }

  return isValueEqual;
}

var OWNER = '_owner';
var hasOwnProperty = Function.prototype.bind.call(Function.prototype.call, Object.prototype.hasOwnProperty);
/**
 * are the objects equal in value
 *
 * @param a the object to test
 * @param b the object to test against
 * @param isEqual the comparator to determine equality
 * @param meta the meta object to pass through
 * @returns are the objects equal
 */

function areObjectsEqual(a, b, isEqual, meta) {
  var keysA = keys(a);
  var index = keysA.length;

  if (keys(b).length !== index) {
    return false;
  }

  if (index) {
    var key = void 0;

    while (index-- > 0) {
      key = keysA[index];

      if (key === OWNER) {
        var reactElementA = isReactElement(a);
        var reactElementB = isReactElement(b);

        if ((reactElementA || reactElementB) && reactElementA !== reactElementB) {
          return false;
        }
      }

      if (!hasOwnProperty(b, key) || !isEqual(a[key], b[key], key, key, a, b, meta)) {
        return false;
      }
    }
  }

  return true;
}
/**
 * are the regExps equal in value
 *
 * @param a the regExp to test
 * @param b the regExp to test agains
 * @returns are the regExps equal
 */


function areRegExpsEqual(a, b) {
  return a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.unicode === b.unicode && a.sticky === b.sticky && a.lastIndex === b.lastIndex;
}
/**
 * are the sets equal in value
 *
 * @param a the set to test
 * @param b the set to test against
 * @param isEqual the comparator to determine equality
 * @param meta the meta set to pass through
 * @returns are the sets equal
 */


function areSetsEqual(a, b, isEqual, meta) {
  var isValueEqual = a.size === b.size;

  if (isValueEqual && a.size) {
    var matchedIndices_2 = {};
    a.forEach(function (aValue, aKey) {
      if (isValueEqual) {
        var hasMatch_2 = false;
        var matchIndex_1 = 0;
        b.forEach(function (bValue, bKey) {
          if (!hasMatch_2 && !matchedIndices_2[matchIndex_1]) {
            hasMatch_2 = isEqual(aValue, bValue, aKey, bKey, a, b, meta);

            if (hasMatch_2) {
              matchedIndices_2[matchIndex_1] = true;
            }
          }

          matchIndex_1++;
        });
        isValueEqual = hasMatch_2;
      }
    });
  }

  return isValueEqual;
}

var HAS_MAP_SUPPORT = typeof Map === 'function';
var HAS_SET_SUPPORT = typeof Set === 'function';

function createComparator(createIsEqual) {
  var isEqual =
  /* eslint-disable no-use-before-define */
  typeof createIsEqual === 'function' ? createIsEqual(comparator) : function (a, b, indexOrKeyA, indexOrKeyB, parentA, parentB, meta) {
    return comparator(a, b, meta);
  };
  /* eslint-enable */

  /**
   * compare the value of the two objects and return true if they are equivalent in values
   *
   * @param a the value to test against
   * @param b the value to test
   * @param [meta] an optional meta object that is passed through to all equality test calls
   * @returns are a and b equivalent in value
   */

  function comparator(a, b, meta) {
    if (a === b) {
      return true;
    }

    if (a && b && typeof a === 'object' && typeof b === 'object') {
      if (isPlainObject(a) && isPlainObject(b)) {
        return areObjectsEqual(a, b, isEqual, meta);
      }

      var aShape = Array.isArray(a);
      var bShape = Array.isArray(b);

      if (aShape || bShape) {
        return aShape === bShape && areArraysEqual(a, b, isEqual, meta);
      }

      aShape = a instanceof Date;
      bShape = b instanceof Date;

      if (aShape || bShape) {
        return aShape === bShape && sameValueZeroEqual(a.getTime(), b.getTime());
      }

      aShape = a instanceof RegExp;
      bShape = b instanceof RegExp;

      if (aShape || bShape) {
        return aShape === bShape && areRegExpsEqual(a, b);
      }

      if (isPromiseLike(a) || isPromiseLike(b)) {
        return a === b;
      }

      if (HAS_MAP_SUPPORT) {
        aShape = a instanceof Map;
        bShape = b instanceof Map;

        if (aShape || bShape) {
          return aShape === bShape && areMapsEqual(a, b, isEqual, meta);
        }
      }

      if (HAS_SET_SUPPORT) {
        aShape = a instanceof Set;
        bShape = b instanceof Set;

        if (aShape || bShape) {
          return aShape === bShape && areSetsEqual(a, b, isEqual, meta);
        }
      }

      return areObjectsEqual(a, b, isEqual, meta);
    }

    return a !== a && b !== b;
  }

  return comparator;
}

var deepEqual = createComparator();
createComparator(function () {
  return sameValueZeroEqual;
});
createComparator(createCircularEqualCreator());
createComparator(createCircularEqualCreator(sameValueZeroEqual));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Cluster = /*#__PURE__*/function () {
  function Cluster(_ref15) {
    var markers = _ref15.markers,
        position = _ref15.position;

    _classCallCheck(this, Cluster);

    this.markers = markers;

    if (position) {
      if (position instanceof google.maps.LatLng) {
        this._position = position;
      } else {
        this._position = new google.maps.LatLng(position);
      }
    }
  }

  _createClass(Cluster, [{
    key: "push",

    /**
     * Add a marker to the cluster.
     */
    value: function push(marker) {
      this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */

  }, {
    key: "delete",
    value: function _delete() {
      if (this.marker) {
        this.marker.setMap(null);
        delete this.marker;
      }

      this.markers.length = 0;
    }
  }, {
    key: "bounds",
    get: function get() {
      if (this.markers.length === 0 && !this._position) {
        return undefined;
      }

      return this.markers.reduce(function (bounds, marker) {
        return bounds.extend(marker.getPosition());
      }, new google.maps.LatLngBounds(this._position, this._position));
    }
  }, {
    key: "position",
    get: function get() {
      return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */

  }, {
    key: "count",
    get: function get() {
      return this.markers.filter(function (m) {
        return m.getVisible();
      }).length;
    }
  }]);

  return Cluster;
}();
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var filterMarkersToPaddedViewport = function filterMarkersToPaddedViewport(map, mapCanvasProjection, markers, viewportPadding) {
  var extendedMapBounds = extendBoundsToPaddedViewport(map.getBounds(), mapCanvasProjection, viewportPadding);
  return markers.filter(function (marker) {
    return extendedMapBounds.contains(marker.getPosition());
  });
};
/**
 * Extends a bounds by a number of pixels in each direction.
 */


var extendBoundsToPaddedViewport = function extendBoundsToPaddedViewport(bounds, projection, pixels) {
  var _latLngBoundsToPixelB = latLngBoundsToPixelBounds(bounds, projection),
      northEast = _latLngBoundsToPixelB.northEast,
      southWest = _latLngBoundsToPixelB.southWest;

  var extendedPixelBounds = extendPixelBounds({
    northEast: northEast,
    southWest: southWest
  }, pixels);
  return pixelBoundsToLatLngBounds(extendedPixelBounds, projection);
};
/**
 * @hidden
 */


var distanceBetweenPoints = function distanceBetweenPoints(p1, p2) {
  var R = 6371; // Radius of the Earth in km

  var dLat = (p2.lat - p1.lat) * Math.PI / 180;
  var dLon = (p2.lng - p1.lng) * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};
/**
 * @hidden
 */


var latLngBoundsToPixelBounds = function latLngBoundsToPixelBounds(bounds, projection) {
  return {
    northEast: projection.fromLatLngToDivPixel(bounds.getNorthEast()),
    southWest: projection.fromLatLngToDivPixel(bounds.getSouthWest())
  };
};
/**
 * @hidden
 */


var extendPixelBounds = function extendPixelBounds(_ref16, pixels) {
  var northEast = _ref16.northEast,
      southWest = _ref16.southWest;
  northEast.x += pixels;
  northEast.y -= pixels;
  southWest.x -= pixels;
  southWest.y += pixels;
  return {
    northEast: northEast,
    southWest: southWest
  };
};
/**
 * @hidden
 */


var pixelBoundsToLatLngBounds = function pixelBoundsToLatLngBounds(_ref17, projection) {
  var northEast = _ref17.northEast,
      southWest = _ref17.southWest;
  var bounds = new google.maps.LatLngBounds();
  bounds.extend(projection.fromDivPixelToLatLng(northEast));
  bounds.extend(projection.fromDivPixelToLatLng(southWest));
  return bounds;
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @hidden
 */


var AbstractAlgorithm = /*#__PURE__*/function () {
  function AbstractAlgorithm(_ref18) {
    var _ref18$maxZoom = _ref18.maxZoom,
        maxZoom = _ref18$maxZoom === void 0 ? 16 : _ref18$maxZoom;

    _classCallCheck(this, AbstractAlgorithm);

    this.maxZoom = maxZoom;
  }
  /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers, map})
   *    }
   * }
   * ```
   */


  _createClass(AbstractAlgorithm, [{
    key: "noop",
    value: function noop(_ref19) {
      var markers = _ref19.markers;
      return noop$1(markers);
    }
  }]);

  return AbstractAlgorithm;
}();
/**
 * Abstract viewport algorithm proves a class to filter markers by a padded
 * viewport. This is a common optimization.
 *
 * @hidden
 */


var AbstractViewportAlgorithm = /*#__PURE__*/function (_AbstractAlgorithm) {
  _inherits(AbstractViewportAlgorithm, _AbstractAlgorithm);

  function AbstractViewportAlgorithm(_a) {
    var _this17;

    _classCallCheck(this, AbstractViewportAlgorithm);

    var _a$viewportPadding = _a.viewportPadding,
        viewportPadding = _a$viewportPadding === void 0 ? 60 : _a$viewportPadding,
        options = __rest(_a, ["viewportPadding"]);

    _this17 = _possibleConstructorReturn(this, _getPrototypeOf(AbstractViewportAlgorithm).call(this, options));
    _this17.viewportPadding = 60;
    _this17.viewportPadding = viewportPadding;
    return _this17;
  }

  _createClass(AbstractViewportAlgorithm, [{
    key: "calculate",
    value: function calculate(_ref20) {
      var markers = _ref20.markers,
          map = _ref20.map,
          mapCanvasProjection = _ref20.mapCanvasProjection;

      if (map.getZoom() >= this.maxZoom) {
        return {
          clusters: this.noop({
            markers: markers,
            map: map,
            mapCanvasProjection: mapCanvasProjection
          }),
          changed: false
        };
      }

      return {
        clusters: this.cluster({
          markers: filterMarkersToPaddedViewport(map, mapCanvasProjection, markers, this.viewportPadding),
          map: map,
          mapCanvasProjection: mapCanvasProjection
        })
      };
    }
  }]);

  return AbstractViewportAlgorithm;
}(AbstractAlgorithm);
/**
 * @hidden
 */


var noop$1 = function noop$1(markers) {
  var clusters = markers.map(function (marker) {
    return new Cluster({
      position: marker.getPosition(),
      markers: [marker]
    });
  });
  return clusters;
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The default Grid algorithm historically used in Google Maps marker
 * clustering.
 *
 * The Grid algorithm does not implement caching and markers may flash as the
 * viewport changes. Instead use {@link SuperClusterAlgorithm}.
 */


var GridAlgorithm = /*#__PURE__*/function (_AbstractViewportAlgo) {
  _inherits(GridAlgorithm, _AbstractViewportAlgo);

  function GridAlgorithm(_a) {
    var _this18;

    _classCallCheck(this, GridAlgorithm);

    var _a$maxDistance = _a.maxDistance,
        maxDistance = _a$maxDistance === void 0 ? 40000 : _a$maxDistance,
        _a$gridSize = _a.gridSize,
        gridSize = _a$gridSize === void 0 ? 40 : _a$gridSize,
        options = __rest(_a, ["maxDistance", "gridSize"]);

    _this18 = _possibleConstructorReturn(this, _getPrototypeOf(GridAlgorithm).call(this, options));
    _this18.clusters = [];
    _this18.maxDistance = maxDistance;
    _this18.gridSize = gridSize;
    return _this18;
  }

  _createClass(GridAlgorithm, [{
    key: "cluster",
    value: function cluster(_ref21) {
      var _this19 = this;

      var markers = _ref21.markers,
          map = _ref21.map,
          mapCanvasProjection = _ref21.mapCanvasProjection;
      this.clusters = [];
      markers.forEach(function (marker) {
        _this19.addToClosestCluster(marker, map, mapCanvasProjection);
      });
      return this.clusters;
    }
  }, {
    key: "addToClosestCluster",
    value: function addToClosestCluster(marker, map, projection) {
      var maxDistance = this.maxDistance; // Some large number

      var cluster = null;

      for (var i = 0; i < this.clusters.length; i++) {
        var candidate = this.clusters[i];
        var distance = distanceBetweenPoints(candidate.bounds.getCenter().toJSON(), marker.getPosition().toJSON());

        if (distance < maxDistance) {
          maxDistance = distance;
          cluster = candidate;
        }
      }

      if (cluster && extendBoundsToPaddedViewport(cluster.bounds, projection, this.gridSize).contains(marker.getPosition())) {
        cluster.push(marker);
      } else {
        var _cluster2 = new Cluster({
          markers: [marker]
        });

        this.clusters.push(_cluster2);
      }
    }
  }]);

  return GridAlgorithm;
}(AbstractViewportAlgorithm);
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Noop algorithm does not generate any clusters or filter markers by the an extended viewport.
 */


var NoopAlgorithm = /*#__PURE__*/function (_AbstractAlgorithm2) {
  _inherits(NoopAlgorithm, _AbstractAlgorithm2);

  function NoopAlgorithm(_a) {
    _classCallCheck(this, NoopAlgorithm);

    var options = __rest(_a, []);

    return _possibleConstructorReturn(this, _getPrototypeOf(NoopAlgorithm).call(this, options));
  }

  _createClass(NoopAlgorithm, [{
    key: "calculate",
    value: function calculate(_ref22) {
      var markers = _ref22.markers,
          map = _ref22.map,
          mapCanvasProjection = _ref22.mapCanvasProjection;
      return {
        clusters: this.cluster({
          markers: markers,
          map: map,
          mapCanvasProjection: mapCanvasProjection
        }),
        changed: false
      };
    }
  }, {
    key: "cluster",
    value: function cluster(input) {
      return this.noop(input);
    }
  }]);

  return NoopAlgorithm;
}(AbstractAlgorithm);
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */


var SuperClusterAlgorithm = /*#__PURE__*/function (_AbstractAlgorithm3) {
  _inherits(SuperClusterAlgorithm, _AbstractAlgorithm3);

  function SuperClusterAlgorithm(_a) {
    var _this20;

    _classCallCheck(this, SuperClusterAlgorithm);

    var maxZoom = _a.maxZoom,
        _a$radius = _a.radius,
        radius = _a$radius === void 0 ? 60 : _a$radius,
        options = __rest(_a, ["maxZoom", "radius"]);

    _this20 = _possibleConstructorReturn(this, _getPrototypeOf(SuperClusterAlgorithm).call(this, {
      maxZoom: maxZoom
    }));
    _this20.superCluster = new Supercluster(Object.assign({
      maxZoom: _this20.maxZoom,
      radius: radius
    }, options));
    _this20.state = {
      zoom: null
    };
    return _this20;
  }

  _createClass(SuperClusterAlgorithm, [{
    key: "calculate",
    value: function calculate(input) {
      var changed = false;

      if (!deepEqual(input.markers, this.markers)) {
        changed = true; // TODO use proxy to avoid copy?

        this.markers = _toConsumableArray(input.markers);
        var points = this.markers.map(function (marker) {
          return {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [marker.getPosition().lng(), marker.getPosition().lat()]
            },
            properties: {
              marker: marker
            }
          };
        });
        this.superCluster.load(points);
      }

      var state = {
        zoom: input.map.getZoom()
      };

      if (!changed) {
        if (this.state.zoom > this.maxZoom && state.zoom > this.maxZoom) ;else {
          changed = changed || !deepEqual(this.state, state);
        }
      }

      this.state = state;

      if (changed) {
        this.clusters = this.cluster(input);
      }

      return {
        clusters: this.clusters,
        changed: changed
      };
    }
  }, {
    key: "cluster",
    value: function cluster(_ref23) {
      var map = _ref23.map;
      return this.superCluster.getClusters([-180, -90, 180, 90], Math.round(map.getZoom())).map(this.transformCluster.bind(this));
    }
  }, {
    key: "transformCluster",
    value: function transformCluster(_ref24) {
      var _ref24$geometry$coord = _slicedToArray(_ref24.geometry.coordinates, 2),
          lng = _ref24$geometry$coord[0],
          lat = _ref24$geometry$coord[1],
          properties = _ref24.properties;

      if (properties.cluster) {
        return new Cluster({
          markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map(function (leaf) {
            return leaf.properties.marker;
          }),
          position: new google.maps.LatLng({
            lat: lat,
            lng: lng
          })
        });
      } else {
        var marker = properties.marker;
        return new Cluster({
          markers: [marker],
          position: marker.getPosition()
        });
      }
    }
  }]);

  return SuperClusterAlgorithm;
}(AbstractAlgorithm);
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */


var ClusterStats = function ClusterStats(markers, clusters) {
  _classCallCheck(this, ClusterStats);

  this.markers = {
    sum: markers.length
  };
  var clusterMarkerCounts = clusters.map(function (a) {
    return a.count;
  });
  var clusterMarkerSum = clusterMarkerCounts.reduce(function (a, b) {
    return a + b;
  }, 0);
  this.clusters = {
    count: clusters.length,
    markers: {
      mean: clusterMarkerSum / clusters.length,
      sum: clusterMarkerSum,
      min: Math.min.apply(Math, _toConsumableArray(clusterMarkerCounts)),
      max: Math.max.apply(Math, _toConsumableArray(clusterMarkerCounts))
    }
  };
};

var DefaultRenderer = /*#__PURE__*/function () {
  function DefaultRenderer() {
    _classCallCheck(this, DefaultRenderer);
  }

  _createClass(DefaultRenderer, [{
    key: "render",

    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */
    value: function render(_ref25, stats) {
      var count = _ref25.count,
          position = _ref25.position;
      // change color if this cluster has more markers than the mean cluster
      var color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff"; // create svg url with fill color

      var svg = window.btoa("\n  <svg fill=\"".concat(color, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 240 240\">\n    <circle cx=\"120\" cy=\"120\" opacity=\".6\" r=\"70\" />\n    <circle cx=\"120\" cy=\"120\" opacity=\".3\" r=\"90\" />\n    <circle cx=\"120\" cy=\"120\" opacity=\".2\" r=\"110\" />\n  </svg>")); // create marker using svg icon

      return new google.maps.Marker({
        position: position,
        icon: {
          url: "data:image/svg+xml;base64,".concat(svg),
          scaledSize: new google.maps.Size(45, 45)
        },
        label: {
          text: String(count),
          color: "rgba(255,255,255,0.9)",
          fontSize: "12px"
        },
        title: "Cluster of ".concat(count, " markers"),
        // adjust zIndex to be above other markers
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
      });
    }
  }]);

  return DefaultRenderer;
}();
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any


function extend(type1, type2) {
  /* istanbul ignore next */
  // eslint-disable-next-line prefer-const
  for (var property in type2.prototype) {
    type1.prototype[property] = type2.prototype[property];
  }
}
/**
 * @ignore
 */


var OverlayViewSafe = function OverlayViewSafe() {
  _classCallCheck(this, OverlayViewSafe);

  // MarkerClusterer implements google.maps.OverlayView interface. We use the
  // extend function to extend MarkerClusterer with google.maps.OverlayView
  // because it might not always be available when the code is defined so we
  // look for it at the last possible moment. If it doesn't exist now then
  // there is no point going ahead :)
  extend(OverlayViewSafe, google.maps.OverlayView);
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var MarkerClustererEvents;

(function (MarkerClustererEvents) {
  MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
  MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
  MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})(MarkerClustererEvents || (MarkerClustererEvents = {}));

var defaultOnClusterClickHandler = function defaultOnClusterClickHandler(_, cluster, map) {
  map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */


var MarkerClusterer = /*#__PURE__*/function (_OverlayViewSafe) {
  _inherits(MarkerClusterer, _OverlayViewSafe);

  function MarkerClusterer(_ref26) {
    var _this21;

    var map = _ref26.map,
        _ref26$markers = _ref26.markers,
        markers = _ref26$markers === void 0 ? [] : _ref26$markers,
        _ref26$algorithm = _ref26.algorithm,
        algorithm = _ref26$algorithm === void 0 ? new SuperClusterAlgorithm({}) : _ref26$algorithm,
        _ref26$renderer = _ref26.renderer,
        renderer = _ref26$renderer === void 0 ? new DefaultRenderer() : _ref26$renderer,
        _ref26$onClusterClick = _ref26.onClusterClick,
        onClusterClick = _ref26$onClusterClick === void 0 ? defaultOnClusterClickHandler : _ref26$onClusterClick;

    _classCallCheck(this, MarkerClusterer);

    _this21 = _possibleConstructorReturn(this, _getPrototypeOf(MarkerClusterer).call(this));
    _this21.markers = _toConsumableArray(markers);
    _this21.clusters = [];
    _this21.algorithm = algorithm;
    _this21.renderer = renderer;
    _this21.onClusterClick = onClusterClick;

    if (map) {
      _this21.setMap(map);
    }

    return _this21;
  }

  _createClass(MarkerClusterer, [{
    key: "addMarker",
    value: function addMarker(marker, noDraw) {
      if (this.markers.includes(marker)) {
        return;
      }

      this.markers.push(marker);

      if (!noDraw) {
        this.render();
      }
    }
  }, {
    key: "addMarkers",
    value: function addMarkers(markers, noDraw) {
      var _this22 = this;

      markers.forEach(function (marker) {
        _this22.addMarker(marker, true);
      });

      if (!noDraw) {
        this.render();
      }
    }
  }, {
    key: "removeMarker",
    value: function removeMarker(marker, noDraw) {
      var index = this.markers.indexOf(marker);

      if (index === -1) {
        // Marker is not in our list of markers, so do nothing:
        return false;
      }

      marker.setMap(null);
      this.markers.splice(index, 1); // Remove the marker from the list of managed markers

      if (!noDraw) {
        this.render();
      }

      return true;
    }
  }, {
    key: "removeMarkers",
    value: function removeMarkers(markers, noDraw) {
      var _this23 = this;

      var removed = false;
      markers.forEach(function (marker) {
        removed = _this23.removeMarker(marker, true) || removed;
      });

      if (removed && !noDraw) {
        this.render();
      }

      return removed;
    }
  }, {
    key: "clearMarkers",
    value: function clearMarkers(noDraw) {
      this.markers.length = 0;

      if (!noDraw) {
        this.render();
      }
    }
    /**
     * Recalculates and draws all the marker clusters.
     */

  }, {
    key: "render",
    value: function render() {
      var map = this.getMap();

      if (map instanceof google.maps.Map && this.getProjection()) {
        google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_BEGIN, this);

        var _this$algorithm$calcu = this.algorithm.calculate({
          markers: this.markers,
          map: map,
          mapCanvasProjection: this.getProjection()
        }),
            clusters = _this$algorithm$calcu.clusters,
            changed = _this$algorithm$calcu.changed; // allow algorithms to return flag on whether the clusters/markers have changed


        if (changed || changed == undefined) {
          // reset visibility of markers and clusters
          this.reset(); // store new clusters

          this.clusters = clusters;
          this.renderClusters();
        }

        google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_END, this);
      }
    }
  }, {
    key: "onAdd",
    value: function onAdd() {
      this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
      this.render();
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      google.maps.event.removeListener(this.idleListener);
      this.reset();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.markers.forEach(function (marker) {
        return marker.setMap(null);
      });
      this.clusters.forEach(function (cluster) {
        return cluster.delete();
      });
      this.clusters = [];
    }
  }, {
    key: "renderClusters",
    value: function renderClusters() {
      var _this24 = this;

      // generate stats to pass to renderers
      var stats = new ClusterStats(this.markers, this.clusters);
      var map = this.getMap();
      this.clusters.forEach(function (cluster) {
        if (cluster.markers.length === 1) {
          cluster.marker = cluster.markers[0];
        } else {
          cluster.marker = _this24.renderer.render(cluster, stats);

          if (_this24.onClusterClick) {
            cluster.marker.addListener("click",
            /* istanbul ignore next */
            function (event) {
              google.maps.event.trigger(_this24, MarkerClustererEvents.CLUSTER_CLICK, cluster);

              _this24.onClusterClick(event, cluster, map);
            });
          }
        }

        cluster.marker.setMap(map);
      });
    }
  }]);

  return MarkerClusterer;
}(OverlayViewSafe);

var index_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AbstractAlgorithm: AbstractAlgorithm,
  AbstractViewportAlgorithm: AbstractViewportAlgorithm,
  Cluster: Cluster,
  ClusterStats: ClusterStats,
  DefaultRenderer: DefaultRenderer,
  GridAlgorithm: GridAlgorithm,
  MarkerClusterer: MarkerClusterer,

  get MarkerClustererEvents() {
    return MarkerClustererEvents;
  },

  NoopAlgorithm: NoopAlgorithm,
  SuperClusterAlgorithm: SuperClusterAlgorithm,
  defaultOnClusterClickHandler: defaultOnClusterClickHandler,
  distanceBetweenPoints: distanceBetweenPoints,
  extendBoundsToPaddedViewport: extendBoundsToPaddedViewport,
  extendPixelBounds: extendPixelBounds,
  filterMarkersToPaddedViewport: filterMarkersToPaddedViewport,
  noop: noop$1,
  pixelBoundsToLatLngBounds: pixelBoundsToLatLngBounds
});

function useGoogleMarkerClusterer(options) {
  var map = useGoogleMap();

  var _useState111 = useState(null),
      _useState112 = _slicedToArray(_useState111, 2),
      markerClusterer = _useState112[0],
      setMarkerClusterer = _useState112[1];

  useEffect(function () {
    if (map && markerClusterer === null) {
      var markerCluster = new MarkerClusterer(Object.assign(Object.assign({}, options), {
        map: map
      }));
      setMarkerClusterer(markerCluster);
    }
  }, [map]);
  return markerClusterer;
}
/** Wrapper around [@googlemaps/markerclusterer](https://github.com/googlemaps/js-markerclusterer)
 *
 * Accepts {@link  MarkerClustererOptionsSubset} which is a subset of  {@link MarkerClustererOptions}
 */


function GoogleMarkerClusterer(_ref27) {
  var children = _ref27.children,
      options = _ref27.options;
  var markerClusterer = useGoogleMarkerClusterer(options);
  return markerClusterer !== null ? children(markerClusterer) : null;
}

var GoogleMarkerClusterer$1 = memo(GoogleMarkerClusterer);
/* global google */

var eventMap$c = {
  onCloseClick: 'closeclick',
  onContentChanged: 'content_changed',
  onDomReady: 'domready',
  onPositionChanged: 'position_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$c = {
  options: function options(instance, _options6) {
    instance.setOptions(_options6);
  },
  position: function position(instance, _position4) {
    instance.setPosition(_position4);
  },
  zIndex: function zIndex(instance, _zIndex3) {
    instance.setZIndex(_zIndex3);
  }
};

function InfoWindowFunctional(_ref28) {
  var children = _ref28.children,
      anchor = _ref28.anchor,
      options = _ref28.options,
      position = _ref28.position,
      zIndex = _ref28.zIndex,
      onCloseClick = _ref28.onCloseClick,
      onDomReady = _ref28.onDomReady,
      onContentChanged = _ref28.onContentChanged,
      onPositionChanged = _ref28.onPositionChanged,
      onZindexChanged = _ref28.onZindexChanged,
      onLoad = _ref28.onLoad,
      onUnmount = _ref28.onUnmount;
  var map = useContext(MapContext);

  var _useState113 = useState(null),
      _useState114 = _slicedToArray(_useState113, 2),
      instance = _useState114[0],
      setInstance = _useState114[1];

  var _useState115 = useState(null),
      _useState116 = _slicedToArray(_useState115, 2),
      closeclickListener = _useState116[0],
      setCloseClickListener = _useState116[1];

  var _useState117 = useState(null),
      _useState118 = _slicedToArray(_useState117, 2),
      domreadyclickListener = _useState118[0],
      setDomReadyClickListener = _useState118[1];

  var _useState119 = useState(null),
      _useState120 = _slicedToArray(_useState119, 2),
      contentchangedclickListener = _useState120[0],
      setContentChangedClickListener = _useState120[1];

  var _useState121 = useState(null),
      _useState122 = _slicedToArray(_useState121, 2),
      positionchangedclickListener = _useState122[0],
      setPositionChangedClickListener = _useState122[1];

  var _useState123 = useState(null),
      _useState124 = _slicedToArray(_useState123, 2),
      zindexchangedclickListener = _useState124[0],
      setZindexChangedClickListener = _useState124[1];

  var containerElementRef = useRef(null); // Order does matter

  useEffect(function () {
    if (instance !== null) {
      instance.close();

      if (anchor) {
        instance.open(map, anchor);
      } else if (instance.getPosition()) {
        instance.open(map);
      }
    }
  }, [map, instance, anchor]);
  useEffect(function () {
    if (options && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  useEffect(function () {
    if (position && instance !== null) {
      instance.setPosition(position);
    }
  }, [position]);
  useEffect(function () {
    if (typeof zIndex === 'number' && instance !== null) {
      instance.setZIndex(zIndex);
    }
  }, [zIndex]);
  useEffect(function () {
    if (instance && onCloseClick) {
      if (closeclickListener !== null) {
        google.maps.event.removeListener(closeclickListener);
      }

      setCloseClickListener(google.maps.event.addListener(instance, 'closeclick', onCloseClick));
    }
  }, [onCloseClick]);
  useEffect(function () {
    if (instance && onDomReady) {
      if (domreadyclickListener !== null) {
        google.maps.event.removeListener(domreadyclickListener);
      }

      setDomReadyClickListener(google.maps.event.addListener(instance, 'domready', onDomReady));
    }
  }, [onDomReady]);
  useEffect(function () {
    if (instance && onContentChanged) {
      if (contentchangedclickListener !== null) {
        google.maps.event.removeListener(contentchangedclickListener);
      }

      setContentChangedClickListener(google.maps.event.addListener(instance, 'content_changed', onContentChanged));
    }
  }, [onContentChanged]);
  useEffect(function () {
    if (instance && onPositionChanged) {
      if (positionchangedclickListener !== null) {
        google.maps.event.removeListener(positionchangedclickListener);
      }

      setPositionChangedClickListener(google.maps.event.addListener(instance, 'position_changed', onPositionChanged));
    }
  }, [onPositionChanged]);
  useEffect(function () {
    if (instance && onZindexChanged) {
      if (zindexchangedclickListener !== null) {
        google.maps.event.removeListener(zindexchangedclickListener);
      }

      setZindexChangedClickListener(google.maps.event.addListener(instance, 'zindex_changed', onZindexChanged));
    }
  }, [onZindexChanged]);
  useEffect(function () {
    var infoWindow = new google.maps.InfoWindow(Object.assign({}, options || {}));
    setInstance(infoWindow);
    containerElementRef.current = document.createElement('div');

    if (onCloseClick) {
      setCloseClickListener(google.maps.event.addListener(infoWindow, 'circlecomplete', onCloseClick));
    }

    if (onDomReady) {
      setDomReadyClickListener(google.maps.event.addListener(infoWindow, 'domready', onDomReady));
    }

    if (onContentChanged) {
      setContentChangedClickListener(google.maps.event.addListener(infoWindow, 'content_changed', onContentChanged));
    }

    if (onPositionChanged) {
      setPositionChangedClickListener(google.maps.event.addListener(infoWindow, 'position_changed', onPositionChanged));
    }

    if (onZindexChanged) {
      setZindexChangedClickListener(google.maps.event.addListener(infoWindow, 'zindex_changed', onZindexChanged));
    }

    infoWindow.setContent(containerElementRef.current);

    if (position) {
      infoWindow.setPosition(position);
    }

    if (zIndex) {
      infoWindow.setZIndex(zIndex);
    }

    if (anchor) {
      infoWindow.open(map, anchor);
    } else if (infoWindow.getPosition()) {
      infoWindow.open(map);
    } else {
      invariant_1(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
    }

    if (onLoad) {
      onLoad(infoWindow);
    }

    return function () {
      if (closeclickListener) {
        google.maps.event.removeListener(closeclickListener);
      }

      if (contentchangedclickListener) {
        google.maps.event.removeListener(contentchangedclickListener);
      }

      if (domreadyclickListener) {
        google.maps.event.removeListener(domreadyclickListener);
      }

      if (positionchangedclickListener) {
        google.maps.event.removeListener(positionchangedclickListener);
      }

      if (zindexchangedclickListener) {
        google.maps.event.removeListener(zindexchangedclickListener);
      }

      if (onUnmount) {
        onUnmount(infoWindow);
      }

      infoWindow.close();
    };
  }, []);
  return containerElementRef.current ? createPortal(Children.only(children), containerElementRef.current) : null;
}

var InfoWindowF = memo(InfoWindowFunctional);

var InfoWindow = /*#__PURE__*/function (_PureComponent10) {
  _inherits(InfoWindow, _PureComponent10);

  function InfoWindow() {
    var _this25;

    _classCallCheck(this, InfoWindow);

    _this25 = _possibleConstructorReturn(this, _getPrototypeOf(InfoWindow).apply(this, arguments));
    _this25.registeredEvents = [];
    _this25.containerElement = null;
    _this25.state = {
      infoWindow: null
    };

    _this25.open = function (infoWindow, anchor) {
      if (anchor) {
        infoWindow.open(_this25.context, anchor);
      } else if (infoWindow.getPosition()) {
        // @ts-ignore
        infoWindow.open(_this25.context);
      } else {
        invariant_1(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
      }
    };

    _this25.setInfoWindowCallback = function () {
      if (_this25.state.infoWindow !== null && _this25.containerElement !== null) {
        _this25.state.infoWindow.setContent(_this25.containerElement);

        _this25.open(_this25.state.infoWindow, _this25.props.anchor);

        if (_this25.props.onLoad) {
          _this25.props.onLoad(_this25.state.infoWindow);
        }
      }
    };

    return _this25;
  }

  _createClass(InfoWindow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var infoWindow = new google.maps.InfoWindow(Object.assign({}, this.props.options || {}));
      this.containerElement = document.createElement('div');
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$c,
        eventMap: eventMap$c,
        prevProps: {},
        nextProps: this.props,
        instance: infoWindow
      });
      this.setState(function () {
        return {
          infoWindow: infoWindow
        };
      }, this.setInfoWindowCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.infoWindow !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$c,
          eventMap: eventMap$c,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.infoWindow
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.infoWindow !== null) {
        unregisterEvents(this.registeredEvents);

        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.infoWindow);
        }

        this.state.infoWindow.close();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.containerElement ? createPortal(Children.only(this.props.children), this.containerElement) : null;
    }
  }]);

  return InfoWindow;
}(PureComponent);

InfoWindow.contextType = MapContext;
var eventMap$b = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$b = {
  draggable: function draggable(instance, _draggable2) {
    instance.setDraggable(_draggable2);
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable);
  },
  map: function map(instance, _map2) {
    instance.setMap(_map2);
  },
  options: function options(instance, _options7) {
    instance.setOptions(_options7);
  },
  path: function path(instance, _path) {
    instance.setPath(_path);
  },
  visible: function visible(instance, _visible3) {
    instance.setVisible(_visible3);
  }
};
var defaultOptions$1 = {};

function PolylineFunctional(_ref29) {
  var options = _ref29.options,
      draggable = _ref29.draggable,
      editable = _ref29.editable,
      visible = _ref29.visible,
      path = _ref29.path,
      onDblClick = _ref29.onDblClick,
      onDragEnd = _ref29.onDragEnd,
      onDragStart = _ref29.onDragStart,
      onMouseDown = _ref29.onMouseDown,
      onMouseMove = _ref29.onMouseMove,
      onMouseOut = _ref29.onMouseOut,
      onMouseOver = _ref29.onMouseOver,
      onMouseUp = _ref29.onMouseUp,
      onRightClick = _ref29.onRightClick,
      onClick = _ref29.onClick,
      onDrag = _ref29.onDrag,
      onLoad = _ref29.onLoad,
      onUnmount = _ref29.onUnmount;
  var map = useContext(MapContext);

  var _useState125 = useState(null),
      _useState126 = _slicedToArray(_useState125, 2),
      instance = _useState126[0],
      setInstance = _useState126[1];

  var _useState127 = useState(null),
      _useState128 = _slicedToArray(_useState127, 2),
      dblclickListener = _useState128[0],
      setDblclickListener = _useState128[1];

  var _useState129 = useState(null),
      _useState130 = _slicedToArray(_useState129, 2),
      dragendListener = _useState130[0],
      setDragendListener = _useState130[1];

  var _useState131 = useState(null),
      _useState132 = _slicedToArray(_useState131, 2),
      dragstartListener = _useState132[0],
      setDragstartListener = _useState132[1];

  var _useState133 = useState(null),
      _useState134 = _slicedToArray(_useState133, 2),
      mousedownListener = _useState134[0],
      setMousedownListener = _useState134[1];

  var _useState135 = useState(null),
      _useState136 = _slicedToArray(_useState135, 2),
      mousemoveListener = _useState136[0],
      setMousemoveListener = _useState136[1];

  var _useState137 = useState(null),
      _useState138 = _slicedToArray(_useState137, 2),
      mouseoutListener = _useState138[0],
      setMouseoutListener = _useState138[1];

  var _useState139 = useState(null),
      _useState140 = _slicedToArray(_useState139, 2),
      mouseoverListener = _useState140[0],
      setMouseoverListener = _useState140[1];

  var _useState141 = useState(null),
      _useState142 = _slicedToArray(_useState141, 2),
      mouseupListener = _useState142[0],
      setMouseupListener = _useState142[1];

  var _useState143 = useState(null),
      _useState144 = _slicedToArray(_useState143, 2),
      rightclickListener = _useState144[0],
      setRightclickListener = _useState144[1];

  var _useState145 = useState(null),
      _useState146 = _slicedToArray(_useState145, 2),
      clickListener = _useState146[0],
      setClickListener = _useState146[1];

  var _useState147 = useState(null),
      _useState148 = _slicedToArray(_useState147, 2),
      dragListener = _useState148[0],
      setDragListener = _useState148[1]; // Order does matter


  useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  useEffect(function () {
    if (typeof editable !== 'undefined' && instance !== null) {
      instance.setEditable(editable);
    }
  }, [instance, editable]);
  useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  useEffect(function () {
    if (typeof path !== 'undefined' && instance !== null) {
      instance.setPath(path);
    }
  }, [instance, path]);
  useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDblClick]);
  useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  useEffect(function () {
    var polyline = new google.maps.Polyline(Object.assign(Object.assign({}, options || defaultOptions$1), {
      map: map
    }));

    if (path) {
      polyline.setPath(path);
    }

    if (typeof visible !== 'undefined') {
      polyline.setVisible(visible);
    }

    if (typeof editable !== 'undefined') {
      polyline.setEditable(editable);
    }

    if (typeof draggable !== 'undefined') {
      polyline.setDraggable(draggable);
    }

    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(polyline, 'dblclick', onDblClick));
    }

    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(polyline, 'dragend', onDragEnd));
    }

    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(polyline, 'dragstart', onDragStart));
    }

    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(polyline, 'mousedown', onMouseDown));
    }

    if (onMouseMove) {
      setMousemoveListener(google.maps.event.addListener(polyline, 'mousemove', onMouseMove));
    }

    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(polyline, 'mouseout', onMouseOut));
    }

    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(polyline, 'mouseover', onMouseOver));
    }

    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(polyline, 'mouseup', onMouseUp));
    }

    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(polyline, 'rightclick', onRightClick));
    }

    if (onClick) {
      setClickListener(google.maps.event.addListener(polyline, 'click', onClick));
    }

    if (onDrag) {
      setDragListener(google.maps.event.addListener(polyline, 'drag', onDrag));
    }

    setInstance(polyline);

    if (onLoad) {
      onLoad(polyline);
    }

    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      if (onUnmount) {
        onUnmount(polyline);
      }

      polyline.setMap(null);
    };
  }, []);
  return null;
}

var PolylineF = memo(PolylineFunctional);

var Polyline = /*#__PURE__*/function (_PureComponent11) {
  _inherits(Polyline, _PureComponent11);

  function Polyline() {
    var _this26;

    _classCallCheck(this, Polyline);

    _this26 = _possibleConstructorReturn(this, _getPrototypeOf(Polyline).apply(this, arguments));
    _this26.registeredEvents = [];
    _this26.state = {
      polyline: null
    };

    _this26.setPolylineCallback = function () {
      if (_this26.state.polyline !== null && _this26.props.onLoad) {
        _this26.props.onLoad(_this26.state.polyline);
      }
    };

    return _this26;
  }

  _createClass(Polyline, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var polyline = new google.maps.Polyline(Object.assign(Object.assign({}, this.props.options || {}), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$b,
        eventMap: eventMap$b,
        prevProps: {},
        nextProps: this.props,
        instance: polyline
      });
      this.setState(function setPolyline() {
        return {
          polyline: polyline
        };
      }, this.setPolylineCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.polyline !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$b,
          eventMap: eventMap$b,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.polyline
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.polyline !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.polyline);
        }

        unregisterEvents(this.registeredEvents);
        this.state.polyline.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Polyline;
}(PureComponent);

Polyline.contextType = MapContext;
/* global google */

var eventMap$a = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$a = {
  draggable: function draggable(instance, _draggable3) {
    instance.setDraggable(_draggable3);
  },
  editable: function editable(instance, _editable2) {
    instance.setEditable(_editable2);
  },
  map: function map(instance, _map3) {
    instance.setMap(_map3);
  },
  options: function options(instance, _options8) {
    instance.setOptions(_options8);
  },
  path: function path(instance, _path2) {
    instance.setPath(_path2);
  },
  paths: function paths(instance, _paths) {
    instance.setPaths(_paths);
  },
  visible: function visible(instance, _visible4) {
    instance.setVisible(_visible4);
  }
};

function PolygonFunctional(_ref30) {
  var options = _ref30.options,
      draggable = _ref30.draggable,
      editable = _ref30.editable,
      visible = _ref30.visible,
      path = _ref30.path,
      onDblClick = _ref30.onDblClick,
      onDragEnd = _ref30.onDragEnd,
      onDragStart = _ref30.onDragStart,
      onMouseDown = _ref30.onMouseDown,
      onMouseMove = _ref30.onMouseMove,
      onMouseOut = _ref30.onMouseOut,
      onMouseOver = _ref30.onMouseOver,
      onMouseUp = _ref30.onMouseUp,
      onRightClick = _ref30.onRightClick,
      onClick = _ref30.onClick,
      onDrag = _ref30.onDrag,
      onLoad = _ref30.onLoad,
      onUnmount = _ref30.onUnmount;
  var map = useContext(MapContext);

  var _useState149 = useState(null),
      _useState150 = _slicedToArray(_useState149, 2),
      instance = _useState150[0],
      setInstance = _useState150[1];

  var _useState151 = useState(null),
      _useState152 = _slicedToArray(_useState151, 2),
      dblclickListener = _useState152[0],
      setDblclickListener = _useState152[1];

  var _useState153 = useState(null),
      _useState154 = _slicedToArray(_useState153, 2),
      dragendListener = _useState154[0],
      setDragendListener = _useState154[1];

  var _useState155 = useState(null),
      _useState156 = _slicedToArray(_useState155, 2),
      dragstartListener = _useState156[0],
      setDragstartListener = _useState156[1];

  var _useState157 = useState(null),
      _useState158 = _slicedToArray(_useState157, 2),
      mousedownListener = _useState158[0],
      setMousedownListener = _useState158[1];

  var _useState159 = useState(null),
      _useState160 = _slicedToArray(_useState159, 2),
      mousemoveListener = _useState160[0],
      setMousemoveListener = _useState160[1];

  var _useState161 = useState(null),
      _useState162 = _slicedToArray(_useState161, 2),
      mouseoutListener = _useState162[0],
      setMouseoutListener = _useState162[1];

  var _useState163 = useState(null),
      _useState164 = _slicedToArray(_useState163, 2),
      mouseoverListener = _useState164[0],
      setMouseoverListener = _useState164[1];

  var _useState165 = useState(null),
      _useState166 = _slicedToArray(_useState165, 2),
      mouseupListener = _useState166[0],
      setMouseupListener = _useState166[1];

  var _useState167 = useState(null),
      _useState168 = _slicedToArray(_useState167, 2),
      rightclickListener = _useState168[0],
      setRightclickListener = _useState168[1];

  var _useState169 = useState(null),
      _useState170 = _slicedToArray(_useState169, 2),
      clickListener = _useState170[0],
      setClickListener = _useState170[1];

  var _useState171 = useState(null),
      _useState172 = _slicedToArray(_useState171, 2),
      dragListener = _useState172[0],
      setDragListener = _useState172[1]; // Order does matter


  useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  useEffect(function () {
    if (typeof editable !== 'undefined' && instance !== null) {
      instance.setEditable(editable);
    }
  }, [instance, editable]);
  useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  useEffect(function () {
    if (typeof path !== 'undefined' && instance !== null) {
      instance.setPath(path);
    }
  }, [instance, path]);
  useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDblClick]);
  useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  useEffect(function () {
    var polygon = new google.maps.Polygon(Object.assign(Object.assign({}, options || {}), {
      map: map
    }));

    if (path) {
      polygon.setPath(path);
    }

    if (typeof visible !== 'undefined') {
      polygon.setVisible(visible);
    }

    if (typeof editable !== 'undefined') {
      polygon.setEditable(editable);
    }

    if (typeof draggable !== 'undefined') {
      polygon.setDraggable(draggable);
    }

    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(polygon, 'dblclick', onDblClick));
    }

    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(polygon, 'dragend', onDragEnd));
    }

    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(polygon, 'dragstart', onDragStart));
    }

    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(polygon, 'mousedown', onMouseDown));
    }

    if (onMouseMove) {
      setMousemoveListener(google.maps.event.addListener(polygon, 'mousemove', onMouseMove));
    }

    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(polygon, 'mouseout', onMouseOut));
    }

    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(polygon, 'mouseover', onMouseOver));
    }

    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(polygon, 'mouseup', onMouseUp));
    }

    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(polygon, 'rightclick', onRightClick));
    }

    if (onClick) {
      setClickListener(google.maps.event.addListener(polygon, 'click', onClick));
    }

    if (onDrag) {
      setDragListener(google.maps.event.addListener(polygon, 'drag', onDrag));
    }

    setInstance(polygon);

    if (onLoad) {
      onLoad(polygon);
    }

    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      if (onUnmount) {
        onUnmount(polygon);
      }

      polygon.setMap(null);
    };
  }, []);
  return null;
}

var PolygonF = memo(PolygonFunctional);

var Polygon = /*#__PURE__*/function (_PureComponent12) {
  _inherits(Polygon, _PureComponent12);

  function Polygon() {
    var _this27;

    _classCallCheck(this, Polygon);

    _this27 = _possibleConstructorReturn(this, _getPrototypeOf(Polygon).apply(this, arguments));
    _this27.registeredEvents = [];
    _this27.state = {
      polygon: null
    };

    _this27.setPolygonCallback = function () {
      if (_this27.state.polygon !== null && _this27.props.onLoad) {
        _this27.props.onLoad(_this27.state.polygon);
      }
    };

    return _this27;
  }

  _createClass(Polygon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var polygon = new google.maps.Polygon(Object.assign(Object.assign({}, this.props.options || {}), {
        // @ts-ignore
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$a,
        eventMap: eventMap$a,
        prevProps: {},
        nextProps: this.props,
        instance: polygon
      });
      this.setState(function setPolygon() {
        return {
          polygon: polygon
        };
      }, this.setPolygonCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.polygon !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$a,
          eventMap: eventMap$a,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.polygon
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.polygon !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.polygon);
        }

        unregisterEvents(this.registeredEvents);
        this.state.polygon && this.state.polygon.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Polygon;
}(PureComponent);

Polygon.contextType = MapContext;
var eventMap$9 = {
  onBoundsChanged: 'bounds_changed',
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$9 = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds);
  },
  draggable: function draggable(instance, _draggable4) {
    instance.setDraggable(_draggable4);
  },
  editable: function editable(instance, _editable3) {
    instance.setEditable(_editable3);
  },
  map: function map(instance, _map4) {
    instance.setMap(_map4);
  },
  options: function options(instance, _options9) {
    instance.setOptions(_options9);
  },
  visible: function visible(instance, _visible5) {
    instance.setVisible(_visible5);
  }
};

function RectangleFunctional(_ref31) {
  var options = _ref31.options,
      bounds = _ref31.bounds,
      draggable = _ref31.draggable,
      editable = _ref31.editable,
      visible = _ref31.visible,
      onDblClick = _ref31.onDblClick,
      onDragEnd = _ref31.onDragEnd,
      onDragStart = _ref31.onDragStart,
      onMouseDown = _ref31.onMouseDown,
      onMouseMove = _ref31.onMouseMove,
      onMouseOut = _ref31.onMouseOut,
      onMouseOver = _ref31.onMouseOver,
      onMouseUp = _ref31.onMouseUp,
      onRightClick = _ref31.onRightClick,
      onClick = _ref31.onClick,
      onDrag = _ref31.onDrag,
      onBoundsChanged = _ref31.onBoundsChanged,
      onLoad = _ref31.onLoad,
      onUnmount = _ref31.onUnmount;
  var map = useContext(MapContext);

  var _useState173 = useState(null),
      _useState174 = _slicedToArray(_useState173, 2),
      instance = _useState174[0],
      setInstance = _useState174[1];

  var _useState175 = useState(null),
      _useState176 = _slicedToArray(_useState175, 2),
      dblclickListener = _useState176[0],
      setDblclickListener = _useState176[1];

  var _useState177 = useState(null),
      _useState178 = _slicedToArray(_useState177, 2),
      dragendListener = _useState178[0],
      setDragendListener = _useState178[1];

  var _useState179 = useState(null),
      _useState180 = _slicedToArray(_useState179, 2),
      dragstartListener = _useState180[0],
      setDragstartListener = _useState180[1];

  var _useState181 = useState(null),
      _useState182 = _slicedToArray(_useState181, 2),
      mousedownListener = _useState182[0],
      setMousedownListener = _useState182[1];

  var _useState183 = useState(null),
      _useState184 = _slicedToArray(_useState183, 2),
      mousemoveListener = _useState184[0],
      setMousemoveListener = _useState184[1];

  var _useState185 = useState(null),
      _useState186 = _slicedToArray(_useState185, 2),
      mouseoutListener = _useState186[0],
      setMouseoutListener = _useState186[1];

  var _useState187 = useState(null),
      _useState188 = _slicedToArray(_useState187, 2),
      mouseoverListener = _useState188[0],
      setMouseoverListener = _useState188[1];

  var _useState189 = useState(null),
      _useState190 = _slicedToArray(_useState189, 2),
      mouseupListener = _useState190[0],
      setMouseupListener = _useState190[1];

  var _useState191 = useState(null),
      _useState192 = _slicedToArray(_useState191, 2),
      rightclickListener = _useState192[0],
      setRightclickListener = _useState192[1];

  var _useState193 = useState(null),
      _useState194 = _slicedToArray(_useState193, 2),
      clickListener = _useState194[0],
      setClickListener = _useState194[1];

  var _useState195 = useState(null),
      _useState196 = _slicedToArray(_useState195, 2),
      dragListener = _useState196[0],
      setDragListener = _useState196[1];

  var _useState197 = useState(null),
      _useState198 = _slicedToArray(_useState197, 2),
      boundsChangedListener = _useState198[0],
      setBoundsChangedListener = _useState198[1]; // Order does matter


  useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  useEffect(function () {
    if (typeof editable !== 'undefined' && instance !== null) {
      instance.setEditable(editable);
    }
  }, [instance, editable]);
  useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  useEffect(function () {
    if (typeof bounds !== 'undefined' && instance !== null) {
      instance.setBounds(bounds);
    }
  }, [instance, bounds]);
  useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDblClick]);
  useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  useEffect(function () {
    if (instance && onBoundsChanged) {
      if (boundsChangedListener !== null) {
        google.maps.event.removeListener(boundsChangedListener);
      }

      setBoundsChangedListener(google.maps.event.addListener(instance, 'bounds_changed', onBoundsChanged));
    }
  }, [onBoundsChanged]);
  useEffect(function () {
    var rectangle = new google.maps.Rectangle(Object.assign(Object.assign({}, options || {}), {
      map: map
    }));

    if (typeof visible !== 'undefined') {
      rectangle.setVisible(visible);
    }

    if (typeof editable !== 'undefined') {
      rectangle.setEditable(editable);
    }

    if (typeof draggable !== 'undefined') {
      rectangle.setDraggable(draggable);
    }

    if (typeof bounds !== 'undefined') {
      rectangle.setBounds(bounds);
    }

    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(rectangle, 'dblclick', onDblClick));
    }

    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(rectangle, 'dragend', onDragEnd));
    }

    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(rectangle, 'dragstart', onDragStart));
    }

    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(rectangle, 'mousedown', onMouseDown));
    }

    if (onMouseMove) {
      setMousemoveListener(google.maps.event.addListener(rectangle, 'mousemove', onMouseMove));
    }

    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(rectangle, 'mouseout', onMouseOut));
    }

    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(rectangle, 'mouseover', onMouseOver));
    }

    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(rectangle, 'mouseup', onMouseUp));
    }

    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(rectangle, 'rightclick', onRightClick));
    }

    if (onClick) {
      setClickListener(google.maps.event.addListener(rectangle, 'click', onClick));
    }

    if (onDrag) {
      setDragListener(google.maps.event.addListener(rectangle, 'drag', onDrag));
    }

    if (onBoundsChanged) {
      setBoundsChangedListener(google.maps.event.addListener(rectangle, 'bounds_changed', onBoundsChanged));
    }

    setInstance(rectangle);

    if (onLoad) {
      onLoad(rectangle);
    }

    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      if (boundsChangedListener !== null) {
        google.maps.event.removeListener(boundsChangedListener);
      }

      if (onUnmount) {
        onUnmount(rectangle);
      }

      rectangle.setMap(null);
    };
  }, []);
  return null;
}

var RectangleF = memo(RectangleFunctional);

var Rectangle = /*#__PURE__*/function (_PureComponent13) {
  _inherits(Rectangle, _PureComponent13);

  function Rectangle() {
    var _this28;

    _classCallCheck(this, Rectangle);

    _this28 = _possibleConstructorReturn(this, _getPrototypeOf(Rectangle).apply(this, arguments));
    _this28.registeredEvents = [];
    _this28.state = {
      rectangle: null
    };

    _this28.setRectangleCallback = function () {
      if (_this28.state.rectangle !== null && _this28.props.onLoad) {
        _this28.props.onLoad(_this28.state.rectangle);
      }
    };

    return _this28;
  }

  _createClass(Rectangle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var rectangle = new google.maps.Rectangle(Object.assign(Object.assign({}, this.props.options || {}), {
        // @ts-ignore
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$9,
        eventMap: eventMap$9,
        prevProps: {},
        nextProps: this.props,
        instance: rectangle
      });
      this.setState(function setRectangle() {
        return {
          rectangle: rectangle
        };
      }, this.setRectangleCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.rectangle !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$9,
          eventMap: eventMap$9,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.rectangle
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.rectangle !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.rectangle);
        }

        unregisterEvents(this.registeredEvents);
        this.state.rectangle.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Rectangle;
}(PureComponent);

Rectangle.contextType = MapContext;
var eventMap$8 = {
  onCenterChanged: 'center_changed',
  onRadiusChanged: 'radius_changed',
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$8 = {
  center: function center(instance, _center2) {
    instance.setCenter(_center2);
  },
  draggable: function draggable(instance, _draggable5) {
    instance.setDraggable(_draggable5);
  },
  editable: function editable(instance, _editable4) {
    instance.setEditable(_editable4);
  },
  map: function map(instance, _map5) {
    instance.setMap(_map5);
  },
  options: function options(instance, _options10) {
    instance.setOptions(_options10);
  },
  radius: function radius(instance, _radius) {
    instance.setRadius(_radius);
  },
  visible: function visible(instance, _visible6) {
    instance.setVisible(_visible6);
  }
};
var defaultOptions = {};

function CircleFunctional(_ref32) {
  var options = _ref32.options,
      center = _ref32.center,
      radius = _ref32.radius,
      draggable = _ref32.draggable,
      editable = _ref32.editable,
      visible = _ref32.visible,
      onDblClick = _ref32.onDblClick,
      onDragEnd = _ref32.onDragEnd,
      onDragStart = _ref32.onDragStart,
      onMouseDown = _ref32.onMouseDown,
      onMouseMove = _ref32.onMouseMove,
      onMouseOut = _ref32.onMouseOut,
      onMouseOver = _ref32.onMouseOver,
      onMouseUp = _ref32.onMouseUp,
      onRightClick = _ref32.onRightClick,
      onClick = _ref32.onClick,
      onDrag = _ref32.onDrag,
      onCenterChanged = _ref32.onCenterChanged,
      onRadiusChanged = _ref32.onRadiusChanged,
      onLoad = _ref32.onLoad,
      onUnmount = _ref32.onUnmount;
  var map = useContext(MapContext);

  var _useState199 = useState(null),
      _useState200 = _slicedToArray(_useState199, 2),
      instance = _useState200[0],
      setInstance = _useState200[1];

  var _useState201 = useState(null),
      _useState202 = _slicedToArray(_useState201, 2),
      dblclickListener = _useState202[0],
      setDblclickListener = _useState202[1];

  var _useState203 = useState(null),
      _useState204 = _slicedToArray(_useState203, 2),
      dragendListener = _useState204[0],
      setDragendListener = _useState204[1];

  var _useState205 = useState(null),
      _useState206 = _slicedToArray(_useState205, 2),
      dragstartListener = _useState206[0],
      setDragstartListener = _useState206[1];

  var _useState207 = useState(null),
      _useState208 = _slicedToArray(_useState207, 2),
      mousedownListener = _useState208[0],
      setMousedownListener = _useState208[1];

  var _useState209 = useState(null),
      _useState210 = _slicedToArray(_useState209, 2),
      mousemoveListener = _useState210[0],
      setMousemoveListener = _useState210[1];

  var _useState211 = useState(null),
      _useState212 = _slicedToArray(_useState211, 2),
      mouseoutListener = _useState212[0],
      setMouseoutListener = _useState212[1];

  var _useState213 = useState(null),
      _useState214 = _slicedToArray(_useState213, 2),
      mouseoverListener = _useState214[0],
      setMouseoverListener = _useState214[1];

  var _useState215 = useState(null),
      _useState216 = _slicedToArray(_useState215, 2),
      mouseupListener = _useState216[0],
      setMouseupListener = _useState216[1];

  var _useState217 = useState(null),
      _useState218 = _slicedToArray(_useState217, 2),
      rightclickListener = _useState218[0],
      setRightclickListener = _useState218[1];

  var _useState219 = useState(null),
      _useState220 = _slicedToArray(_useState219, 2),
      clickListener = _useState220[0],
      setClickListener = _useState220[1];

  var _useState221 = useState(null),
      _useState222 = _slicedToArray(_useState221, 2),
      dragListener = _useState222[0],
      setDragListener = _useState222[1];

  var _useState223 = useState(null),
      _useState224 = _slicedToArray(_useState223, 2),
      centerChangedListener = _useState224[0],
      setCenterChangedListener = _useState224[1];

  var _useState225 = useState(null),
      _useState226 = _slicedToArray(_useState225, 2),
      radiusChangedListener = _useState226[0],
      setRadiusChangedListener = _useState226[1]; // Order does matter


  useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  useEffect(function () {
    if (typeof editable !== 'undefined' && instance !== null) {
      instance.setEditable(editable);
    }
  }, [instance, editable]);
  useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  useEffect(function () {
    if (typeof radius === 'number' && instance !== null) {
      instance.setRadius(radius);
    }
  }, [instance, radius]);
  useEffect(function () {
    if (typeof center !== 'undefined' && instance !== null) {
      instance.setCenter(center);
    }
  }, [instance, center]);
  useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDblClick]);
  useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  useEffect(function () {
    if (instance && onCenterChanged) {
      if (centerChangedListener !== null) {
        google.maps.event.removeListener(centerChangedListener);
      }

      setCenterChangedListener(google.maps.event.addListener(instance, 'center_changed', onCenterChanged));
    }
  }, [onClick]);
  useEffect(function () {
    if (instance && onRadiusChanged) {
      if (radiusChangedListener !== null) {
        google.maps.event.removeListener(radiusChangedListener);
      }

      setRadiusChangedListener(google.maps.event.addListener(instance, 'radius_changed', onRadiusChanged));
    }
  }, [onRadiusChanged]);
  useEffect(function () {
    var circle = new google.maps.Circle(Object.assign(Object.assign({}, options || defaultOptions), {
      map: map
    }));

    if (typeof radius === 'number') {
      circle.setRadius(radius);
    }

    if (typeof center !== 'undefined') {
      circle.setCenter(center);
    }

    if (typeof radius === 'number') {
      circle.setRadius(radius);
    }

    if (typeof visible !== 'undefined') {
      circle.setVisible(visible);
    }

    if (typeof editable !== 'undefined') {
      circle.setEditable(editable);
    }

    if (typeof draggable !== 'undefined') {
      circle.setDraggable(draggable);
    }

    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(circle, 'dblclick', onDblClick));
    }

    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(circle, 'dragend', onDragEnd));
    }

    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(circle, 'dragstart', onDragStart));
    }

    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(circle, 'mousedown', onMouseDown));
    }

    if (onMouseMove) {
      setMousemoveListener(google.maps.event.addListener(circle, 'mousemove', onMouseMove));
    }

    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(circle, 'mouseout', onMouseOut));
    }

    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(circle, 'mouseover', onMouseOver));
    }

    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(circle, 'mouseup', onMouseUp));
    }

    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(circle, 'rightclick', onRightClick));
    }

    if (onClick) {
      setClickListener(google.maps.event.addListener(circle, 'click', onClick));
    }

    if (onDrag) {
      setDragListener(google.maps.event.addListener(circle, 'drag', onDrag));
    }

    if (onCenterChanged) {
      setCenterChangedListener(google.maps.event.addListener(circle, 'center_changed', onCenterChanged));
    }

    if (onRadiusChanged) {
      setRadiusChangedListener(google.maps.event.addListener(circle, 'radius_changed', onRadiusChanged));
    }

    setInstance(circle);

    if (onLoad) {
      onLoad(circle);
    }

    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      if (centerChangedListener !== null) {
        google.maps.event.removeListener(centerChangedListener);
      }

      if (radiusChangedListener !== null) {
        google.maps.event.removeListener(radiusChangedListener);
      }

      if (onUnmount) {
        onUnmount(circle);
      }

      circle.setMap(null);
    };
  }, []);
  return null;
}

var CircleF = memo(CircleFunctional);

var Circle = /*#__PURE__*/function (_PureComponent14) {
  _inherits(Circle, _PureComponent14);

  function Circle() {
    var _this29;

    _classCallCheck(this, Circle);

    _this29 = _possibleConstructorReturn(this, _getPrototypeOf(Circle).apply(this, arguments));
    _this29.registeredEvents = [];
    _this29.state = {
      circle: null
    };

    _this29.setCircleCallback = function () {
      if (_this29.state.circle !== null && _this29.props.onLoad) {
        _this29.props.onLoad(_this29.state.circle);
      }
    };

    return _this29;
  }

  _createClass(Circle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var circle = new google.maps.Circle(Object.assign(Object.assign({}, this.props.options || {}), {
        // @ts-ignore
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$8,
        eventMap: eventMap$8,
        prevProps: {},
        nextProps: this.props,
        instance: circle
      });
      this.setState(function setCircle() {
        return {
          circle: circle
        };
      }, this.setCircleCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.circle !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$8,
          eventMap: eventMap$8,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.circle
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.circle !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.circle);
        }

        unregisterEvents(this.registeredEvents);
        this.state.circle && this.state.circle.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Circle;
}(PureComponent);

Circle.contextType = MapContext;
var eventMap$7 = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onMouseDown: 'mousedown',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick',
  onAddFeature: 'addfeature',
  onRemoveFeature: 'removefeature',
  onRemoveProperty: 'removeproperty',
  onSetGeometry: 'setgeometry',
  onSetProperty: 'setproperty'
};
var updaterMap$7 = {
  add: function add(instance, feature) {
    instance.add(feature);
  },
  addgeojson: function addgeojson(instance, geojson, options) {
    instance.addGeoJson(geojson, options);
  },
  contains: function contains(instance, feature) {
    instance.contains(feature);
  },
  foreach: function foreach(instance, callback) {
    instance.forEach(callback);
  },
  loadgeojson: function loadgeojson(instance, url, options, callback) {
    instance.loadGeoJson(url, options, callback);
  },
  overridestyle: function overridestyle(instance, feature, style) {
    instance.overrideStyle(feature, style);
  },
  remove: function remove(instance, feature) {
    instance.remove(feature);
  },
  revertstyle: function revertstyle(instance, feature) {
    instance.revertStyle(feature);
  },
  controlposition: function controlposition(instance, controlPosition) {
    instance.setControlPosition(controlPosition);
  },
  controls: function controls(instance, _controls) {
    instance.setControls(_controls);
  },
  drawingmode: function drawingmode(instance, mode) {
    instance.setDrawingMode(mode);
  },
  map: function map(instance, _map6) {
    instance.setMap(_map6);
  },
  style: function style(instance, _style) {
    instance.setStyle(_style);
  },
  togeojson: function togeojson(instance, callback) {
    instance.toGeoJson(callback);
  }
};

function DataFunctional(_ref33) {
  var options = _ref33.options,
      onClick = _ref33.onClick,
      onDblClick = _ref33.onDblClick,
      onMouseDown = _ref33.onMouseDown,
      onMouseMove = _ref33.onMouseMove,
      onMouseOut = _ref33.onMouseOut,
      onMouseOver = _ref33.onMouseOver,
      onMouseUp = _ref33.onMouseUp,
      onRightClick = _ref33.onRightClick,
      onAddFeature = _ref33.onAddFeature,
      onRemoveFeature = _ref33.onRemoveFeature,
      onRemoveProperty = _ref33.onRemoveProperty,
      onSetGeometry = _ref33.onSetGeometry,
      onSetProperty = _ref33.onSetProperty,
      onLoad = _ref33.onLoad,
      onUnmount = _ref33.onUnmount;
  var map = useContext(MapContext);

  var _useState227 = useState(null),
      _useState228 = _slicedToArray(_useState227, 2),
      instance = _useState228[0],
      setInstance = _useState228[1];

  var _useState229 = useState(null),
      _useState230 = _slicedToArray(_useState229, 2),
      dblclickListener = _useState230[0],
      setDblclickListener = _useState230[1];

  var _useState231 = useState(null),
      _useState232 = _slicedToArray(_useState231, 2),
      mousedownListener = _useState232[0],
      setMousedownListener = _useState232[1];

  var _useState233 = useState(null),
      _useState234 = _slicedToArray(_useState233, 2),
      mousemoveListener = _useState234[0],
      setMousemoveListener = _useState234[1];

  var _useState235 = useState(null),
      _useState236 = _slicedToArray(_useState235, 2),
      mouseoutListener = _useState236[0],
      setMouseoutListener = _useState236[1];

  var _useState237 = useState(null),
      _useState238 = _slicedToArray(_useState237, 2),
      mouseoverListener = _useState238[0],
      setMouseoverListener = _useState238[1];

  var _useState239 = useState(null),
      _useState240 = _slicedToArray(_useState239, 2),
      mouseupListener = _useState240[0],
      setMouseupListener = _useState240[1];

  var _useState241 = useState(null),
      _useState242 = _slicedToArray(_useState241, 2),
      rightclickListener = _useState242[0],
      setRightclickListener = _useState242[1];

  var _useState243 = useState(null),
      _useState244 = _slicedToArray(_useState243, 2),
      clickListener = _useState244[0],
      setClickListener = _useState244[1];

  var _useState245 = useState(null),
      _useState246 = _slicedToArray(_useState245, 2),
      addFeatureListener = _useState246[0],
      setAddFeatureListener = _useState246[1];

  var _useState247 = useState(null),
      _useState248 = _slicedToArray(_useState247, 2),
      removeFeatureListener = _useState248[0],
      setRemoveFeatureListener = _useState248[1];

  var _useState249 = useState(null),
      _useState250 = _slicedToArray(_useState249, 2),
      removePropertyListener = _useState250[0],
      setRemovePropertyListener = _useState250[1];

  var _useState251 = useState(null),
      _useState252 = _slicedToArray(_useState251, 2),
      setGeometryListener = _useState252[0],
      setSetGeometryListener = _useState252[1];

  var _useState253 = useState(null),
      _useState254 = _slicedToArray(_useState253, 2),
      setPropertyListener = _useState254[0],
      setSetPropertyListener = _useState254[1]; // Order does matter


  useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  useEffect(function () {
    if (instance && onAddFeature) {
      if (addFeatureListener !== null) {
        google.maps.event.removeListener(addFeatureListener);
      }

      setAddFeatureListener(google.maps.event.addListener(instance, 'addfeature', onAddFeature));
    }
  }, [onAddFeature]);
  useEffect(function () {
    if (instance && onRemoveFeature) {
      if (removeFeatureListener !== null) {
        google.maps.event.removeListener(removeFeatureListener);
      }

      setRemoveFeatureListener(google.maps.event.addListener(instance, 'removefeature', onRemoveFeature));
    }
  }, [onRemoveFeature]);
  useEffect(function () {
    if (instance && onRemoveProperty) {
      if (removePropertyListener !== null) {
        google.maps.event.removeListener(removePropertyListener);
      }

      setRemovePropertyListener(google.maps.event.addListener(instance, 'removeproperty', onRemoveProperty));
    }
  }, [onRemoveProperty]);
  useEffect(function () {
    if (instance && onSetGeometry) {
      if (setGeometryListener !== null) {
        google.maps.event.removeListener(setGeometryListener);
      }

      setSetGeometryListener(google.maps.event.addListener(instance, 'setgeometry', onSetGeometry));
    }
  }, [onSetGeometry]);
  useEffect(function () {
    if (instance && onSetProperty) {
      if (setPropertyListener !== null) {
        google.maps.event.removeListener(setPropertyListener);
      }

      setSetPropertyListener(google.maps.event.addListener(instance, 'setproperty', onSetProperty));
    }
  }, [onSetProperty]);
  useEffect(function () {
    if (map !== null) {
      var data = new google.maps.Data(Object.assign(Object.assign({}, options || {}), {
        map: map
      }));

      if (onDblClick) {
        setDblclickListener(google.maps.event.addListener(data, 'dblclick', onDblClick));
      }

      if (onMouseDown) {
        setMousedownListener(google.maps.event.addListener(data, 'mousedown', onMouseDown));
      }

      if (onMouseMove) {
        setMousemoveListener(google.maps.event.addListener(data, 'mousemove', onMouseMove));
      }

      if (onMouseOut) {
        setMouseoutListener(google.maps.event.addListener(data, 'mouseout', onMouseOut));
      }

      if (onMouseOver) {
        setMouseoverListener(google.maps.event.addListener(data, 'mouseover', onMouseOver));
      }

      if (onMouseUp) {
        setMouseupListener(google.maps.event.addListener(data, 'mouseup', onMouseUp));
      }

      if (onRightClick) {
        setRightclickListener(google.maps.event.addListener(data, 'rightclick', onRightClick));
      }

      if (onClick) {
        setClickListener(google.maps.event.addListener(data, 'click', onClick));
      }

      if (onAddFeature) {
        setAddFeatureListener(google.maps.event.addListener(data, 'addfeature', onAddFeature));
      }

      if (onRemoveFeature) {
        setRemoveFeatureListener(google.maps.event.addListener(data, 'removefeature', onRemoveFeature));
      }

      if (onRemoveProperty) {
        setRemovePropertyListener(google.maps.event.addListener(data, 'removeproperty', onRemoveProperty));
      }

      if (onSetGeometry) {
        setSetGeometryListener(google.maps.event.addListener(data, 'setgeometry', onSetGeometry));
      }

      if (onSetProperty) {
        setSetPropertyListener(google.maps.event.addListener(data, 'setproperty', onSetProperty));
      }

      setInstance(data);

      if (onLoad) {
        onLoad(data);
      }
    }

    return function () {
      if (instance) {
        if (dblclickListener !== null) {
          google.maps.event.removeListener(dblclickListener);
        }

        if (mousedownListener !== null) {
          google.maps.event.removeListener(mousedownListener);
        }

        if (mousemoveListener !== null) {
          google.maps.event.removeListener(mousemoveListener);
        }

        if (mouseoutListener !== null) {
          google.maps.event.removeListener(mouseoutListener);
        }

        if (mouseoverListener !== null) {
          google.maps.event.removeListener(mouseoverListener);
        }

        if (mouseupListener !== null) {
          google.maps.event.removeListener(mouseupListener);
        }

        if (rightclickListener !== null) {
          google.maps.event.removeListener(rightclickListener);
        }

        if (clickListener !== null) {
          google.maps.event.removeListener(clickListener);
        }

        if (addFeatureListener !== null) {
          google.maps.event.removeListener(addFeatureListener);
        }

        if (removeFeatureListener !== null) {
          google.maps.event.removeListener(removeFeatureListener);
        }

        if (removePropertyListener !== null) {
          google.maps.event.removeListener(removePropertyListener);
        }

        if (setGeometryListener !== null) {
          google.maps.event.removeListener(setGeometryListener);
        }

        if (setPropertyListener !== null) {
          google.maps.event.removeListener(setPropertyListener);
        }

        if (onUnmount) {
          onUnmount(instance);
        }

        instance.setMap(null);
      }
    };
  }, []);
  return null;
}

var DataF = memo(DataFunctional);

var Data = /*#__PURE__*/function (_PureComponent15) {
  _inherits(Data, _PureComponent15);

  function Data() {
    var _this30;

    _classCallCheck(this, Data);

    _this30 = _possibleConstructorReturn(this, _getPrototypeOf(Data).apply(this, arguments));
    _this30.registeredEvents = [];
    _this30.state = {
      data: null
    };

    _this30.setDataCallback = function () {
      if (_this30.state.data !== null && _this30.props.onLoad) {
        _this30.props.onLoad(_this30.state.data);
      }
    };

    return _this30;
  }

  _createClass(Data, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.context !== null) {
        var data = new google.maps.Data(Object.assign(Object.assign({}, this.props.options || {}), {
          map: this.context
        }));
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$7,
          eventMap: eventMap$7,
          prevProps: {},
          nextProps: this.props,
          instance: data
        });
        this.setState(function () {
          return {
            data: data
          };
        }, this.setDataCallback);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.data !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$7,
          eventMap: eventMap$7,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.data
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.data !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.data);
        }

        unregisterEvents(this.registeredEvents);

        if (this.state.data) {
          this.state.data.setMap(null);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Data;
}(PureComponent);

Data.contextType = MapContext;
var eventMap$6 = {
  onClick: 'click',
  onDefaultViewportChanged: 'defaultviewport_changed',
  onStatusChanged: 'status_changed'
};
var updaterMap$6 = {
  options: function options(instance, _options11) {
    instance.setOptions(_options11);
  },
  url: function url(instance, _url) {
    instance.setUrl(_url);
  },
  zIndex: function zIndex(instance, _zIndex4) {
    instance.setZIndex(_zIndex4);
  }
};

var KmlLayer = /*#__PURE__*/function (_PureComponent16) {
  _inherits(KmlLayer, _PureComponent16);

  function KmlLayer() {
    var _this31;

    _classCallCheck(this, KmlLayer);

    _this31 = _possibleConstructorReturn(this, _getPrototypeOf(KmlLayer).apply(this, arguments));
    _this31.registeredEvents = [];
    _this31.state = {
      kmlLayer: null
    };

    _this31.setKmlLayerCallback = function () {
      if (_this31.state.kmlLayer !== null && _this31.props.onLoad) {
        _this31.props.onLoad(_this31.state.kmlLayer);
      }
    };

    return _this31;
  }

  _createClass(KmlLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var kmlLayer = new google.maps.KmlLayer(Object.assign(Object.assign({}, this.props.options), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$6,
        eventMap: eventMap$6,
        prevProps: {},
        nextProps: this.props,
        instance: kmlLayer
      });
      this.setState(function setLmlLayer() {
        return {
          kmlLayer: kmlLayer
        };
      }, this.setKmlLayerCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.kmlLayer !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$6,
          eventMap: eventMap$6,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.kmlLayer
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.kmlLayer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.kmlLayer);
        }

        unregisterEvents(this.registeredEvents);
        this.state.kmlLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return KmlLayer;
}(PureComponent);

KmlLayer.contextType = MapContext;

function getOffsetOverride(containerElement, getPixelPositionOffset) {
  return typeof getPixelPositionOffset === 'function' ? getPixelPositionOffset(containerElement.offsetWidth, containerElement.offsetHeight) : {};
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng);
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function createLatLngBounds(inst, Type) {
  return new Type(new google.maps.LatLng(inst.ne.lat, inst.ne.lng), new google.maps.LatLng(inst.sw.lat, inst.sw.lng));
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function ensureOfType(inst, type, factory) {
  return inst instanceof type ? inst : factory(inst, type);
}

function ensureOfTypeBounds(inst, type, factory) {
  return inst instanceof type ? inst : factory(inst, type);
}

function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast());
  var sw = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest());

  if (ne && sw) {
    return {
      left: "".concat(sw.x + offset.x, "px"),
      top: "".concat(ne.y + offset.y, "px"),
      width: "".concat(ne.x - sw.x - offset.x, "px"),
      height: "".concat(sw.y - ne.y - offset.y, "px")
    };
  }

  return {
    left: '-9999px',
    top: '-9999px'
  };
}

function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(position);

  if (point) {
    var x = point.x,
        y = point.y;
    return {
      left: "".concat(x + offset.x, "px"),
      top: "".concat(y + offset.y, "px")
    };
  }

  return {
    left: '-9999px',
    top: '-9999px'
  };
}

function getLayoutStyles(mapCanvasProjection, offset, bounds, position) {
  return bounds !== undefined ? getLayoutStylesByBounds(mapCanvasProjection, offset, ensureOfTypeBounds(bounds, google.maps.LatLngBounds, createLatLngBounds)) : getLayoutStylesByPosition(mapCanvasProjection, offset, ensureOfType(position, google.maps.LatLng, createLatLng));
}

function arePositionsEqual(currentPosition, previousPosition) {
  return currentPosition.left === previousPosition.left && currentPosition.top === previousPosition.top && currentPosition.width === previousPosition.height && currentPosition.height === previousPosition.height;
}

function convertToLatLngString(latLngLike) {
  if (!latLngLike) {
    return '';
  }

  var latLng = latLngLike instanceof google.maps.LatLng ? latLngLike : new google.maps.LatLng(latLngLike.lat, latLngLike.lng);
  return latLng + '';
}

function convertToLatLngBoundsString(latLngBoundsLike) {
  if (!latLngBoundsLike) {
    return '';
  }

  var latLngBounds = latLngBoundsLike instanceof google.maps.LatLngBounds ? latLngBoundsLike : new google.maps.LatLngBounds(new google.maps.LatLng(latLngBoundsLike.south, latLngBoundsLike.east), new google.maps.LatLng(latLngBoundsLike.north, latLngBoundsLike.west));
  return latLngBounds + '';
}

var OverlayView = /*#__PURE__*/function (_PureComponent17) {
  _inherits(OverlayView, _PureComponent17);

  function OverlayView(props) {
    var _this32;

    _classCallCheck(this, OverlayView);

    _this32 = _possibleConstructorReturn(this, _getPrototypeOf(OverlayView).call(this, props));
    _this32.state = {
      paneEl: null,
      containerStyle: {
        // set initial position
        position: 'absolute'
      }
    };

    _this32.updatePane = function () {
      var mapPaneName = _this32.props.mapPaneName; // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes

      var mapPanes = _this32.overlayView.getPanes();

      invariant_1(!!mapPaneName, "OverlayView requires props.mapPaneName but got %s", mapPaneName);

      if (mapPanes) {
        _this32.setState({
          paneEl: mapPanes[mapPaneName]
        });
      } else {
        _this32.setState({
          paneEl: null
        });
      }
    };

    _this32.onAdd = function () {
      var _a, _b;

      _this32.updatePane();

      (_b = (_a = _this32.props).onLoad) === null || _b === void 0 ? void 0 : _b.call(_a, _this32.overlayView);
    };

    _this32.onPositionElement = function () {
      var mapCanvasProjection = _this32.overlayView.getProjection();

      var offset = Object.assign({
        x: 0,
        y: 0
      }, _this32.containerRef.current ? getOffsetOverride(_this32.containerRef.current, _this32.props.getPixelPositionOffset) : {});
      var layoutStyles = getLayoutStyles(mapCanvasProjection, offset, _this32.props.bounds, _this32.props.position);
      var _this32$state$contain = _this32.state.containerStyle,
          left = _this32$state$contain.left,
          top = _this32$state$contain.top,
          width = _this32$state$contain.width,
          height = _this32$state$contain.height;

      if (!arePositionsEqual(layoutStyles, {
        left: left,
        top: top,
        width: width,
        height: height
      })) {
        _this32.setState({
          containerStyle: Object.assign(Object.assign({}, layoutStyles), {
            position: 'absolute'
          })
        });
      }
    };

    _this32.draw = function () {
      _this32.onPositionElement();
    };

    _this32.onRemove = function () {
      var _a, _b;

      _this32.setState(function () {
        return {
          paneEl: null
        };
      }); // this.mapPaneEl = null


      (_b = (_a = _this32.props).onUnmount) === null || _b === void 0 ? void 0 : _b.call(_a, _this32.overlayView);
    };

    _this32.containerRef = createRef(); // You must implement three methods: onAdd(), draw(), and onRemove().

    var overlayView = new google.maps.OverlayView();
    overlayView.onAdd = _this32.onAdd;
    overlayView.draw = _this32.draw;
    overlayView.onRemove = _this32.onRemove;
    _this32.overlayView = overlayView;
    return _this32;
  }

  _createClass(OverlayView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // You must call setMap() with a valid Map object to trigger the call to
      // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
      // @ts-ignore
      this.overlayView.setMap(this.context);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevPositionString = convertToLatLngString(prevProps.position);
      var positionString = convertToLatLngString(this.props.position);
      var prevBoundsString = convertToLatLngBoundsString(prevProps.bounds);
      var boundsString = convertToLatLngBoundsString(this.props.bounds);

      if (prevPositionString !== positionString || prevBoundsString !== boundsString) {
        this.overlayView.draw();
      }

      if (prevProps.mapPaneName !== this.props.mapPaneName) {
        this.updatePane();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.overlayView.setMap(null);
    }
  }, {
    key: "render",
    value: function render() {
      var paneEl = this.state.paneEl;

      if (paneEl) {
        return ReactDOM.createPortal(jsxRuntime.exports.jsx("div", Object.assign({
          ref: this.containerRef,
          style: this.state.containerStyle
        }, {
          children: Children.only(this.props.children)
        })), paneEl);
      } else {
        return null;
      }
    }
  }]);

  return OverlayView;
}(PureComponent);

OverlayView.FLOAT_PANE = "floatPane";
OverlayView.MAP_PANE = "mapPane";
OverlayView.MARKER_LAYER = "markerLayer";
OverlayView.OVERLAY_LAYER = "overlayLayer";
OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget";
OverlayView.contextType = MapContext;

function noop() {
  return;
}

var eventMap$5 = {
  onDblClick: 'dblclick',
  onClick: 'click'
};
var updaterMap$5 = {
  opacity: function opacity(instance, _opacity2) {
    instance.setOpacity(_opacity2);
  }
};

var GroundOverlay = /*#__PURE__*/function (_PureComponent18) {
  _inherits(GroundOverlay, _PureComponent18);

  function GroundOverlay() {
    var _this33;

    _classCallCheck(this, GroundOverlay);

    _this33 = _possibleConstructorReturn(this, _getPrototypeOf(GroundOverlay).apply(this, arguments));
    _this33.registeredEvents = [];
    _this33.state = {
      groundOverlay: null
    };

    _this33.setGroundOverlayCallback = function () {
      if (_this33.state.groundOverlay !== null && _this33.props.onLoad) {
        _this33.props.onLoad(_this33.state.groundOverlay);
      }
    };

    return _this33;
  }

  _createClass(GroundOverlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1(!!this.props.url || !!this.props.bounds, "For GroundOverlay, url and bounds are passed in to constructor and are immutable after instantiated. This is the behavior of Google Maps JavaScript API v3 ( See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay) Hence, use the corresponding two props provided by `react-google-maps-api`, url and bounds. In some cases, you'll need the GroundOverlay component to reflect the changes of url and bounds. You can leverage the React's key property to remount the component. Typically, just `key={url}` would serve your need. See https://github.com/tomchentw/react-google-maps/issues/655");
      var groundOverlay = new google.maps.GroundOverlay(this.props.url, this.props.bounds, Object.assign(Object.assign({}, this.props.options), {
        // @ts-ignore
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$5,
        eventMap: eventMap$5,
        prevProps: {},
        nextProps: this.props,
        instance: groundOverlay
      });
      this.setState(function setGroundOverlay() {
        return {
          groundOverlay: groundOverlay
        };
      }, this.setGroundOverlayCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.groundOverlay !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$5,
          eventMap: eventMap$5,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.groundOverlay
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.groundOverlay) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.groundOverlay);
        }

        this.state.groundOverlay.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return GroundOverlay;
}(PureComponent);

GroundOverlay.defaultProps = {
  onLoad: noop
};
GroundOverlay.contextType = MapContext;
var eventMap$4 = {};
var updaterMap$4 = {
  data: function data(instance, _data) {
    instance.setData(_data);
  },
  map: function map(instance, _map7) {
    instance.setMap(_map7);
  },
  options: function options(instance, _options12) {
    instance.setOptions(_options12);
  }
};

var HeatmapLayer = /*#__PURE__*/function (_PureComponent19) {
  _inherits(HeatmapLayer, _PureComponent19);

  function HeatmapLayer() {
    var _this34;

    _classCallCheck(this, HeatmapLayer);

    _this34 = _possibleConstructorReturn(this, _getPrototypeOf(HeatmapLayer).apply(this, arguments));
    _this34.registeredEvents = [];
    _this34.state = {
      heatmapLayer: null
    };

    _this34.setHeatmapLayerCallback = function () {
      if (_this34.state.heatmapLayer !== null && _this34.props.onLoad) {
        _this34.props.onLoad(_this34.state.heatmapLayer);
      }
    };

    return _this34;
  }

  _createClass(HeatmapLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} to <LoadScript />? %s', google.maps.visualization);
      invariant_1(!!this.props.data, 'data property is required in HeatmapLayer %s', this.props.data);
      var heatmapLayer = new google.maps.visualization.HeatmapLayer(Object.assign(Object.assign({}, this.props.options || {}), {
        data: this.props.data,
        // @ts-ignore
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$4,
        eventMap: eventMap$4,
        prevProps: {},
        nextProps: this.props,
        instance: heatmapLayer
      });
      this.setState(function setHeatmapLayer() {
        return {
          heatmapLayer: heatmapLayer
        };
      }, this.setHeatmapLayerCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$4,
        eventMap: eventMap$4,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.heatmapLayer
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.heatmapLayer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.heatmapLayer);
        }

        unregisterEvents(this.registeredEvents);
        this.state.heatmapLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return HeatmapLayer;
}(PureComponent);

HeatmapLayer.contextType = MapContext;
var eventMap$3 = {
  onCloseClick: 'closeclick',
  onPanoChanged: 'pano_changed',
  onPositionChanged: 'position_changed',
  onPovChanged: 'pov_changed',
  onResize: 'resize',
  onStatusChanged: 'status_changed',
  onVisibleChanged: 'visible_changed',
  onZoomChanged: 'zoom_changed'
};
var updaterMap$3 = {
  register: function register(instance, provider, options) {
    instance.registerPanoProvider(provider, options);
  },
  links: function links(instance, _links) {
    instance.setLinks(_links);
  },
  motionTracking: function motionTracking(instance, _motionTracking) {
    instance.setMotionTracking(_motionTracking);
  },
  options: function options(instance, _options13) {
    instance.setOptions(_options13);
  },
  pano: function pano(instance, _pano) {
    instance.setPano(_pano);
  },
  position: function position(instance, _position5) {
    instance.setPosition(_position5);
  },
  pov: function pov(instance, _pov) {
    instance.setPov(_pov);
  },
  visible: function visible(instance, _visible7) {
    instance.setVisible(_visible7);
  },
  zoom: function zoom(instance, _zoom2) {
    instance.setZoom(_zoom2);
  }
};

var StreetViewPanorama = /*#__PURE__*/function (_PureComponent20) {
  _inherits(StreetViewPanorama, _PureComponent20);

  function StreetViewPanorama() {
    var _this35;

    _classCallCheck(this, StreetViewPanorama);

    _this35 = _possibleConstructorReturn(this, _getPrototypeOf(StreetViewPanorama).apply(this, arguments));
    _this35.registeredEvents = [];
    _this35.state = {
      streetViewPanorama: null
    };

    _this35.setStreetViewPanoramaCallback = function () {
      if (_this35.state.streetViewPanorama !== null && _this35.props.onLoad) {
        _this35.props.onLoad(_this35.state.streetViewPanorama);
      }
    };

    return _this35;
  }

  _createClass(StreetViewPanorama, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // @ts-ignore
      var streetViewPanorama = this.context.getStreetView();
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$3,
        eventMap: eventMap$3,
        prevProps: {},
        nextProps: this.props,
        instance: streetViewPanorama
      });
      this.setState(function () {
        return {
          streetViewPanorama: streetViewPanorama
        };
      }, this.setStreetViewPanoramaCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.streetViewPanorama !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$3,
          eventMap: eventMap$3,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.streetViewPanorama
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.streetViewPanorama !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.streetViewPanorama);
        }

        unregisterEvents(this.registeredEvents);
        this.state.streetViewPanorama.setVisible(false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return StreetViewPanorama;
}(PureComponent);

StreetViewPanorama.contextType = MapContext;

var StreetViewService = /*#__PURE__*/function (_PureComponent21) {
  _inherits(StreetViewService, _PureComponent21);

  function StreetViewService() {
    var _this36;

    _classCallCheck(this, StreetViewService);

    _this36 = _possibleConstructorReturn(this, _getPrototypeOf(StreetViewService).apply(this, arguments));
    _this36.state = {
      streetViewService: null
    };

    _this36.setStreetViewServiceCallback = function () {
      if (_this36.state.streetViewService !== null && _this36.props.onLoad) {
        _this36.props.onLoad(_this36.state.streetViewService);
      }
    };

    return _this36;
  }

  _createClass(StreetViewService, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var streetViewService = new google.maps.StreetViewService();
      this.setState(function setStreetViewService() {
        return {
          streetViewService: streetViewService
        };
      }, this.setStreetViewServiceCallback);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.streetViewService !== null && this.props.onUnmount) {
        this.props.onUnmount(this.state.streetViewService);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return StreetViewService;
}(PureComponent);

StreetViewService.contextType = MapContext;

var DirectionsService = /*#__PURE__*/function (_require$$0$PureCompo) {
  _inherits(DirectionsService, _require$$0$PureCompo);

  function DirectionsService() {
    var _this37;

    _classCallCheck(this, DirectionsService);

    _this37 = _possibleConstructorReturn(this, _getPrototypeOf(DirectionsService).apply(this, arguments));
    _this37.state = {
      directionsService: null
    };

    _this37.setDirectionsServiceCallback = function () {
      if (_this37.state.directionsService !== null && _this37.props.onLoad) {
        _this37.props.onLoad(_this37.state.directionsService);
      }
    };

    return _this37;
  }

  _createClass(DirectionsService, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1(!!this.props.options, 'DirectionsService expected options object as parameter, but got %s', this.props.options);
      var directionsService = new google.maps.DirectionsService();
      this.setState(function setDirectionsService() {
        return {
          directionsService: directionsService
        };
      }, this.setDirectionsServiceCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.directionsService !== null) {
        this.state.directionsService.route(this.props.options, this.props.callback);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.directionsService !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.directionsService);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return DirectionsService;
}(require$$0.PureComponent);

var eventMap$2 = {
  onDirectionsChanged: 'directions_changed'
};
var updaterMap$2 = {
  directions: function directions(instance, _directions) {
    instance.setDirections(_directions);
  },
  map: function map(instance, _map8) {
    instance.setMap(_map8);
  },
  options: function options(instance, _options14) {
    instance.setOptions(_options14);
  },
  panel: function panel(instance, _panel) {
    instance.setPanel(_panel);
  },
  routeIndex: function routeIndex(instance, _routeIndex) {
    instance.setRouteIndex(_routeIndex);
  }
};

var DirectionsRenderer = /*#__PURE__*/function (_PureComponent22) {
  _inherits(DirectionsRenderer, _PureComponent22);

  function DirectionsRenderer() {
    var _this38;

    _classCallCheck(this, DirectionsRenderer);

    _this38 = _possibleConstructorReturn(this, _getPrototypeOf(DirectionsRenderer).apply(this, arguments));
    _this38.registeredEvents = [];
    _this38.state = {
      directionsRenderer: null
    };

    _this38.setDirectionsRendererCallback = function () {
      if (_this38.state.directionsRenderer !== null) {
        // @ts-ignore
        _this38.state.directionsRenderer.setMap(_this38.context);

        if (_this38.props.onLoad) {
          _this38.props.onLoad(_this38.state.directionsRenderer);
        }
      }
    };

    return _this38;
  }

  _createClass(DirectionsRenderer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var directionsRenderer = new google.maps.DirectionsRenderer(this.props.options);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$2,
        eventMap: eventMap$2,
        prevProps: {},
        nextProps: this.props,
        instance: directionsRenderer
      });
      this.setState(function setDirectionsRenderer() {
        return {
          directionsRenderer: directionsRenderer
        };
      }, this.setDirectionsRendererCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.directionsRenderer !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$2,
          eventMap: eventMap$2,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.directionsRenderer
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.directionsRenderer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.directionsRenderer);
        }

        unregisterEvents(this.registeredEvents);

        if (this.state.directionsRenderer) {
          this.state.directionsRenderer.setMap(null);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {});
    }
  }]);

  return DirectionsRenderer;
}(PureComponent);

DirectionsRenderer.contextType = MapContext;

var DistanceMatrixService = /*#__PURE__*/function (_require$$0$PureCompo2) {
  _inherits(DistanceMatrixService, _require$$0$PureCompo2);

  function DistanceMatrixService() {
    var _this39;

    _classCallCheck(this, DistanceMatrixService);

    _this39 = _possibleConstructorReturn(this, _getPrototypeOf(DistanceMatrixService).apply(this, arguments));
    _this39.state = {
      distanceMatrixService: null
    };

    _this39.setDistanceMatrixServiceCallback = function () {
      if (_this39.state.distanceMatrixService !== null && _this39.props.onLoad) {
        _this39.props.onLoad(_this39.state.distanceMatrixService);
      }
    };

    return _this39;
  }

  _createClass(DistanceMatrixService, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1(!!this.props.options, 'DistanceMatrixService expected options object as parameter, but go %s', this.props.options);
      var distanceMatrixService = new google.maps.DistanceMatrixService();
      this.setState(function setDistanceMatrixService() {
        return {
          distanceMatrixService: distanceMatrixService
        };
      }, this.setDistanceMatrixServiceCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.distanceMatrixService !== null) {
        this.state.distanceMatrixService.getDistanceMatrix(this.props.options, this.props.callback);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.distanceMatrixService !== null && this.props.onUnmount) {
        this.props.onUnmount(this.state.distanceMatrixService);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return DistanceMatrixService;
}(require$$0.PureComponent);

var eventMap$1 = {
  onPlacesChanged: 'places_changed'
};
var updaterMap$1 = {
  bounds: function bounds(instance, _bounds2) {
    instance.setBounds(_bounds2);
  }
};

var StandaloneSearchBox = /*#__PURE__*/function (_PureComponent23) {
  _inherits(StandaloneSearchBox, _PureComponent23);

  function StandaloneSearchBox() {
    var _this40;

    _classCallCheck(this, StandaloneSearchBox);

    _this40 = _possibleConstructorReturn(this, _getPrototypeOf(StandaloneSearchBox).apply(this, arguments));
    _this40.registeredEvents = [];
    _this40.containerElement = createRef();
    _this40.state = {
      searchBox: null
    };

    _this40.setSearchBoxCallback = function () {
      if (_this40.state.searchBox !== null && _this40.props.onLoad) {
        _this40.props.onLoad(_this40.state.searchBox);
      }
    };

    return _this40;
  }

  _createClass(StandaloneSearchBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);

      if (this.containerElement !== null && this.containerElement.current !== null) {
        var input = this.containerElement.current.querySelector('input');

        if (input !== null) {
          var searchBox = new google.maps.places.SearchBox(input, this.props.options);
          this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$1,
            eventMap: eventMap$1,
            prevProps: {},
            nextProps: this.props,
            instance: searchBox
          });
          this.setState(function setSearchBox() {
            return {
              searchBox: searchBox
            };
          }, this.setSearchBoxCallback);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.searchBox !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$1,
          eventMap: eventMap$1,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.searchBox
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.searchBox !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.searchBox);
        }

        unregisterEvents(this.registeredEvents);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsx("div", Object.assign({
        ref: this.containerElement
      }, {
        children: Children.only(this.props.children)
      }));
    }
  }]);

  return StandaloneSearchBox;
}(PureComponent);

StandaloneSearchBox.contextType = MapContext;
var eventMap = {
  onPlaceChanged: 'place_changed'
};
var updaterMap = {
  bounds: function bounds(instance, _bounds3) {
    instance.setBounds(_bounds3);
  },
  restrictions: function restrictions(instance, _restrictions) {
    instance.setComponentRestrictions(_restrictions);
  },
  fields: function fields(instance, _fields) {
    instance.setFields(_fields);
  },
  options: function options(instance, _options15) {
    instance.setOptions(_options15);
  },
  types: function types(instance, _types) {
    instance.setTypes(_types);
  }
};

var Autocomplete = /*#__PURE__*/function (_PureComponent24) {
  _inherits(Autocomplete, _PureComponent24);

  function Autocomplete() {
    var _this41;

    _classCallCheck(this, Autocomplete);

    _this41 = _possibleConstructorReturn(this, _getPrototypeOf(Autocomplete).apply(this, arguments));
    _this41.registeredEvents = [];
    _this41.containerElement = createRef();
    _this41.state = {
      autocomplete: null
    };

    _this41.setAutocompleteCallback = function () {
      if (_this41.state.autocomplete !== null && _this41.props.onLoad) {
        _this41.props.onLoad(_this41.state.autocomplete);
      }
    };

    return _this41;
  }

  _createClass(Autocomplete, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places); // TODO: why current could be equal null?
      // @ts-ignore

      var input = this.containerElement.current.querySelector('input');

      if (input) {
        var autocomplete = new google.maps.places.Autocomplete(input, this.props.options);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap,
          eventMap: eventMap,
          prevProps: {},
          nextProps: this.props,
          instance: autocomplete
        });
        this.setState(function () {
          return {
            autocomplete: autocomplete
          };
        }, this.setAutocompleteCallback);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap,
        eventMap: eventMap,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.autocomplete
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.autocomplete !== null) {
        unregisterEvents(this.registeredEvents);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsx("div", Object.assign({
        ref: this.containerElement,
        className: this.props.className
      }, {
        children: Children.only(this.props.children)
      }));
    }
  }]);

  return Autocomplete;
}(PureComponent);

Autocomplete.defaultProps = {
  className: ''
};
Autocomplete.contextType = MapContext;
export { Autocomplete, BicyclingLayer, BicyclingLayerF, Circle, CircleF, Data, DataF, DirectionsRenderer, DirectionsService, DistanceMatrixService, DrawingManager, DrawingManagerF, GoogleMap, index_esm as GoogleMapsMarkerClusterer, GoogleMarkerClusterer$1 as GoogleMarkerClusterer, GroundOverlay, HeatmapLayer, InfoBoxComponent as InfoBox, InfoBoxF, InfoWindow, InfoWindowF, KmlLayer, LoadScript, LoadScriptNext$1 as LoadScriptNext, MapContext, Marker, ClustererComponent as MarkerClusterer, MarkerF, OverlayView, Polygon, PolygonF, Polyline, PolylineF, Rectangle, RectangleF, StandaloneSearchBox, StreetViewPanorama, StreetViewService, TrafficLayer, TrafficLayerF, TransitLayer, TransitLayerF, useGoogleMap, useJsApiLoader, useLoadScript };